(function() {
    'use strict';

    angular.module('public.auction', []);
})();

(function() {
    'use strict';

    angular
        .module('public.auction')
        .controller('ItemController', ItemController);

    function ItemController($state, $log, $scope, $rootScope, $filter, $stateParams, itemRepository, bidRepository, auctionRepository, authService,
        emailService, formsService, modalService, Notification, flashService, metaTagsService) {
        var vm = this;

        // ViewModel Properties
        vm.activePanel = -1;
        vm.bid = {};
        vm.bidForm = {};
        vm.bidFormByPhone={};
        vm.isEdit = false;
        vm.isEditByPhone = false;
        vm.isLogin = false;
        vm.isSignup = false;
        vm.item = {
            featuredImagesUrls: [],
            isBiddable: ''
        };
        vm.prevItem = null;
        vm.nextItem = null;
        vm.auction = {
            isPast: null,
            isLive: null
        };


        // ViewModel Methods
        vm.isAuthenticated = authService.isAuthenticated;
        vm.isEmail = emailService.isEmail;
        vm.isEmailUnique = emailService.isEmailUnique;
        vm.onBackClick = handleBackClick;
        vm.onCancel = handleCancel;
        vm.onCancelByPhone = handleCancelByPhone;
        vm.onEdit = handleEdit;
        vm.onLoginClick = handleLoginClick;
        vm.onSignupClick = handleSignupClick;
        vm.onSubmitBid = handleSubmitBid;
        vm.onSubmitBidByPhone = handleSubmitBidByPhone;
        vm.onGoto = handleGotoItem;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        // Event listeners
        $scope.$on('UserUpdate', getBid);

        (function init() {
            $scope.isDataLoading = false;
            getItem();
        })();


        // Private Properties
        var params;

        // Private Methods
        // getBid
        function getBid() {
            return bidRepository.listMyBids($rootScope.currentUser.email)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    $log.debug('vm.bid:\n', vm.bid);

                    var myBid = response.filter(function(bid) {
                        return bid.item.id === vm.item._id;
                    }).pop();

                    if (myBid) {
                        vm.isEdit = true;
                        vm.isEditByPhone = true;

                        vm.bid._id = myBid._id;
                        vm.bid.bidamount = myBid.bidamount;
                        vm.bid.lot = myBid.lot;
                        vm.bid.message = myBid.message;
                        vm.bid.phone = $filter('phoneUS')($rootScope.currentUser.phone);
                        vm.bid.phoneBid = myBid.phoneBid;

                        // fixme: errors out if item has been sold
                        //formsService.refresh(vm.bidForm);
                    }
                    else {
                        vm.isEdit = false;
                        vm.isEditByPhone = false;

                    }

                    $log.debug('ItemController.getBid-success:\n', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('ItemController.getBid-error:\n', error);
                    Notification.error('There was an error loading the bid.');
                });
        }

        // getItem
        function getItem() {
            $scope.isDataLoading = true;

            $log.debug('$stateParams.itemSlug', $stateParams.itemSlug);

            params = {
                slug: $stateParams.itemSlug,
                withPrevNext: true,
            };

            return itemRepository.list(params)
                .then(function(response) {
                    $log.debug('ItemController.getItem-success:\n', response);

                    var item = response.item;

                    vm.item = item;

                    // add the main image to the array
                    if (vm.item.itemImageUrl) {
                        // rm if clause when no need to show old items with image dublicates
                        var firstImage = vm.item.featuredImagesUrls[0];

                        if (!firstImage || firstImage.xs !== vm.item.itemImageUrl) {
                            var itemImageObj = {
                                xs: vm.item.itemImageUrl,
                                sm: vm.item.itemImageUrl,
                                md: vm.item.itemImageUrl,
                                lg: vm.item.itemImageUrl
                            };

                            vm.item.featuredImagesUrls.unshift(itemImageObj);
                        }
                    }

                    vm.prevItem = response.prevItem;
                    vm.nextItem = response.nextItem;

                    metaTagsService.setMetaTag(vm.item);

                    // if user is authenticated
                    if (vm.isAuthenticated()) {
                        getBid();
                    }
                    else {
                        $scope.isDataLoading = false;
                    }

                    $log.debug('vm.item:\n', vm.item);


                    getAuction();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('ItemController.getItem-error:\n', error);
                    Notification.error('There was an error loading the item.');
                });
        }

        function getAuction() {
            $scope.isDataLoading = true;

            params = {
                slug: $stateParams.auctionSlug,
            };

            return auctionRepository.list(params)
                .then(function(response) {
                    $scope.isDataLoading = false;
                    vm.auction = response;

                    // check how much time before auction start
                    var timesBefore = vm.auction.startDates.map(function(date) {
                        return moment(date).diff(moment(), 'minutes');
                    });
                    //$log.error('timeBefore:\n', timeBefore);

                    // auction isPast after 8 hours
                    vm.auction.isPast = false;
                    vm.auction.isLive = false;

                    if (timesBefore.every(function(time) {
                        return time < -480;
                    })) {
                        vm.auction.isPast = true;
                    }
                    else if (timesBefore.some(function(time) {
                        return time < 60;
                    })) {
                        vm.auction.isLive = true;
                    }

                    $log.debug('AuctionDetailController.getAuction-success:\n', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;
                    $log.error('AuctionDetailController.getAuction-error:\n', error);
                    Notification.error('There was an error loading the auction.');
                });
        }

        function handleGotoItem(item) {
            var params = {
                auctionSlug: $stateParams.auctionSlug,
                itemSlug: item.meta.slug
            };

            $state.go('auction-item', params);
        }

        // handleCancel
        function handleCancel() {
            if (confirm('Are you sure you want to cancel your bid?')) {
                $scope.isDataLoading = true;

                return bidRepository.deleteOneBid(vm.bid._id, vm.item._id)
                    .then(function(response) {
                        $scope.isDataLoading = false;

                        modalService.hide();

                        $log.debug('ItemController.handleCancel-success:', response);
                        Notification.success('Bid deleted.');
                    })
                    .catch(function(error) {
                        $scope.isDataLoading = false;

                        $log.error('ItemController.handleCancel-error:', error);
                        flashService.error('There was an error deleting the bid.');
                    });
            }
        }

        // handleCancelByPhone
        function handleCancelByPhone() {
            if (confirm('Are you sure you want to cancel your phone request?')) {
                $scope.isDataLoading = true;

                return bidRepository.deleteOneBid(vm.bid._id, vm.item._id)
                    .then(function(response) {
                        $scope.isDataLoading = false;

                        modalService.hide();

                        $log.debug('ItemController.handleCancelByPhone-success:', response);
                        Notification.success('Your phone request was cancelled.');
                    })
                    .catch(function(error) {
                        $scope.isDataLoading = false;

                        $log.error('ItemController.handleCancelByPhone-error:', error);
                        flashService.error('There was an error cancelling the phone request.');
                    });
            }
        }

        // handleEdit
        function handleEdit() {
            $scope.isDataLoading = true;

            // user's info
            vm.bid.email = $rootScope.currentUser.email;
            vm.bid.name = $filter('ucfirst')($rootScope.currentUser.name.first + ' ' + $rootScope.currentUser.name.last);
            vm.bid.phone = $filter('phoneUS')($rootScope.currentUser.phone);

            var bid = angular.copy(vm.bid);
            delete bid._id;

            return bidRepository.update(vm.bid._id, bid)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    modalService.hide();

                    $log.debug('ItemController.handleEdit-success:', response);
                    Notification.success('Bid updated!');
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('ItemController.handleEdit-error:', error);
                    flashService.error('There was an error updating the bid.');
                });
        }

        // handleBackClick
        function handleBackClick() {
            flashService.clear();
            vm.isLogin = vm.isSignup = false;
        }

        // handleLoginClick
        function handleLoginClick() {
            vm.isLogin = true;
        }

        // handleSignupClick
        function handleSignupClick() {
            vm.isSignup = true;
        }

        // handleSubmitBid
        function handleSubmitBid() {
            $scope.isDataLoading = true;

            // user's info
            vm.bid.lot = vm.item.lot;
            vm.bid.email = $rootScope.currentUser.email;
            vm.bid.name = $filter('ucfirst')($rootScope.currentUser.name.first + ' ' + $rootScope.currentUser.name.last);
            vm.bid.phone = $filter('phoneUS')($rootScope.currentUser.phone);

            return itemRepository.bid(vm.item._id, vm.bid)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    modalService.hide();

                    $log.debug('ItemController.handleSubmit-success:', response);
                    Notification.success('Bid submitted!');
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('ItemController.handleSubmit-error:', error);
                    flashService.error('There was an error creating the bid.');
                });
        }

        // handleSubmitBidByPhone
        function handleSubmitBidByPhone() {
            $scope.isDataLoading = true;

            $log.debug('vm.bid', vm.bid);


            // user's info
            vm.bid.lot = vm.item.lot;
            vm.bid.name = $filter('ucfirst')($rootScope.currentUser.name.first + ' ' + $rootScope.currentUser.name.last);
            vm.bid.phone = $filter('phoneUS')($rootScope.currentUser.phone);
            vm.bid.email = $rootScope.currentUser.email;
            vm.bid.bidamount = 0;
            vm.bid.phoneBid = true;
            vm.bid.message = "CALL CUSTOMER BY PHONE";

            return itemRepository.bid(vm.item._id, vm.bid)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    modalService.hide();

                    $log.debug('ItemController.handleSubmit-success:', response);
                    Notification.success('Phone bid submitted!');
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('ItemController.handleSubmit-error:', error);
                    flashService.error('There was an error creating the call request.');
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('public.auction').controller('AuctionDetailController', AuctionDetailController);

    function AuctionDetailController($log, $scope, $location, $state, $stateParams, $sce, auctionRepository, itemRepository, formsService, metaTagsService, Notification) {
        var vm = this;
        var footer = angular.element(document).find('footer');

        // ViewModel Properties
        vm.auction = {};
        vm.items = [];
        vm.searching = false;
        vm.social = [
            // 'facebook',
            // 'twitter',
        ];

        // ViewModel Methods
        vm.getAuctionItems = getAuctionItems;
        vm.onImageClick = handleImageClick;
        vm.clearSearch = handleClearSearch;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;
        $scope.$destroy = handleDestroy;

        (function init() {
            $scope.isDataLoading = false;

            getAuction();
        })();

        // Private Properties
        var params;
        var page = 1;
        var pagesMax = 100;
        var options;

        // Private Methods
        // getAuction
        function getAuction() {
            $scope.isDataLoading = true;

            params = {
                slug: $stateParams.auctionSlug
            };

            return auctionRepository
                .list(params)
                .then(function (response) {
                    $scope.isDataLoading = false;

                    if (response.state !== 'published') {
                        $state.go('auction');
                        return;
                    }

                    vm.auction = response;
                    vm.auction.body = $sce.trustAsHtml(vm.auction.body);

                    // check how much time before auction start
                    var timesBefore = vm.auction.startDates.map(function (date) {
                        return moment(date).diff(moment(), 'minutes');
                    });
                    //$log.error('timeBefore:\n', timeBefore);

                    // auction isPast after 8 hours
                    if (
                        timesBefore.length > 0 &&
                        timesBefore.every(function (time) {
                            return time < -480;
                        })
                    ) {
                        vm.auction.isPast = true;
                    } else if (
                        timesBefore.some(function (time) {
                            return time < 60;
                        })
                    ) {
                        vm.auction.isLive = true;
                    }

                    metaTagsService.setMetaTag(vm.auction);

                    // now lets get auction items
                    getAuctionItems();

                    $log.debug('AuctionDetailController.getAuction-success:\n', response);
                })
                .catch(function (error) {
                    $scope.isDataLoading = false;

                    $log.error('AuctionDetailController.getAuction-error:\n', error);
                    Notification.error('There was an error loading the auction.');
                });
        }

        $scope.$watch('vm.search', function () {
            page = 1;
            vm.items.length = 0;
            // $log.debug('vm.items:\n', vm.items);
            // $log.debug('vm.items:\n', vm.items);

            getAuctionItems();
        });

        // getAuctionItems
        function getAuctionItems() {
            if (!$scope.isDataLoading && page <= pagesMax) {
                $scope.isDataLoading = true;

                params = {
                    event: vm.auction._id,
                    sort: 'position',
                    page: page,
                    limit: $location.search().limit
                };

                if (vm.search) {
                    $log.debug('searching');
                    vm.searching = true;
                    params.search = vm.search;
                }

                //var documentHeight = (page !== 1) ? ($('.site-content').height() + 170) : 0;

                return itemRepository
                    .list(params)
                    .then(function (response) {
                        $scope.isDataLoading = false;

                        page++;
                        pagesMax = response.pages.total || 1;
                        footer.css('display', pagesMax > page ? 'none' : 'block');

                        response.data
                            .filter(function (item) {
                                return item.lot && item.title && item.meta && item.itemImageUrl;
                            })
                            .map(function (item) {
                                params = {
                                    itemSlug: item.meta.slug
                                };
                                options = {
                                    absolute: true
                                };

                                item.url = $state.href('auction-item', params, options);
                                vm.items.push(item);

                                return item;
                            });
                        $log.debug('vm.items:\n', vm.items);

                        // scroll to the top of a new items
                        //$('html, body').animate({'scrollTop': documentHeight}, 1000);
                    })
                    .catch(function (error) {
                        $scope.isDataLoading = false;

                        $log.error('AuctionDetailController.getAuctionItems-error:\n', error);
                        Notification.error('There was an error loading the items.');
                    });
            }
        }

        // handleDestroy
        function handleDestroy() {
            footer.css('display', 'block');
        }

        // handleClearSearch
        function handleClearSearch() {
            vm.search = '';
        }

        // handleImageClick
        function handleImageClick(item) {
            // copy properties from auction object
            item.isPast = vm.auction.isPast || false;
            item.isLive = vm.auction.isLive || false;

            params = {
                item: item
            };

            $state.go('photos', params);
        }
    }
})();

(function() {
    'use strict';

    angular.module('public.about', []);
})();

(function() {
    'use strict';

    angular
        .module('public.about')
        .controller('TeamController', TeamController);

    function TeamController($filter, $stateParams, metaTagsService) {
        var vm = this;

        // ViewModel Properties
        vm.person = $stateParams.person;
        metaTagsService.setMetaTag(vm.person);

        if (vm.person.phone) {
            vm.person.phone = $filter('phoneUS')(vm.person.phone);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility', []);
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('usernameService', usernameService);

    function usernameService($q, $http, $log, API) {
        return {
            isUsernameValid: isUsernameValid,
            isUsernameUnique: isUsernameUnique,
        };

        // isUsernameValid
        function isUsernameValid(username) {
            var regexp = /^[\S]*$/;
            return regexp.test(username);
        }

        // isUsernameUnique
        function isUsernameUnique(username, originalUsername) {
            return $q(function(resolve, reject) {
                if (originalUsername && username.toLowerCase() === originalUsername.toLowerCase()) {
                    resolve();
                }
                else {
                    return $http.get(API.BASE_URL + 'api/username/check/' + username, {})
                        .then(function(response) {
                            $log.debug('usernameService.isUsernameUnique-success:\n', response);
                            resolve();
                        })
                        .catch(function(error) {
                            $log.error('usernameService.isUsernameUnique-error:\n', error);
                            reject();
                        });
                }
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.services.utility")
        .factory("taxonomyService", taxonomyService);

    function taxonomyService($log, specialtiesRepository) {
        return {
            filter: filterWithSpecialty,
            group: groupCategories,
        };

        // filterWithSpecialty
        function filterWithSpecialty(categories) {
            return specialtiesRepository
                .list()
                .then(function (response) {
                    $log.debug(
                        "MainController.filterWithSpecialty-success:\n",
                        response
                    );

                    var catsIds = response.data.map(function (item) {
                        return item.categories.map(function (o) {
                            return o.id;
                        });
                    });

                    var uniqCatsIds = _.uniq(_.flatten(catsIds));

                    return categories.filter(function (category) {
                        return uniqCatsIds.includes(category._id);
                    });
                })
                .catch(function (error) {
                    $log.error(
                        "MainController.filterWithSpecialty-error:\n",
                        error
                    );
                    Notification.error(
                        "There was an error loading Specialties."
                    );
                });
        }

        // groupCategories
        function groupCategories(categories) {
            var rootKey = "root";

            var groupedByParents = _.groupBy(categories, function (item) {
                return !item.parentId ? rootKey : item.parentId;
            });

            var catsById = _.keyBy(categories, "_id");
            var omitted = _.omit(groupedByParents, rootKey);

            _.each(omitted, function (children, parentId) {
                catsById[parentId].children = children;
            });
            _.each(catsById, function (cat) {
                cat.isParent = !_.isEmpty(cat.children);
                cat.children = _.compact(_.union(cat.children, cat.posts));
            });

            var catsWithLevel = _.map(
                groupedByParents[rootKey],
                function (item) {
                    return assignDeepLevel(item, 0);
                }
            );

            sortByWeight(catsWithLevel);

            return catsWithLevel;
        }

        // sortByWeight
        function sortByWeight(items) {
            _.each(items, function (item) {
                item.weight = item.weight ? item.weight : 0;
                if (_.isEmpty(item.children)) {
                    return undefined;
                }
                sortByWeight(item.children);
            });

            items.sort(function (a, b) {
                return a.weight > b.weight;
            });
        }

        // assignDeepLevel
        function assignDeepLevel(item, level) {
            _.assign(item, {
                level: level,
            });

            if (_.isEmpty(item.children)) {
                return item;
            }

            return _.assign(item, {
                children: _.map(item.children, function (nested) {
                    return assignDeepLevel(nested, level + 1);
                }),
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('responseInterceptorService', responseInterceptorService);

    function responseInterceptorService($rootScope, $q, $log, $injector) {
        return {
            responseError: responseError,
        };

        function responseError(response) {
            // HANDLE 404s
            // if (response.status === 404) {
            //     $injector.get('$state').go('404server');
            // }

            /* If not a 404, do nothing with this error.
             * This is necessary to make a `responseError`
             * interceptor a no-op. */
            return $q.reject(response);
        }
    };
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('passService', passService);

    function passService($q) {
        return {
            isPasswordConfirmed: isPasswordConfirmed,
            isPasswordStrong: isPasswordStrong,
        };

        // isPasswordConfirmed
        function isPasswordConfirmed(passwordConfirmation, password) {
            return $q(function(resolve, reject) {
                if (passwordConfirmation === password) {
                    resolve();
                }
                else {
                    reject();
                }
            });
        }

        // isPasswordStrong
        function isPasswordStrong(password) {
            var regexp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/;
            return regexp.test(password);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('formsService', formsService);

    function formsService($log) {
        return {
            canSave: canSave,
            changeOutside: changeOutside,
            getDropdownOption: getDropdownOption,
            hasError: hasError,
            refresh: refresh,
            showError: showError,
            showErrorOnSubmit: showErrorOnSubmit,
        };

        // Notifications
        function canSave(ngFormCtrl) {
            if (ngFormCtrl) {
                return ngFormCtrl.$dirty && ngFormCtrl.$valid;
            }
        }
        function changeOutside(ngFormCtrl) {
            if (ngFormCtrl) {
                ngFormCtrl.$setDirty();
            }
        }
        function hasError(ngModelCtrl) {
            if (ngModelCtrl) {
                return ngModelCtrl.$dirty && ngModelCtrl.$invalid;
            }
        }
        function refresh(ngFormCtrl) {
            if (ngFormCtrl) {
                ngFormCtrl.$setPristine();
                ngFormCtrl.$setUntouched();
            }
        }
        function showError(ngModelCtrl, err) {
            if (ngModelCtrl) {
                return ngModelCtrl.$dirty && ngModelCtrl.$error[err];
            }
        }
        function showErrorOnSubmit(formCtrl, ngModelCtrl, err) {
            if (ngModelCtrl) {
                return ngModelCtrl.$dirty && ngModelCtrl.$error[err] && formCtrl.$submitted;
            }
        }

        // Form Elements
        /*
         * Returns the exact option object so that the option is reflected in the view
         * @param currentOption
         * @param options
         * @returns {*}
         */
        function getDropdownOption(currentOption, options) {
            if (options) {
                if (!currentOption || !currentOption._id) {
                    currentOption = options[0];
                }
                else {
                    currentOption = options.find(function(option) {
                        return option._id === currentOption._id;
                    });
                }
            }
            return currentOption;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('flashService', flashService);

    function flashService($log, $rootScope) {
        initService();

        return {
            clear: clearFlashMessage,
            error: error,
            info: info,
            success: success,
            warning: warning,
        };

        // initService
        function initService() {
            $rootScope.$on('$stateChangeStart', function() {
                clearFlashMessage();
            });
        }

        // clearFlashMessage
        function clearFlashMessage() {
            var flash = $rootScope.flash;

            if (flash) {
                if (!flash.keepAfterLocationChange) {
                    delete $rootScope.flash;
                }
                else {
                    // only keep for a single location change
                    flash.keepAfterLocationChange = false;
                }
            }
        }

        // error
        function error(message, keepAfterLocationChange) {
            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'danger',
                keepAfterLocationChange: keepAfterLocationChange,
            };
        }

        // info
        function info(message, keepAfterLocationChange) {
            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'info',
                keepAfterLocationChange: keepAfterLocationChange,
            };
        }

        // success
        function success(message, keepAfterLocationChange) {
            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'success',
                keepAfterLocationChange: keepAfterLocationChange,
            };
        }

        // warning
        function warning(message, keepAfterLocationChange) {
            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'warning',
                keepAfterLocationChange: keepAfterLocationChange,
            };
        }
    }
})();

// This Service is used for Global Event Broadcasting

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('errorResponseService', errorResponseService);

    function errorResponseService() {
        var service = {};

        service.getErrorMessage = getErrorMessage;

        return service;

        function parseMessage(response) {
            var extracted = /\[(.*?)\]/.exec(response.message);
            if (!extracted || !extracted[1]) {
                return response.message;
            }
            var message = extracted[1].replace(/"/g, '');
            return message.charAt(0).toUpperCase() + message.slice(1);
        }

        function prettifyFieldName(message) {
            var spacePos = message.indexOf(' ');
            if (spacePos === -1) {
                return message;
            }
            var fieldName = message.substr(0, spacePos);
            var prettyFieldName = fieldName.match(/[A-Z][a-z]+/g).join(' ');
            return prettyFieldName + message.substr(spacePos);
        }

        function getErrorMessage(response, defaultMessage) {
            if (!response.validation) {
                // unrecognized, no-validation error
                return defaultMessage;
            }
            return prettifyFieldName(parseMessage(response));
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('emailService', emailService);

    function emailService($log, $q, authService) {
        return {
            isEmail: isEmail,
            isEmailUnique: isEmailUnique,
        };

        // isEmail
        function isEmail(email) {
            var regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexp.test(email);
        }

        // isEmailUnique
        function isEmailUnique(email, originalEmail) {
            return $q(function(resolve, reject) {
                if (originalEmail && email === originalEmail) {
                    resolve();
                }
                else {
                    authService.checkEmail(email)
                        .then(function(result) {
                            if (result.data.length > 0) {
                                reject();
                            }
                            else {
                                resolve();
                            }
                        })
                        .catch(function(error) {
                            $log.error('emailService.isEmailUnique-error:\n', error);
                            reject();
                        });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('apiHelperService', apiHelperService);

    function apiHelperService($log, $http, API, ENV_VARS) {
        return {
            delete: _delete,
            get: _get,
            post: _post,
            put: _put,
            sendHTTPRequest: sendHTTPRequest,
        };

        function sendHTTPRequest(req) {
            if (req.method === 'GET' && ENV_VARS && ENV_VARS.s3BucketDomain && ENV_VARS.cdnDomain) {
                req.url.replace(ENV_VARS.s3BucketDomain, ENV_VARS.cdnDomain);
            }

            return $http(req)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    throw error.data;
                });
        }

        function _delete(url, payload) {
            return $http({
                data: payload,
                method: 'DELETE',
                url: API.BASE_URL + url,
            })
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    throw error.data;
                });
        }

        function _get(url, params) {
            return $http({
                method: 'GET',
                params: params,
                url: API.BASE_URL + url,
            })
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    throw error.data;
                });
        }

        function _post(url, payload) {
            return $http({
                data: payload,
                method: 'POST',
                url: API.BASE_URL + url,
            })
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    throw error.data;
                });
        }

        function _put(url, payload) {
            return $http({
                data: payload,
                method: 'PUT',
                url: API.BASE_URL + url,
            })
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    throw error.data;
                });
        }
    }
})();

'use strict';


/**
 * This service generates all the CRUD and Association methods for a model entity. Refer to the repositories directory
 * for implementation examples.
 */
angular.module('app.services.utility')
    .factory('restfulResourceHelper', function($log, apiHelperService) {
        return {
            /*
             * Generate the CRUD methods for a model entity.
             * @param resourceRoute: The API route for the model entity.
             */
            generateCrudCallers: function(resourceRoute) {
                return {
                    list: this.generateListCaller(resourceRoute),
                    find: this.generateFindCaller(resourceRoute),
                    update: this.generateUpdateCaller(resourceRoute),
                    create: this.generateCreateCaller(resourceRoute),
                    deleteOne: this.generateDeleteOneCaller(resourceRoute),
                    deleteMany: this.generateDeleteManyCaller(resourceRoute),
                };
            },
            generateListCaller: function(resourceRoute) {
                return function(params) {
                    //$log.debug(resourceRoute + '.list + params: ', params);

                    return apiHelperService.get(resourceRoute, params)
                        .then(function(response) {
                            //$log.debug(resourceRoute + '.list response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            //$log.error(resourceRoute + '.list error:\n', error);
                            throw error;
                        });
                };
            },
            generateFindCaller: function(resourceRoute) {
                return function(_id, params) {
                    //$log.debug(resourceRoute + '.find + _id: ', _id, ', params: ', params);

                    return apiHelperService.get(resourceRoute + '/' + _id, params)
                        .then(function(response) {
                            //$log.debug(resourceRoute + '.find response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            //$log.error(resourceRoute + '.find error:\n', error);
                            throw error;
                        });
                };
            },
            generateUpdateCaller: function(resourceRoute) {
                return function(_id, payload) {
                    delete payload.createdAt;
                    delete payload.updatedAt;
                    delete payload.isDeleted;
                    $log.debug(resourceRoute + '.update + _id: ', _id, ', payload: ', payload);

                    return apiHelperService.put(resourceRoute + '/' + _id, payload)
                        .then(function(response) {
                            $log.debug(resourceRoute + '.update response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(resourceRoute + '.update error:\n', error);
                            throw error;
                        });
                };
            },
            generateCreateCaller: function(resourceRoute) {
                return function(payload) {
                    $log.debug(resourceRoute + '.create + payload: ', payload);

                    return apiHelperService.post(resourceRoute, payload)
                        .then(function(response) {
                            $log.debug(resourceRoute + '.create response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(resourceRoute + '.create error:\n', error);
                            throw error;
                        });
                };
            },
            generateDeleteOneCaller: function(resourceRoute) {
                return function(_id) {
                    $log.debug(resourceRoute + '.deleteOne + _id: ', _id);

                    return apiHelperService.delete(resourceRoute + '/' + _id)
                        .then(function(response) {
                            $log.debug(resourceRoute + '.delete response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.debug(resourceRoute + '.delete error:\n', error);
                            throw error;
                        });
                };
            },
            generateDeleteManyCaller: function(resourceRoute) {
                return function(payload) {
                    $log.debug(resourceRoute + '.deleteMany + payload', payload);

                    return apiHelperService.delete(resourceRoute, payload)
                        .then(function(response) {
                            $log.debug(resourceRoute + '.delete response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.debug(resourceRoute + '.delete error:\n', error);
                            throw error;
                        });
                };
            },
            /*
             * Generate the association methods for a model entity. The parameters are explained below with examples
             * using the context of a user and their shopping cart items.
             * @param ownerRoute: The API route for the owner model,                    Ex: user
             * @param associationName: The name of the association for the owner model, Ex: shoppingCartItems
             * @param associationRoute: The API route for the association,              Ex: cart-item
             * @param childName: The name of the child/association model,               Ex: storeItem
             *
             * The generated methods will correspond with the following routes:
             *
             * DELETE /user/{ownerId}/cart-item             Remove multiple storeItems from a user's list of shoppingCartItems
             * GET /user/{ownerId}/cart-item                Get all of the storeItems for a user
             * POST /user/{ownerId}/cart-item               Add multiple storeItems to a user's list of shoppingCartItems
             * DELETE /user/{ownerId}/cart-item/{childId}   Remove a single storeItem from a user's list of shoppingCartItems
             * PUT /user/{ownerId}/cart-item/{childId}      Add a single storeItem to a user's list of shoppingCartItems
             */
            generateAssociationCallers: function(ownerRoute, associationName, associationRoute, childName) {
                var resourceMethodName = associationName[0].toUpperCase() + associationName.slice(1);
                var callers = {};
                callers['get' + resourceMethodName] = this.generateGetAssociationsAssociationCaller(ownerRoute, associationRoute, resourceMethodName);
                callers['addOne' + resourceMethodName] = this.generateAddOneAssociationCaller(ownerRoute, associationRoute, resourceMethodName);
                callers['removeOne' + resourceMethodName] = this.generateRemoveOneAssociationCaller(ownerRoute, associationRoute, resourceMethodName);
                callers['addMany' + resourceMethodName] = this.generateAddManyAssociationCaller(ownerRoute, associationRoute, resourceMethodName);
                callers['removeMany' + resourceMethodName] = this.generateRemoveManyAssociationCaller(ownerRoute, associationRoute, resourceMethodName);

                callers['flatten' + resourceMethodName] = this.generateFlattenAssociationData(associationName, childName);
                return callers;
            },
            generateGetAssociationsAssociationCaller: function(ownerRoute, associationRoute, resourceMethodName) {
                return function(ownerId, params) {
                    var methodName = ownerRoute + '.get' + resourceMethodName;
                    $log.debug(methodName + ' + ownerId: ', ownerId, ', params: ', params);

                    if (!params) {
                        params = {
                            isDeleted: false
                        };
                    }
                    else if (!params.isDeleted) {
                        params.isDeleted = false;
                    }

                    return apiHelperService.get(ownerRoute + '/' + ownerId + '/' + associationRoute, params)
                        .then(function(response) {
                            $log.debug(methodName + ' response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(methodName + ' error:\n', error);
                            throw error;
                        });
                };
            },
            generateAddOneAssociationCaller: function(ownerRoute, associationRoute, resourceMethodName) {
                return function(ownerId, childId, payload) {
                    var methodName = ownerRoute + '.addOne' + resourceMethodName;
                    $log.debug(methodName + ' + ownerId: ', ownerId, 'childId: ', childId, ', payload: ', payload);

                    return apiHelperService.put(ownerRoute + '/' + ownerId + '/' + associationRoute + '/' + childId, payload)
                        .then(function(response) {
                            $log.debug(methodName + ' response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(methodName + ' error:\n', error);
                            throw error;
                        });
                };
            },
            generateRemoveOneAssociationCaller: function(ownerRoute, associationRoute, resourceMethodName) {
                return function(ownerId, childId) {
                    var methodName = ownerRoute + '.removeOne' + resourceMethodName;
                    $log.debug(methodName + ' + ownerId: ', ownerId, 'childResource: ', associationRoute, 'childId: ', childId);

                    return apiHelperService.delete(ownerRoute + '/' + ownerId + '/' + associationRoute + '/' + childId)
                        .then(function(response) {
                            $log.debug(methodName + ' response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(methodName + ' error:\n', error);
                            throw error;
                        });
                };
            },
            generateAddManyAssociationCaller: function(ownerRoute, associationRoute, resourceMethodName) {
                return function(ownerId, payload) {
                    var methodName = ownerRoute + '.addMany' + resourceMethodName;
                    $log.debug(methodName + ' + ownerId: ', ownerId, ', payload: ', payload);

                    return apiHelperService.post(ownerRoute + '/' + ownerId + '/' + associationRoute, payload)
                        .then(function(response) {
                            $log.debug(methodName + ' response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(methodName + ' error:\n', error);
                            throw error;
                        });
                };
            },
            generateRemoveManyAssociationCaller: function(ownerRoute, associationRoute, resourceMethodName) {
                return function(ownerId, payload) {
                    var methodName = ownerRoute + '.removeMany' + resourceMethodName;
                    $log.debug(methodName + ' + ownerId: ', ownerId, ', payload: ', payload);

                    return apiHelperService.delete(ownerRoute + '/' + ownerId + '/' + associationRoute, payload)
                        .then(function(response) {
                            $log.debug(methodName + ' response:\n', response);
                            return response;
                        })
                        .catch(function(error) {
                            $log.error(methodName + ' error:\n', error);
                            throw error;
                        });
                };
            },
            /*
             * Flattens MANY_MANY relationships so just the associated object is returned and no extra fields
             * @returns {Function}
             */
            generateFlattenAssociationData: function(associationName, childName) {
                return function(data) {
                    if (!data) {
                        return [];
                    }
                    return data.map(function(object) {
                        if (childName) {
                            return object[childName];
                        }
                        else {
                            return object[associationName];
                        }
                    });
                };
            },
        };
    });

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('panelService', panelService);

    function panelService($log, $q, $state, $aside) {
        var aside;

        return {
            show: show,
            hide: hide,
        };

        // SHOW PANEL (ASIDE)
        function show(templatePath, controller) {
            if (!templatePath || !controller) {
                return $q.reject();
            }
            if (aside) {
                $log.debug(
                    'help.panel.service: instance already exists - multiple requests?'
                );
                return $q.reject();
            }

            aside = $aside({
                controller: controller,
                controllerAs: 'vm',
                keyboard: true,
                onHide: hide,
                show: false,
                templateUrl: templatePath
            });

            return aside.$promise.then(aside.show);

        }

        // CLOSE PANEL (ASIDE)
        function hide(params) {
            if (!aside) {
                return;
            }
            //$log.debug('help.modal.service: hide');
            aside.hide();
            aside = null;

            if (params && params.redirect) {
                $log.debug('REDIRECTING TO:', params.redirect);
                $state.go(params.redirect);
            }
            else {
                $state.go($state.current.parent);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('modalService', modalService);

    function modalService($log, $q, $state, $modal) {
        var modal;
        var redirect;

        return {
            hide: hide,
            show: show,
        };


        // hide
        function hide(params) {
            if (modal) {
                redirect = (typeof params !== 'undefined') ? params : redirect;

                modal.$promise.then(modal.hide);
            }
        }

        // on hide panel event
        function handlePanelHide() {
            if (modal) {
                modal.destroy();

                // check if redirect should be
                if (redirect) {
                    $state.go($state.current.parent);
                }
            }
        }

        // show
        function show(template, controller, params) {
            if (!template || !controller) {
                return $q.reject();
            }

            // if we change from modal to modal, we can skip animation
            if (modal) {
                modal.destroy();
            }

            modal = $modal({
                controller: controller,
                controllerAs: 'vm',
                keyboard: false,
                onHide: handlePanelHide,
                show: false,
                templateUrl: template
            });

            redirect = (typeof params !== 'undefined') ? params : true;

            return modal.$promise.then(modal.show);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.repository', []);
})();

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('userRepository', function($log, API, apiHelperService) {
            return _.merge(
                {
                    getMy: function() {
                        $log.debug(API.USERS + '.getMy + params: ');

                        return apiHelperService.get(API.USERS + '/my')
                            .then(function(response) {
                                $log.debug(API.USERS + '.getMy response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.USERS + '.getMy error:\n', error);
                                throw error;
                            });
                    },
                },
                {
                    updateMy: function(user) {
                        $log.debug(API.USERS + '.updateMy + params: ', user);

                        return apiHelperService.put(API.USERS + '/my', user)
                            .then(function(response) {
                                $log.debug(API.USERS + '.updateMy response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.USERS + '.updateMy error:\n', error);
                                throw error;
                            });
                    },
                },
                {
                    changeMyPassword: function(password) {
                        $log.debug(API.USERS + '.changeMyPassword + params: ');

                        return apiHelperService.put(API.USERS + '/my/password', {password: password})
                            .then(function(response) {
                                $log.debug(API.USERS + '.changeMyPassword response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.USERS + '.changeMyPassword error:\n', error);
                                throw error;
                            });
                    },
                }
            );
        });
})();

/*
 ** Factory for CRUDing API.USERS
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('teamRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.TEAM));
        });
})();

/*
 ** Factory for CRUDing API.TEAM
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('subscriptionRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.SUBSCRIPTION));
        });
})();

/*
 ** Factory for CRUDing API.SUBSCRIPTION
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('specialtiesRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.SPECIALTIES));
        });
})();

/*
 ** Factory for CRUDing API.SPECIALTIES
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('pagesRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.PAGES));
        });
})();

/*
 ** Factory for CRUDing API.PAGES
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('itemRepository', function($log, API, restfulResourceHelper, apiHelperService) {
            return _.merge(
                restfulResourceHelper.generateCrudCallers(API.ITEMS),
                {
                    bid: function(_id, params) {
                        $log.debug(API.ITEMS + '.bid + _id', _id, ' + params: ', params);

                        return apiHelperService.post(API.ITEMS + '/' + _id + '/bid', params)
                            .then(function(response) {
                                $log.debug(API.ITEMS + '.bid response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.ITEMS + '.bid error:\n', error);
                                throw error;
                            });
                    },
                }
            );
        });
})();

/*
 ** Factory for CRUDing API.ITEMS
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('highlightRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.HIGHLIGHTS));
        });
})();

/*
 ** Factory for CRUDing API.HIGHLIGHTS
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('contactRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.CONTACT));
        });
})();

/*
 ** Factory for CRUDing API.CONTACT
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('categoriesRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.CATEGORIES));
        });
})();

/*
 ** Factory for CRUDing API.CATEGORIES
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('bidRepository', function($log, API, restfulResourceHelper, apiHelperService) {
            return _.merge(
                restfulResourceHelper.generateCrudCallers(API.BIDS),
                {
                    deleteOneBid: restfulResourceHelper.generateRemoveOneAssociationCaller(API.BIDS, 'item'),
                    listMyBids: function(email, params) {
                        $log.debug(API.BIDS + '.' + email + '.user + params: ', params);

                        return apiHelperService.get(API.BIDS + '/' + email + '/user', params)
                            .then(function(response) {
                                $log.debug(API.BIDS + '.' + email + '.user response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.BIDS + '.' + email + '.user error:\n', error);
                                throw error;
                            });
                    },
                });
        });
})();

/*
 ** Factory for CRUDing API.BIDS
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('auctionRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.EVENTS));
        });
})();

/*
 ** Factory for CRUDing API.EVENTS
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('assetsRepository', function(API, restfulResourceHelper) {
            return _.merge(restfulResourceHelper.generateCrudCallers(API.ASSETS));
        });
})();

/*
 ** Factory for CRUDing API.ASSETS
 */

(function() {
    'use strict';

    /**
     * NOTE: Refer to the "generateAssociationCallers" docs (in restful-resource-utility.service.js) for insight into
     * its parameters.
     */

    angular
        .module('app.services.repository')
        .factory('accountRepository', function($log, API, apiHelperService) {
            return _.merge(
                {
                    getMy: function() {
                        $log.debug(API.ACCOUNTS + '.getMy');

                        return apiHelperService.get(API.ACCOUNTS + '/my')
                            .then(function(response) {
                                $log.debug(API.ACCOUNTS + '.getMy response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.ACCOUNTS + '.getMy error:\n', error);
                                throw error;
                            });
                    },
                },
                {
                    updateMy: function(user) {
                        $log.debug(API.ACCOUNTS + '.updateMy + params: ', user);

                        return apiHelperService.put(API.ACCOUNTS + '/my', user)
                            .then(function(response) {
                                $log.debug(API.ACCOUNTS + '.updateMy response:\n', response);
                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.ACCOUNTS + '.updateMy error:\n', error);
                                throw error;
                            });
                    },
                },
                {
                    updateCache: function(limit, page, sort) {
                        $log.debug(API.ACCOUNTS + '.updateCache: ');

                        var accounts = {};

                        return apiHelperService.get(API.ACCOUNTS)
                            .then(function(response) {
                                $log.debug(API.USERS + '.updateCache success:\n', response);

                                response.data.forEach(function(a) {
                                    accounts[a._id] = a;
                                });

                                return response;
                            })
                            .catch(function(error) {
                                $log.error(API.USERS + '.updateCache error:\n', error);
                                throw error;
                            });
                    },
                }
            );
        });
})();

/*
 ** Factory for CRUDing API.ACCOUNTS
 */

(function() {
    'use strict';

    angular
        .module('app.services.metatags', []);

})();

(function() {
    'use strict';

    angular
        .module('app.services.metatags')
        .factory('metaTagsService', metaTagsService);

    function metaTagsService(ngMeta, $location, ENV_VARS) {
        return {
            setMetaTag: setMetaTag,
        };

        // setMetaTag
        function setMetaTag(obj, type) {
            var title = obj.meta.title ? obj.meta.title + ' | ' + ENV_VARS.appName : ENV_VARS.appName;
            var description = obj.meta.description || ENV_VARS.appDesc;
            var imageUrl = obj.headerUrl || obj.eventImageUrl || obj.itemImageUrl || obj.imageUrl || obj.mainImage;

            ngMeta.setTitle(title);
            ngMeta.setTag('description', description);
            ngMeta.setTag('headerImage', imageUrl);

            ngMeta.setTag('og:title', title);
            ngMeta.setTag('og:description', description);
            ngMeta.setTag('og:image', imageUrl);
            ngMeta.setTag('og:url', $location.absUrl());

            if (type) {
                ngMeta.setTag('og:type', type);
            }
            else {
                ngMeta.setTag('og:type', 'website');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.metatags')
        .provider('metaTagsData', metaTagsDataProvider);

    function metaTagsDataProvider(ENV_VARS) {

        this.getMetaTagsData = function() {
            var domain = 'https://' + ENV_VARS.appDomain;

            var defaultMeta = {
                'description': ENV_VARS.appDesc,
                'headerImage': domain + '/assets/images/logo.svg',

                'og:title': ENV_VARS.appName,
                'og:image': domain + '/assets/images/logo.svg',
                'og:url': domain,
                'og:description': ENV_VARS.appDesc,
                'og:type': 'website',
            };

            return {
                defaultMeta: defaultMeta,
                auctions: {
                    'title': 'Auctions',
                    'description': 'Upcoming Auctions, Next Auction Coming Soon, Past Auctions',
                    'og:title': 'Auctions | ' + ENV_VARS.appName,
                    'og:description': 'Upcoming Auctions, Next Auction Coming Soon, Past Auctions',
                    'og:image': domain + '/assets/images/hero-paddle.jpg',
                    'og:url': domain + '/auctions'
                },
                directions: {
                    'title': 'Directions to Vogt auction',
                    'description': "We'll show you the way! Vogt Auction Galleries is located at: 7233 Blanco Road in San Antonio, Texas. Hours: Monday-Friday 10am-6pm, Phone: (210) 822-6155, Fax: (210) 821-5821",
                    'og:title': 'Directions to Vogt auction | ' + ENV_VARS.appName,
                    'og:description': "We'll show you the way! Vogt Auction Galleries is located at: 7233 Blanco Road in San Antonio, Texas. Hours: Monday-Friday 10am-6pm, Phone: (210) 822-6155, Fax: (210) 821-5821",
                    'og:image': domain + '/assets/images/hero-directions.jpg',
                    'og:url': domain + '/directions'
                },
                settings: {
                    'title': 'Settings',
                    'og:title': 'Settings | ' + ENV_VARS.appName,
                },
                login: {
                    'title': 'Login',
                    'og:title': 'Login | ' + ENV_VARS.appName,
                },
                forgotpassword: {
                    'title': 'Forgot Password',
                    'og:title': 'Forgot Password | ' + ENV_VARS.appName,
                },
                resetpassword: {
                    'title': 'Reset Password',
                    'og:title': 'Reset Password | ' + ENV_VARS.appName,
                },
                signup: {
                    'title': 'Sign Up',
                    'og:title': 'Sign Up | ' + ENV_VARS.appName,
                },
                mybids: {
                    'title': 'My Bids',
                    'og:title': 'My Bids | ' + ENV_VARS.appName,
                },
                blog: {
                    'title': 'Blog',
                    'og:title': 'Blog | ' + ENV_VARS.appName,
                },
                about: {
                    'title': 'About us',
                    'description': "San Antonio's trusted estates leader. We’re the leading appraisal and auction house in our region, selling more than $135,000,000 in our award-winning 43 year history. We specialize in the appraisal and sale of antique furniture, Texan & European art, decorative arts, rugs, folk art, jewelry, coins, and sterling silver. We hold weekly & specialized auctions at our central San Antonio, Texas auction house drawing hundreds of bidders to each event.",

                    'og:title': 'About us | ' + ENV_VARS.appName,
                    'og:description': "San Antonio's trusted estates leader. We’re the leading appraisal and auction house in our region, selling more than $135,000,000 in our award-winning 43 year history. We specialize in the appraisal and sale of antique furniture, Texan & European art, decorative arts, rugs, folk art, jewelry, coins, and sterling silver. We hold weekly & specialized auctions at our central San Antonio, Texas auction house drawing hundreds of bidders to each event.",
                    'og:url': domain + '/about'
                },
            };
        };

        this.$get = function() {};
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.auth', []);
})();

// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('authService', authService);

    function authService($log, $timeout, $q, $http, $state, localStorageService, Notification, Session, API, REDIRECT) {
        return {
            login: login,
            loginForgot: loginForgot,
            loginReset: loginReset,
            logout: logout,
            signup: signup,
            checkEmail: checkEmail,
            getSession: getSession,
            isAuthenticated: isAuthenticated,
            isAuthorized: isAuthorized,
        };


        // login
        function login(user) {
            return $http.post(API.BASE_URL + API.LOGIN, {
                    username: user.username,
                    password: user.password
                })
                .then(function(response) {
                    $log.debug('authService.login-success:', response.data);

                    // EXPL: login successful if there's a user in the response
                    if (response.data.session) {
                        var session = angular.copy(response.data);
                        var account = angular.copy(response.data.user.account);
                        var user = angular.copy(response.data.user);
                        var role = Object.keys(response.data.user.roles)[0];

                        delete session.user;

                        session.role = role;
                        session.user = {
                            email: user.email,
                            _id: user._id,
                            name: account.name,
                            phone: account.phone,
                            username: user.username
                        };

                        Session.create(session);
                    }
                    else {
                        throw new Error('The response did not contain a user.');
                    }

                    return session.user;
                })
                .catch(function(error) {
                    $log.error('authService.login-error:', error);
                    throw error.data;
                });
        }

        // login forgot
        function loginForgot(email) {
            return $http.post(API.BASE_URL + API.LOGIN_FORGOT, {
                    email: email
                })
                .then(function(response) {
                    $log.debug('authService.loginForgot-success:\n', response);
                    return response;
                })
                .catch(function(error) {
                    $log.error('authService.loginForgot-error:\n', error);
                    throw error.data;
                });
        }

        // login reset
        function loginReset(data) {
            return $http.post(API.BASE_URL + API.LOGIN_RESET, data)
                .then(function(response) {
                    $log.debug('authService.loginReset-success:\n', response);
                    return response;
                })
                .catch(function(error) {
                    $log.error('authService.loginReset-error:\n', error);
                    throw error.data;
                });
        }

        // logout
        function logout() {
            // log user out if they exist in localstorage
            if (localStorageService.get('session')) {
                Session.deprecated = true;

                return $http.delete(API.BASE_URL + API.LOGOUT)
                    .then(function(response) {
                        // call singleton to wipe session
                        Session.destroy();
                        // direct call to null token so user is unAuthenticated
                        // to pass route resolve on login route
                        Session.authHeader = null;
                        Session.deprecated = false;

                        // messaging
                        $log.debug('authService.logout-success:', response);

                        // redirect
                        if ($state.includes('account')) {
                            $state.go(REDIRECT.HOME);
                        }
                    })
                    .catch(function(error) {
                        // failure
                        $log.error('authService.logout-error:', error);

                        // call singleton to wipe session
                        Session.destroy();
                        // direct call to null token so user is unAuthenticated
                        // to pass route resolve on login route
                        Session.authHeader = null;

                        // redirect
                        if ($state.includes('account')) {
                            $state.go(REDIRECT.HOME);
                        }
                    });
            }
            else {
                $log.debug('authService.logout: No session exists.');
                // redirect
                if ($state.includes('account')) {
                    $state.go(REDIRECT.HOME);
                }
            }
        }

        // signup
        function signup(data) {
            delete data.confirmPassword;

            var deferred = $q.defer();
            var promise = $http.post(API.BASE_URL + API.SIGNUP, data);

            // EXPL: use a timeout to delay activation response for better user experience
            $timeout(function() {
                promise
                    .then(function(response) {
                        $log.debug('authService.signup-success:\n', response);

                        if (response.data.session) {
                            var session = angular.copy(response.data);
                            var account = angular.copy(response.data.user.roles.account);
                            var user = angular.copy(response.data.user);
                            var phone = angular.copy(response.config.data.phone);
                            var role = Object.keys(response.data.user.roles)[0];

                            delete session.user;

                            $log.debug('authService.account:\n', account);

                            session.role = role;
                            session.user = {
                                email: user.email,
                                _id: user._id,
                                phone: phone,
                                username: user.username
                            };

                            var firstName = account.name.split(' ').slice(0, -1).join(' ');
                            var lastName = account.name.split(' ').slice(-1).join(' ');

                            session.user.name = {
                                first: firstName,
                                last: lastName,
                            };

                            $log.debug('authService.session:\n', session);

                            Session.create(session);
                        }
                        else {
                            throw new Error('The response did not contain a user.');
                        }

                        deferred.resolve(session.user);
                    })
                    .catch(function(error) {
                        $log.error('authService.signup-error:\n', error);
                        deferred.reject(error.data);
                    });
            }, 1000);

            return deferred.promise;
        }

        // check email
        function checkEmail(email) {
            return $http.get(API.BASE_URL + API.USERS + '/' + email + '/search', {})
                .then(function(response) {
                    $log.debug('authService.checkEmail-success:\n', response);
                    return response;
                })
                .catch(function(error) {
                    $log.error('authService.checkEmail-error:\n', error);
                    throw error.data;
                });
        }

        // get existing session
        function getSession() {
            // get user from localstorage
            if (localStorageService.get('session')) {

                $log.debug('authService.getSession-session exists');

                // update session with local storage
                Session.update();
            }
            else {
                $log.debug('authService.getSession-NO session exists');
            }
        }

        // is authenticated
        function isAuthenticated() {
            return !!Session.authHeader && !Session.deprecated;
        }

        // is authorized
        // pass role name to check against allowed from backend
        function isAuthorized(authorizedRoles) {
            if (!angular.isArray(authorizedRoles)) {
                // converts if no brackets around role name in the route
                authorizedRoles = [authorizedRoles];
            }

            // if user is authed with session, convert roles object to array to be searched
            var userRole = Session.role; // ES6 - works only in modern browsers

            // compare the two role sets to see if we allow access to the route
            var foundRole = authorizedRoles.indexOf(userRole);

            return (isAuthenticated() && foundRole > -1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('Session', Session);

    function Session($log, $http, localStorageService) {
        var session = {
            create: create,
            destroy: destroy,
            setUser: setUser,
            update: update,
        };

        return session;

        function create(obj) {
            // add jwt token to auth header for all requests made by the $http service
            $http.defaults.headers.common.Authorization = obj.authHeader;

            // FUTURE: determine jwt expire time
            // var hoursToExpireTokenIn = 4;
            // var tokenExpiry = new Date(obj.time);
            // tokenExpiry.setHours(tokenExpiry.getHours() + hoursToExpireTokenIn);

            // save vars to keep user logged in between page refreshes
            localStorageService.set('session', {
                user: obj.user,
                role: obj.role,
                authHeader: obj.authHeader
            });

            // set vars for session
            session.user = obj.user;
            session.role = obj.role;
            session.authHeader = obj.authHeader;
            session.deprecated = false;

            $log.debug('Session created:\n', session);
        }

        function destroy() {
            $log.debug('Session.destroy: clearing localstorage');
            // remove jwt token from header
            $http.defaults.headers.common.Authorization = '';
            // remove user from local storage and clear http auth header
            localStorageService.remove('session');
        }

        function setUser(user) {
            session.user = user;
            localStorageService.set('session', session);
        }

        function update() {
            // add jwt token to auth header for all requests made by the $http service
            $http.defaults.headers.common.Authorization = localStorageService.get('session').authHeader;

            // set vars for session on page refresh
            session.user = localStorageService.get('session').user;
            session.role = localStorageService.get('session').role;
            session.authHeader = localStorageService.get('session').authHeader;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('authSecurityService', authSecurityService);

    function authSecurityService($log, $timeout, $state, $q, authService, Notification, REDIRECT) {
        return {
            requireAccountUser: requireAccountUser,
            requireAuthenticatedUser: requireAuthenticatedUser,
            requireUnauthenticatedUser: requireUnauthenticatedUser
        };

        // SECURITY: ADMIN
        function requireAccountUser() {
            var defer = $q.defer();
            var authorizedRoles = ['account'];

            // check if user has account role
            if (authService.isAuthorized(authorizedRoles)) {
                // user is authenticated and has the correct role - let them pass
                $log.debug('auth.security: requireAccountUser: user has account role - lets resolve');

                defer.resolve();
            }
            else if (authService.isAuthenticated()) {
                // user is authenticated and does not have the account role - redirect home
                $log.debug('auth.security: requireAccountUser: user DOES NOT HAVE account role - lets reject');

                // must be wrapped with timeout for async or will hang
                $timeout(function() {
                    authService.logout();
                    $state.go(REDIRECT.LOGIN);
                    Notification.warning({message: 'You don\'t have the correct role to log in or access this area.  Please try a different account.', title: 'Not Authorized'});

                });
                defer.reject();
            }
            else {
                $log.debug('auth.security: requireAccountUser: user is NOT AUTHED and DOES NOT HAVE account role - lets reject');
                // user is not authenticated (therefore doesnt have a role)

                // must be wrapped with timeout for async or will hang
                $timeout(function() {
                    $log.debug('auth.security: ATTEMPTING REDIRECT TO LOGIN');
                    $state.go(REDIRECT.LOGIN);
                    Notification.warning({message: 'You don\'t have the correct role to log in or access this area.  Please try a different account.', title: 'Not Authorized'});
                });

                defer.reject();
            }

            return defer.promise;
        }

        // SECURITY: AUTHENTICATED
        function requireAuthenticatedUser() {
            var defer = $q.defer();

            // check if user is authenticated
            if (authService.isAuthenticated()) {
                // user is authenticated and does not have the account role - redirect home
                $log.debug('auth.security: requireAuthenticatedUser: user is authenitcated-resolve');
                defer.resolve();
            }
            else {
                $log.debug('auth.security: requireAuthenticatedUser: user is not authenitcated');

                $timeout(function() {
                    $state.go(REDIRECT.LOGIN);
                });
                defer.reject();
            }
            return defer.promise;
        }

        // SECURITY: UNAUTHENTICATED
        function requireUnauthenticatedUser() {
            var defer = $q.defer();

            if (authService.isAuthenticated()) {
                // user is authenticated - dont let them access the requested page - redirect
                $log.debug('auth.security: requireUnauthenticatedUser-redirect');
                Notification.warning('You\'re Authenticated.');

                // must be wrapped with timeout for async or will hang
                $timeout(function() {
                    $state.go(REDIRECT.BID);
                });
                defer.reject();
            }
            else {
                $log.debug('auth.security: requireUnauthenticatedUser-resolve', $state);
                defer.resolve();
            }
            return defer.promise;
        }
    }
})();

// This service provides guard methods to support AngularJS routes.
// You can add them as resolves to routes to require authorization levels before allowing a route change to complete

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('authInterceptorService', authInterceptorService);

    function authInterceptorService($q, $log, $injector, REDIRECT) {
        return {
            responseError: responseError
        };

        function responseError(response) {
            var Session = $injector.get('Session');
            var $state = $injector.get('$state');

            // 401 UNAUTHORIZED CAUGHT - No Valid Auth Credentials OR Session expired
            if (response.status === 401) {
                $log.debug('authInterceptor.service: 401: response:', response);

                // call singleton to wipe session
                Session.destroy();
                // direct call to null token so user is unAuthenticated
                // to pass route resolve on login route
                Session.authHeader = null;

                $state.go(REDIRECT.LOGIN);
            }

            /* If not a 401, do nothing with this error.
             * This is necessary to make a `responseError`
             * interceptor a no-op. */
            return $q.reject(response);
        }
    };

})();

// This http interceptor listens for 401 authentication failures
// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth

(function() {
    'use strict';

    angular.module('auth.login', []);
})();


(function() {
    'use strict';

    angular
        .module('auth.login')
        .controller('LoginResetController', LoginResetController);

    function LoginResetController($scope, $log, $location, Session, authService, passService, flashService, formsService) {
        var vm = this;

        $log.debug('LoginResetController *** GOT HERE ****');


        // ViewModel Properties
        vm.password = '';
        vm.confirmPassword = '';
        vm.success = false;
        vm.token = '';
        vm.valid = false;

        // ViewModel Methods
        vm.isPasswordConfirmed = passService.isPasswordConfirmed;
        vm.onSubmit = handleSubmit;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        (function init() {
            // reset login status - ensure user is logged out on controller load
            // user should never get to /activate-account when authenticated - this is precaution
            Session.destroy();
            Session.token = null;

            // if the user was directed here via a link with a key, then activate their account
            if ($location.search().token) {
                vm.valid = true;
                vm.token = $location.search().token;
            }
            else {
                $log.error('LoginResetController.init-error:', 'no token');
                flashService.error('The link you used did not contain a token. Please click on the link in your email to ' +
                    'reset your password, or proceed to the login page to request a new email.');
            }
        })();


        // Private Methods
        // handleSubmit
        function handleSubmit() {
            $scope.isDataLoading = true;

            return authService.loginReset({
                token: vm.token,
                password: vm.password
            })
                .then(function(response) {
                    $scope.isDataLoading = false;

                    $scope.resetForm.$setPristine();

                    vm.user = {};
                    vm.success = true;

                    flashService.success('Your password has been reset. Please login to confirm.');
                    $log.debug('LoginResetController.resetPassword-success:', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    vm.valid = false;

                    if (error.message === 'Invalid email or key.') {
                        flashService.error('The token in your email link has expired, proceed to the login page to request a new email.');
                    }
                    else {
                        flashService.error('There was an error during the activation process, please try again.');
                    }

                    $log.error('LoginResetController.resetPassword-error:', error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('auth.login')
        .controller('LoginForgotController', LoginForgotController);

    function LoginForgotController($scope, $log, authService, emailService, flashService, formsService) {
        var vm = this;

        // ViewModel Properties
        vm.email = '';
        vm.success = false;

        // ViewModel Methods
        vm.isEmail = emailService.isEmail;
        vm.onSubmit = handleSubmit;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        // Private Methods
        // handleSubmit
        function handleSubmit() {
            $scope.isDataLoading = true;

            return authService.loginForgot(vm.email)
                .then(function(response) {
                    $scope.loginForgotForm.$setPristine();

                    vm.email = '';
                    vm.success = true;

                    $log.debug('loginForgot.controller-success:', response);
                    flashService.info('If an account matched that address, an email will be sent with instructions.');
                }, function(error) {
                    $log.error('loginForgot.controller-error:', error);
                    flashService.error('Error resetting your account, please try again.');
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('account.bid', []);
})();

(function() {
    'use strict';

    angular
        .module('account.bid')
        .controller('BidPhotosController', BidPhotosController);

    function BidPhotosController($state, $timeout, $log, $scope, $rootScope, $stateParams, modalService, itemRepository,
        auctionRepository, bidRepository, Notification) {
        var vm = this;

        // ViewModel Properties
        vm.auction = {};
        vm.bid = $stateParams.bid;
        vm.bid.item.featuredImagesUrls = [];
        vm.photoIndex = 0;

        // ViewModel Methods
        vm.onView = handleView;


        (function init() {
            $scope.isDataLoading = false;
            getItem();
        })();


        // Private Methods

        // getItem
        function getItem() {
            $scope.isDataLoading = true;

            return itemRepository.find(vm.bid.item.id)
                .then(function(response) {
                    vm.bid.item = response;

                    // add the main image to the array
                    if (vm.bid.item.itemImageUrl) {
                        vm.bid.item.featuredImagesUrls.unshift(vm.bid.item.itemImageUrl);
                    }

                    getAuction();

                    $log.debug('BidPhotosController.getItem-success:\n', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('BidPhotosController.getItem-error:\n', error);
                    Notification.error('There was an error loading the item.');
                });
        }

        // getAuction
        function getAuction() {
            $log.debug('vm.bid.item:\n', vm.bid.item);

            return auctionRepository.find(vm.bid.item.events[0].id)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    vm.auction = response;

                    $log.debug('BidPhotosController.getAuction-success:\n', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('BidPhotosController.getAuction-error:\n', error);
                    Notification.error('There was an error loading the auction.');
                });
        }


        // handleView
        function handleView() {
            modalService.hide(false);

            var params = {
                auctionSlug: vm.auction.meta.slug
            };

            $timeout(function() {
                $state.go('auction-detail', params);
            }, 500);
        }
    }
})();

(function() {
    'use strict';

    angular.module('public.pages', []);
})();

(function() {
    'use strict';

    angular
        .module('public.pages')
        .config(pagesRouteConfig);

    function pagesRouteConfig($stateProvider) {
        $stateProvider

        .state('pages', {
            abstract: true,
            controller: 'PagesController',
            controllerAs: 'vm',
            parent: 'public',
            url: 'page',
        })

        .state('page-detail', {
            controller: 'PagesController',
            controllerAs: 'vm',
            templateUrl: 'app/public/pages/pages.view.html',
            parent: 'public',
            url: 'page/:pageSlug',
        })

        .state('page-universal', {
            controller: 'PagesController',
            controllerAs: 'vm',
            templateUrl: 'app/public/pages/pages.view.html',
            parent: 'public',
            url: "{pageSlug:.*}"
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('public.pages')
        .controller('PagesController', PagesController);

    function PagesController($log, $scope, $state, $sce, pagesRepository, Notification, metaTagsService) {
        var vm = this;

        // ViewModel Properties
        vm.page = [];


        (function init() {
            $scope.isDataLoading = false;

            getPage();
        })();


        // Private Methods
        // getPage
        function getPage() {
            $scope.isDataLoading = true;

            var params = {
                slug: $state.params.pageSlug,
            };
            $log.debug('pageSlug:', params.slug);

            return pagesRepository.list(params)
                .then(function(response) {
                    //$log.debug('PageController.getPage-response.data:', response.data);

                    $scope.isDataLoading = false;

                    // ensure our stateparam exists in our object array
                    vm.page = response;
                    vm.page.body = $sce.trustAsHtml(vm.page.body);
                    metaTagsService.setMetaTag(vm.page);

                    // if not contained in array, go redirect home
                    if (!vm.page) $state.go('home');

                    $log.debug('PageController.getPage-vm.page:', vm.page);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('PageController.getPage-error:\n', error);
                    Notification.error('There was an error loading the page.');
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('public.home', []);
})();

(function() {
    'use strict';

    angular
        .module('public.home')
        .config(homeRouteConfig);

    function homeRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('home', {
            controller: 'HomeController',
            controllerAs: 'vm',
            parent: 'public',
            templateUrl: 'app/public/home/home.view.html',
            url: '',
            data: {
                meta: defaultMeta,
            }
        })

        .state('directions', {
            controller: 'HomeController',
            controllerAs: 'vm',
            templateUrl: 'app/public/home/directions/directions.view.html',
            parent: 'public',
            url: 'directions',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.directions),
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('public.home')
        .controller('HomeController', HomeController);

    function HomeController($q, $log, $scope, $rootScope, auctionRepository, categoriesRepository, highlightRepository, Notification) {
        var vm = this;

        // ViewModel Properties
        vm.activePanel = 0;
        vm.highlights = [];
        vm.auction = [];
        vm.auctionPast = [];
        vm.categories = [];


        (function init() {
            $scope.isDataLoading = false;
            getCategory();

        })();


        // Private Methods
        // getCategory
        function getCategory() {
            $scope.isDataLoading = true;

            return categoriesRepository.list()
                .then(function(response) {
                    //$log.debug('HomeController.getCategory-success:\n', response);

                    _.forEach(response.data, function(item, i) {
                        vm.categories.push({
                            'id': item._id,
                            'name': item.name,
                            'slug': item.meta.slug
                        });
                    });

                    getHighlights();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('HomeController.getCategory-error:\n', error);
                    Notification.error('There was an error loading the categories.');
                });
        }

        // isAuctionPast
        function isAuctionPast(auction) {
            return auction.startDates.length > 0 && auction.startDates.every(function(date) {
                return moment(date).diff(moment(), 'minutes') < 0;
            });
        }

        // getHighlights
        function getHighlights() {
            $scope.isDataLoading = true;

            return highlightRepository.list()
                .then(function(response) {
                    $scope.isDataLoading = false;

                    _.forEach(response, function(event, i) {
                        //$log.debug('event', event.index + ': ' + event.title);

                        vm.foundCategories = [];

                        _.forEach(event.categories, function(cat) {
                            //$log.debug('vm.categories', vm.categories);
                            vm.foundCategories.push(_.find(vm.categories, {id: cat}));
                        });


                        if (event.type === $rootScope.HIGHLIGHT_TYPE.VIDEO) {
                            event.video = event.url;
                            delete event.url;
                        }

                        vm.highlights.push({
                            'id': event._id,
                            'url': event.url,
                            'title': event.title,
                            'categories': vm.foundCategories,
                            'foreignId': event.foreignId,
                            'type': event.type,
                            'imageUrl': event.imageUrl,
                            'imageLink': event.imageLink,
                            'video': event.video,
                            'dates': event.dates,
                            'index': event.index
                        });
                    });

                    getAuctions();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('HomeController.getHighlights-error:\n', error);
                    Notification.error('There was an error loading the highlights.');
                });
        }

        // getAuctions
        function getAuctions() {
            $scope.isDataLoading = true;

            return auctionRepository.list()
                .then(function(response) {

                    $scope.isDataLoading = false;

                    _.forEach(response.data, function(event, i) {
                        vm.foundCategories = [];

                        _.forEach(event.categories, function(cat) {
                            vm.foundCategories.push(_.find(vm.categories, {id: cat.id}));
                        });

                        if (event.state.indexOf('published') > -1) {

                            vm.auction.push({
                                'id': event._id,
                                'title': event.title,
                                'categories': vm.foundCategories,
                                'eventImageUrl': event.eventImageUrl,
                                'startDates': event.startDates.sort(function(a, b) {
                                    return a < b ? 1 : -1;
                                }),
                                'state': event.state,
                                'meta': event.meta
                            });
                        }
                    });

                    vm.auction = vm.auction.sort(function(a, b) {
                        return (a.startDates[0] < b.startDates[0]) ? 1 : -1;
                    });

                    vm.auctionPast = vm.auction.filter(isAuctionPast);

                    //$log.debug('AuctionController.vm.auction-filtered:\n', vm.auction);

                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('AuctionController.getAuctions-error:\n', error);
                    Notification.error('There was an error loading the auctions.');
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('public.category', []);
})();

(function() {
    'use strict';

    angular
        .module('public.category')
        .factory('categoryService', categoryService);

    function categoryService($log, API, apiHelperService) {
        return {
            getSpecialtyAuction: getSpecialtyAuction
        };

        function getSpecialtyAuction(id) {
            var req = {
                method: 'GET',
                url: API.BASE_URL + API.EVENTS + '/' + id,
            };

            return apiHelperService.sendHTTPRequest(req);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('public.category')
        .config(categoryRouteConfig);

    function categoryRouteConfig($stateProvider) {
        $stateProvider

        .state('categories', {
            url: 'category',
            parent: 'public',
            abstract: true,
            controller: 'CategoryController',
            controllerAs: 'vm'
        })

        .state('category-detail', {
            url: 'category/:categorySlug',
            parent: 'public',
            controller: 'CategoryController',
            controllerAs: 'vm',
            templateUrl: 'app/public/category/category.view.html',
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('public.category')
        .controller('CategoryController', CategoryController);

    function CategoryController($q, $log, $scope, $state, $stateParams, auctionRepository, categoriesRepository, specialtiesRepository, Notification, metaTagsService) {
        var vm = this;

        // ViewModel Properties
        vm.category = {};
        vm.categories = [];
        vm.specialty = {};
        vm.auctionNext = [];
        vm.auctionPast = [];
        vm.auction = [];

        (function init() {
            $scope.isDataLoading = false;
            getCategory();
        })();


        // Private Methods
        // getCategory
        function getCategory() {
            $scope.isDataLoading = true;

            return categoriesRepository.list()
                .then(function(response) {
                    $log.debug('CategoryController.getCategory-success:\n', response);

                    vm.categories = response.data;
                    vm.category = response.data.filter(function(item) {
                        return item.meta.slug.toLowerCase() === $stateParams.categorySlug.toLowerCase();
                    })[0];

                    getSpecialties();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('CategoryController.getCategory-error:\n', error);
                    Notification.error('There was an error loading the category.');
                });
        }


        // getSpecialties
        function getSpecialties() {
            $scope.isDataLoading = true;

            return specialtiesRepository.list()
                .then(function(response) {
                    $log.debug('CategoryController.getSpecialties-success:\n', response);

                    // filter specialties using categoryId
                    vm.specialty = response.data.filter(function(item) {
                        return item.categories.filter(function(category) {
                            return category.id === vm.category._id;
                        }).length > 0;
                    })[0];

                    if (vm.specialty.events) {
                        vm.specialty.events.forEach(function(event) {
                            event.event.categories = event.event.categories.map(function(c) {
                                return vm.categories.find(function(cat) {
                                    return cat._id == c.id;
                                });
                            });
                            vm.specialty.mainImage = event.event.eventImageUrl;
                        });
                    }

                    metaTagsService.setMetaTag(vm.specialty);

                    // if not contained in array, go redirect home
                    if (!vm.specialty) {
                        return $state.go('home');
                    }

                    getAuctions();

                    $scope.isDataLoading = false;
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('CategoryController.getSpecialties-error:\n', error);
                    Notification.error('There was an error loading the specialties.');
                });
        }

        // isAuctionNext
        function isAuctionNext(auction) {
            if (auction.startDates.length == 0) {
                return true;
            }
            return auction.startDates.some(function(date) {
                return moment(date).diff(moment(), 'minutes') > 0;
            });
        }

        // isAuctionPast
        function isAuctionPast(auction) {
            return auction.startDates.length > 0 && auction.startDates.every(function(date) {
                return moment(date).diff(moment(), 'minutes') < 0;
            });
        }

        // getAuctions
        function getAuctions() {
            $scope.isDataLoading = true;

            return auctionRepository.list()
                .then(function(response) {

                    $scope.isDataLoading = false;

                    _.forEach(response.data, function(event, i) {
                        vm.foundCategories = [];
                        //$log.debug('CategoryController.event:\n', event);

                        _.forEach(event.categories, function(cat) {
                            //vm.foundCategories.push(_.find(vm.category, {id: cat.id}));

                            if (vm.category._id === cat.id) {
                                vm.auction.push({
                                    'id': event._id,
                                    'title': event.title,
                                    'categories': vm.foundCategories,
                                    'eventImageUrl': event.eventImageUrl,
                                    'startDates': event.startDates.sort(function(a, b) {
                                        return a < b ? 1 : -1;
                                    }),
                                    'state': event.state,
                                    'meta': event.meta
                                });
                            }
                        });
                    });

                    vm.auction = vm.auction.sort(function(a, b) {
                        return (a.startDates[0] < b.startDates[0]) ? 1 : -1;
                    });

                    vm.auctionNext = vm.auction.filter(isAuctionNext);
                    vm.auctionPast = vm.auction.filter(isAuctionPast);

                    // $log.debug('CategoryController.auctionNext:', vm.auctionNext);
                    // $log.debug('CategoryController.auctionPast:', vm.auctionPast);
                    // $log.debug('CategoryController.getAuctions-success:\n', response);
                    $log.debug('CategoryController.vm.auction-filtered:\n', vm.auction);

                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('CategoryController.getAuctions-error:\n', error);
                    Notification.error('There was an error loading the auctions.');
                });
        }

    }
})();

(function() {
    'use strict';

    angular.module('public.blog', []);
})();

(function() {
    'use strict';

    angular
        .module('public.blog')
        .factory('blogService', blogService);

    function blogService($log, API, apiHelperService) {
        return {
            getBlogPosts: getBlogPosts,
            getBlogPostDetail: getBlogPostDetail,
            getCategories: getCategories,
        };

        function getBlogPosts(sort) {
            var req = {
                method: 'GET',
                url: API.BASE_URL + API.BLOG,
                params: {
                    sort: sort,
                    limit: 100,
                },
            };

            return apiHelperService.sendHTTPRequest(req);
        }

        function getBlogPostDetail(id) {
            var req = {
                method: 'GET',
                url: API.BASE_URL + API.BLOG + '/' + id,
            };

            return apiHelperService.sendHTTPRequest(req);
        }

        function getCategories() {
            var req = {
                method: 'GET',
                url: API.BASE_URL + API.CATEGORIES,
            };

            return apiHelperService.sendHTTPRequest(req);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('public.blog')
        .config(blogRouteConfig);

    function blogRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('blog', {
            controller: 'BlogController',
            controllerAs: 'vm',
            parent: 'public',
            templateUrl: 'app/public/blog/blog.view.html',
            url: 'blog',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.blog)
            }
        })

        .state('blog-detail', {
            controller: 'BlogDetailController',
            controllerAs: 'vm',
            parent: 'public',
            templateUrl: 'app/public/blog/blog-detail/blog-detail.view.html',
            url: 'blog/:id',
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('public.blog')
        .controller('BlogController', BlogController);

    function BlogController($sce, blogService) {
        var vm = this;

        vm.posts = [];
        vm.categories = [];

        (function init() {
            blogService.getCategories().then(function(response) {
                if (response.data) {
                    // $log.debug('getCategories--response.data', response.data);

                    _.forEach(response.data, function(item, i) {
                        vm.categories.push({
                           'id': item._id,
                           'name': item.name,
                        });
                    });

                    // $log.debug('vm.categories', vm.categories);
                }
            });

            blogService.getBlogPosts('-created').then(function(response) {
                if (response.data) {
                    // $log.debug('getBlogPosts--response.data', response.data);

                    _.forEach(response.data, function(item, i) {
                        // $log.debug('item', item);

                         vm.foundCategories = [];

                        _.forEach(item.categories, function(cat) {
                            vm.foundCategories.push(_.find(vm.categories, {id: cat.id}));
                        });

                        // $log.debug('vm.foundCategories', vm.foundCategories);

                        vm.posts.push({
                           'id': item._id,
                           'title': item.title,
                           'categories': vm.foundCategories,
                           'image': item.headerUrl,
                           'body': $sce.trustAsResourceUrl(item.body),
                        });
                    });

                    // $log.debug('vm.posts', vm.posts);
                }
            });
        })();
    }
})();

(function() {
    'use strict';

    angular
        .module('public.auction')
        .config(auctionRouteConfig);

    function auctionRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('auction', {
            parent: 'public',
            url: 'auctions',
            templateUrl: 'app/public/auction/auction.view.html',
            controller: 'AuctionController',
            controllerAs: 'vm',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.auctions),
            }
        })

        .state('auction-detail', {
            parent: 'public',
            url: 'auctions/:auctionSlug?limit',
            templateUrl: 'app/public/auction/auction-detail/auction-detail.view.html',
            controller: 'AuctionDetailController',
            controllerAs: 'vm',
        })

        .state('auction-item', {
            parent: 'auction-detail',
            url: '/item/:itemSlug',
            onEnter: function($state, $stateParams, modalService) {
                if ($stateParams.itemSlug && typeof $stateParams.itemSlug === 'string') {
                    modalService.show(
                        'app/public/auction/auction-detail/item/item.modal.html',
                        'ItemController'
                    );
                }
                else {
                    var params = {
                        auctionSlug: $stateParams.auctionSlug,
                    };

                    $state.go('auction-detail', params);
                }
            },
            params: {
                itemSlug: null,
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('public.auction')
        .controller('AuctionController', AuctionController);

    function AuctionController($q, $log, $scope, auctionRepository, categoriesRepository, Notification) {
        var vm = this;

        // ViewModel Properties
        vm.activePanel = 0;
        vm.auction = [];
        vm.auctionNext = [];
        vm.auctionPast = [];
        vm.categories = [];


        var promises = [
            getCategory(),
            getAuctions()
        ];

        (function init() {
            $scope.isDataLoading = false;
            return $q.all(promises);

        })();

        // Private Methods

        // getCategory
        function getCategory() {
            $scope.isDataLoading = true;

            return categoriesRepository.list()
                .then(function(response) {
                    //$log.debug('AuctionController.getCategory-success:\n', response);

                    _.forEach(response.data, function(item, i) {
                        vm.categories.push({
                           'id': item._id,
                           'name': item.name,
                           'slug': item.meta.slug
                        });
                    });
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('AuctionController.getCategory-error:\n', error);
                    Notification.error('There was an error loading the categories.');
                });
        }

        // isAuctionNext
        function isAuctionNext(auction) {
            if (auction.startDates.length == 0) {
                return true;
            }
            return auction.startDates.some(function(date) {
                return moment(date).diff(moment(), 'minutes') > 0;
            });
        }

        // isAuctionPast
        function isAuctionPast(auction) {
            return auction.startDates.length > 0 && auction.startDates.every(function(date) {
                return moment(date).diff(moment(), 'minutes') < 0;
            });
        }

        // getAuctions
        function getAuctions() {
            $scope.isDataLoading = true;

            return auctionRepository.list()
                .then(function(response) {

                    $scope.isDataLoading = false;

                    _.forEach(response.data, function(event, i) {

                         vm.foundCategories = [];

                        _.forEach(event.categories, function(cat) {
                            vm.foundCategories.push(_.find(vm.categories, {id: cat.id}));
                        });

                        vm.auction.push({
                           'id': event._id,
                           'title': event.title,
                           'categories': vm.foundCategories,
                           'eventImageLink': event.eventImageLink,
                           'eventImageUrl': event.eventImageUrl,
                           'startDates': event.startDates.sort(function(a, b) {
                               return a < b ? 1 : -1;
                           }),
                           'state': event.state,
                           'meta': event.meta
                        });
                    });

                    vm.auction = vm.auction.sort(function(a, b) {
                        return (a.startDates[0] < b.startDates[0]) ? 1 : -1;
                    });

                    vm.auctionNext = vm.auction.filter(isAuctionNext).reverse();
                    vm.auctionPast = vm.auction.filter(isAuctionPast);

                    // $log.debug('AuctionController.auctionNext:', vm.auctionNext);
                    // $log.debug('AuctionController.auctionPast:', vm.auctionPast);
                    // $log.debug('AuctionController.getAuctions-success:\n', response);
                    // $log.debug('AuctionController.vm.auction-filtered:\n', vm.auction);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('AuctionController.getAuctions-error:\n', error);
                    Notification.error('There was an error loading the auctions.');
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('public.assets', []);
})();

(function() {
    'use strict';

    angular
        .module('public.assets')
        .config(pagesRouteConfig);

    function pagesRouteConfig($stateProvider) {
        $stateProvider

        .state('assets', {
            abstract: true,
            controller: 'AssetsController',
            controllerAs: 'vm',
            parent: 'public',
            url: 'asset',
        })

        .state('assets-detail', {
            controller: 'AssetsController',
            controllerAs: 'vm',
            templateUrl: 'app/public/assets/assets.view.html',
            parent: 'public',
            url: 'asset/:assetSlug',
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('public.assets')
        .controller('AssetsController', AssetsController);

    function AssetsController($log, $scope, $state, $http, assetsRepository, Notification, metaTagsService) {
        var vm = this;

        // ViewModel Properties
        vm.asset = [];

        (function init() {
            $scope.isDataLoading = false;

            getAsset();
        })();


        // Private Properties
        var assetSlug = $state.params.assetSlug;

        // Private Methods
        // getAsset
        function getAsset() {
            $scope.isDataLoading = true;

            $log.debug('assetSlug:', assetSlug);

            return assetsRepository.list()
                .then(function(response) {
                    //$log.debug('assetController.getAsset-response.data:', response.data);

                    $scope.isDataLoading = false;

                    // ensure our stateparam exists in our object array
                    vm.asset = _.find(response.data, {meta: {slug: assetSlug}});
                    metaTagsService.setMetaTag(vm.asset);

                    // if not contained in array, go redirect home
                    if (!vm.asset) $state.go('home');

                    var isGoogleDoc = /^https:\/\/docs\.google\.com/.test(vm.asset.assetUrl);
                    vm.isPdf = /\.pdf$/.test(vm.asset.assetUrl) || isGoogleDoc;
                    vm.isDoc = /\.(doc|docx)$/.test(vm.asset.assetUrl);

                    if (vm.isDoc) {
                        $http.get(vm.asset.assetUrl, {
                            responseType: 'arraybuffer'
                        })
                        .then(function(response) {
                            var arrayBuffer = new Uint8Array(response.data);
                            mammoth.convertToHtml({arrayBuffer: arrayBuffer})
                                .then(function(result) {
                                    vm.html = result.value;
                                    $scope.$apply();
                                })
                                .done();
                        });
                    }

                    $log.debug('AssetsController.getAsset-vm.asset:', vm.asset);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('AssetsController.getAsset-error:\n', error);
                    Notification.error('There was an error loading the asset.');
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('public.about')
        .config(aboutRouteConfig);

    function aboutRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('about', {
            controller: 'AboutController',
            controllerAs: 'vm',
            parent: 'public',
            templateUrl: 'app/public/about/about.view.html',
            url: 'about',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.about)
            }
        })

        .state('person', {
            data: {
                bodyClass: 'backdrop-dark',
            },
            onEnter: function($state, $stateParams, modalService) {
                if ($stateParams.person && typeof $stateParams.person._id === 'string') {
                    modalService.show(
                        'app/public/about/team/team.modal.html',
                        'TeamController'
                    );
                }
                else {
                    $state.go('about');
                }
            },
            params: {
                person: null,
            },
            parent: 'about',
            url: '/:personSlug',
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("public.about")
        .controller("AboutController", AboutController);

    function AboutController(
        $log,
        $scope,
        $state,
        $sce,
        teamRepository,
        pagesRepository,
        Notification
    ) {
        var vm = this;

        // ViewModel Properties
        vm.persons = [];

        (function init() {
            getPage();
            getTeam();
        })();

        // Private Methods
        function getPage() {
            $scope.isDataLoading = true;

            return pagesRepository
                .list()
                .then(function (response) {
                    //$log.debug('PageController.getPage-response.data:', response.data);

                    $scope.isDataLoading = false;

                    // ensure our stateparam exists in our object array
                    vm.page = _.find(response.data, {
                        meta: { slug: "about" },
                    });
                    vm.page.body = $sce.trustAsHtml(vm.page.body);

                    // if not contained in array, go redirect home
                    if (!vm.page) $state.go("home");
                })
                .catch(function (error) {
                    $scope.isDataLoading = false;

                    $log.error("AboutController.getPage-error:\n", error);
                    Notification.error(
                        "There was an error loading the about page."
                    );
                });
        }

        // getTeam
        function getTeam() {
            $scope.isDataLoading = true;

            return teamRepository
                .list()
                .then(function (response) {
                    $scope.isDataLoading = false;

                    vm.persons = response.data;

                    // add slug property
                    vm.persons = vm.persons.map(function (item) {
                        item.slug = item.name
                            .replace(/\s+/g, "-")
                            .replace(/[^A-Za-z0-9-]+/g, "")
                            .toLowerCase();
                        return item;
                    });

                    $log.debug("AboutController.getTeam-success:\n", response);
                    $log.debug(
                        "AboutController.vm.persons-reorder:\n",
                        vm.persons
                    );
                })
                .catch(function (error) {
                    $scope.isDataLoading = false;

                    $log.error("AboutController.getTeam-error:\n", error);
                    Notification.error("There was an error loading the team.");
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services', [
            'app.services.auth',
            'app.services.repository',
            'app.services.utility',
            'app.services.metatags'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('public.assets')
        .filter('trustUrl', function($sce) {
            return function(val) {
                return $sce.trustAsResourceUrl(val);
            };
        });
})();

(function() {
    'use strict';

    angular
        .module('app.filters', []);
})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('phonenumberFilter', phonenumberFilter);

    function phonenumberFilter() {
        return function(tel) {
            if (!tel) {
                return '';
            }

            var value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            var country;
            var city;
            var number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                case 13: // +CCCPPP####### -> CCC (PPP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 6);
                    number = value.slice(6);
                    break;

                default:
                    return tel;
            }

            if (country == 1) {
                country = '';
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (country + ' (' + city + ') ' + number).trim();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('gtEventStartDate', gtEventStartDate);

    function gtEventStartDate() {
        return function( items, value ) {
            var filteredItems = [];

            angular.forEach(items, function( item, cnt ) {
                // if ( cnt > value ) {

                    // to add event, must be past 3rd in index AND date must be current
                    var today = new Date();
                    var eventStartDates = item.startDates.map(function(date) {
                        return new Date(date);
                    });

                    if (eventStartDates.some(function(date) {
                        return date > today;
                    })) {
                        filteredItems.push(item);
                    }
                // }
            });

            return filteredItems;
        };
    }
})();


/* function gtEventStartDate() {
    return function( items, value ) {
        var filteredItems = [];

        angular.forEach(items, function(item, cnt) {
            var today = new Date();
            var eventStartDates = item.startDates.map(function(date) {
                return new Date(date);
            });

            if (eventStartDates.some(function(date) {
                return date > today;
            })) {
                if ((value == 0) && (cnt > 3)) {
                    // if no value provided, return first 3 (upcoming) events past today
                    filteredItems.push(item);
                }

                if ((value > 0) && (cnt < 2)) {
                    // must be greater than 3rd in index AND date must be current
                    filteredItems.push(item);
                }
            }
        });

        return filteredItems;
    };
} */

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('formatTime', formatTime);

    function formatTime() {
        return function(timestamp, withtime) {
            if (!timestamp) {
                return;
            }

            if (withtime) {
                return moment(timestamp).format('lll'); // Jan 12, 2017
            }

            return moment(timestamp).format('ll'); // Jan 12, 2017
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('capitalize', capitalize);

    function capitalize() {
        return function(input, scope) {
            if (input != null) {
                if (input.length >= 1) {
                    input = input.toLowerCase();
                    return input.substring(0, 1).toUpperCase() + input.substring(1);
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('addTargetBlank', addTargetBlank);

    function addTargetBlank(ENV_VARS) {
        return function(content) {
            var tree = angular.element('<div>' + content + '</div>');

            angular.forEach(tree.find('a'), function(element) {
                var anchor = angular.element(element);
                if (isExternalUrl(element.hostname)) {
                    anchor.attr('target', '_blank');
                }
            });

            return angular.element('<div>').append(tree).html();
        };

        function isExternalUrl(hostname) {
            if (!hostname || typeof hostname !== 'string') {
                return false;
            }

            return hostname.search(ENV_VARS.appDomain) < 0;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.directives', []);
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        // .directive('pageTitle', pageTitle)
        // .directive('sideNavigation', sideNavigation)
        // .directive('iboxTools', iboxTools)
        // .directive('minimalizaSidebar', minimalizaSidebar)
        // .directive('vectorMap', vectorMap)
        // .directive('sparkline', sparkline)
        // .directive('icheck', icheck)
        // .directive('ionRangeSlider', ionRangeSlider)
        // .directive('dropZone', dropZone)
        // .directive('responsiveVideo', responsiveVideo)
        // .directive('chatSlimScroll', chatSlimScroll)
        // .directive('customValid', customValid)
        // .directive('fullScroll', fullScroll)
        // .directive('closeOffCanvas', closeOffCanvas)
        // .directive('clockPicker', clockPicker)
        // .directive('landingScrollspy', landingScrollspy)
        // .directive('fitHeight', fitHeight)
        // .directive('iboxToolsFullScreen', iboxToolsFullScreen)
        // .directive('slimScroll', slimScroll)
        // .directive('truncate', truncate)
        // .directive('touchSpin', touchSpin)
        // .directive('markdownEditor', markdownEditor)
        // .directive('categoryName', categoryName)
        // .directive('categorySelect', categorySelect)
        //.directive('numbersExcludingZero', numbersExcludingZero)
        .directive('youtubeEmbed', youtubeEmbed)
        .directive('topnavcollapse', topNavCollapse)
        .filter('cdn', cdnFilter)
        .directive('autofocus', ['$timeout', autofocus]);


    function youtubeEmbed($sce) {
        return {
            restrict: 'EA',
            scope: {
                code: '=',
            },
            replace: true,
            template: '<div style="height:400px;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
            link: function(scope) {
                scope.$watch('code', function(newVal) {
                    if (newVal) {
                        scope.url = $sce.trustAsResourceUrl("http://www.youtube.com/embed/" + newVal);
                    }
                });
            },
        };
    }


    function cdnFilter(ENV_VARS) {
        return function(input) {
            if (!ENV_VARS || !ENV_VARS.s3BucketDomain || !ENV_VARS.cdnDomain) return input;
            return (input || '').replace(ENV_VARS.s3BucketDomain, ENV_VARS.cdnDomain);
        };
    }

    // function numbersExcludingZero() {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element, attrs) {
    //             var ele = element[0];
    //             var regex = new RegExp(attrs.restrictInput);
    //             var value = ele.value;
    //             ele.addEventListener('keyup', function(e) {
    //                 if (regex.test(ele.value)) {
    //                     value = ele.value;
    //                 }
    //                 else {
    //                     ele.value = value;
    //                 }
    //             });
    //         }
    //     };
    // }

    // /**
    //  * pageTitle - Directive for set Page title - mata title
    //  */
    // function pageTitle($rootScope, $timeout) {
    //     return {
    //         link: function(scope, element) {
    //             var listener = function(event, toState, toParams, fromState, fromParams) {
    //                 // Default title - load on Dashboard 1
    //                 var title = 'Vogt-Auction';
    //                 // Create your own title pattern
    //                 if (toState.data && toState.data.pageTitle) title = 'Vogt Auction | ' + toState.data.pageTitle;
    //                 $timeout(function() {
    //                     element.text(title);
    //                 });
    //             };
    //             $rootScope.$on('$stateChangeStart', listener);
    //         }
    //     }
    // }

    // /**
    //  * sideNavigation - Directive for run metsiMenu on sidebar navigation
    //  */
    // function sideNavigation($timeout) {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element) {
    //             // Call the metsiMenu plugin and plug it to sidebar navigation
    //             $timeout(function() {
    //                 element.metisMenu();

    //             });
    //         }
    //     };
    // }

    // /**
    //  * responsibleVideo - Directive for responsive video
    //  */
    // function responsiveVideo() {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element) {
    //             var figure = element;
    //             var video = element.children();
    //             video
    //                 .attr('data-aspectRatio', video.height() / video.width())
    //                 .removeAttr('height')
    //                 .removeAttr('width')

    //             //We can use $watch on $window.innerWidth also.
    //             $(window).resize(function() {
    //                 var newWidth = figure.width();
    //                 video
    //                     .width(newWidth)
    //                     .height(newWidth * video.attr('data-aspectRatio'));
    //             }).resize();
    //         }
    //     }
    // }

    // /**
    //  * iboxTools - Directive for iBox tools elements in right corner of ibox
    //  */
    // function iboxTools($timeout) {
    //     return {
    //         restrict: 'A',
    //         scope: true,
    //         templateUrl: 'app/main/main-ibox_tools.view.html',
    //         controller: function($scope, $element) {
    //             // Function for collapse ibox
    //             $scope.showhide = function() {
    //                 var ibox = $element.closest('div.ibox');
    //                 var icon = $element.find('i:first');
    //                 var content = ibox.find('div.ibox-content');
    //                 content.slideToggle(200);
    //                 // Toggle icon from up to down
    //                 icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    //                 ibox.toggleClass('').toggleClass('border-bottom');
    //                 $timeout(function() {
    //                     ibox.resize();
    //                     ibox.find('[id^=map-]').resize();
    //                 }, 50);
    //             };
    //             // Function for close ibox
    //             $scope.closebox = function() {
    //                 var ibox = $element.closest('div.ibox');
    //                 ibox.remove();
    //             }
    //         }
    //     };
    // }

    // /**
    //  * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
    //  */
    // function iboxToolsFullScreen($timeout) {
    //     return {
    //         restrict: 'A',
    //         scope: true,
    //         templateUrl: 'app/main/main-ibox_tools_full_screen.view.html',
    //         controller: function($scope, $element) {
    //             // Function for collapse ibox
    //             $scope.showhide = function() {
    //                 var ibox = $element.closest('div.ibox');
    //                 var icon = $element.find('i:first');
    //                 var content = ibox.find('div.ibox-content');
    //                 content.slideToggle(200);
    //                 // Toggle icon from up to down
    //                 icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    //                 ibox.toggleClass('').toggleClass('border-bottom');
    //                 $timeout(function() {
    //                     ibox.resize();
    //                     ibox.find('[id^=map-]').resize();
    //                 }, 50);
    //             };
    //             // Function for close ibox
    //             $scope.closebox = function() {
    //                 var ibox = $element.closest('div.ibox');
    //                 ibox.remove();
    //             };
    //             // Function for full screen
    //             $scope.fullscreen = function() {
    //                 var ibox = $element.closest('div.ibox');
    //                 var button = $element.find('i.fa-expand');
    //                 $('body').toggleClass('fullscreen-ibox-mode');
    //                 button.toggleClass('fa-expand').toggleClass('fa-compress');
    //                 ibox.toggleClass('fullscreen');
    //                 setTimeout(function() {
    //                     $(window).trigger('resize');
    //                 }, 100);
    //             }
    //         }
    //     };
    // }

    // /**
    //  * minimalizaSidebar - Directive for minimalize sidebar
    //  */
    // function minimalizaSidebar($timeout) {
    //     return {
    //         restrict: 'A',
    //         //template: '<a class="navbar-minimalize " href="" ng-click="minimalize()"><i class="fa fa-sun-o fa-3x"></i></a>',
    //         template: '<div class="navbar-minimalize " href="" ng-click="minimalize()"><i class="material-icons menu-icon">menu</i></div>',

    //         controller: function($scope, $element) {
    //             $scope.minimalize = function() {
    //                 angular.element('body').toggleClass('mini-navbar');
    //                 if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
    //                     // Hide menu in order to smoothly turn on when maximize menu
    //                     angular.element('#side-menu').hide();
    //                     // For smoothly turn on menu
    //                     $timeout(function() {
    //                         angular.element('#side-menu').fadeIn(500);
    //                     }, 100);
    //                 }
    //                 else {
    //                     // Remove all inline style from jquery fadeIn function to reset menu state
    //                     angular.element('#side-menu').removeAttr('style');
    //                 }
    //             };
    //         }
    //     };
    // };


    // function closeOffCanvas() {
    //     return {
    //         restrict: 'A',
    //         template: '<a class="close-canvas-menu" ng-click="closeOffCanvas()"><i class="fa fa-times"></i></a>',
    //         controller: function($scope, $element) {
    //             $scope.closeOffCanvas = function() {
    //                 $("body").toggleClass("mini-navbar");
    //             }
    //         }
    //     };
    // }

    // /**
    //  * vectorMap - Directive for Vector map plugin
    //  */
    // function vectorMap() {
    //     return {
    //         restrict: 'A',
    //         scope: {
    //             myMapData: '=',
    //         },
    //         link: function(scope, element, attrs) {
    //             var map = element.vectorMap({
    //                 map: 'world_mill_en',
    //                 backgroundColor: "transparent",
    //                 regionStyle: {
    //                     initial: {
    //                         fill: '#e4e4e4',
    //                         "fill-opacity": 0.9,
    //                         stroke: 'none',
    //                         "stroke-width": 0,
    //                         "stroke-opacity": 0
    //                     }
    //                 },
    //                 series: {
    //                     regions: [{
    //                         values: scope.myMapData,
    //                         scale: ["#1ab394", "#22d6b1"],
    //                         normalizeFunction: 'polynomial'
    //                     }]
    //                 },
    //             });
    //             var destroyMap = function() {
    //                 element.remove();
    //             };
    //             scope.$on('$destroy', function() {
    //                 destroyMap();
    //             });
    //         }
    //     }
    // }


    // /**
    //  * sparkline - Directive for Sparkline chart
    //  */
    // function sparkline() {
    //     return {
    //         restrict: 'A',
    //         scope: {
    //             sparkData: '=',
    //             sparkOptions: '=',
    //         },
    //         link: function(scope, element, attrs) {
    //             scope.$watch(scope.sparkData, function() {
    //                 render();
    //             });
    //             scope.$watch(scope.sparkOptions, function() {
    //                 render();
    //             });
    //             var render = function() {
    //                 $(element).sparkline(scope.sparkData, scope.sparkOptions);
    //             };
    //         }
    //     }
    // }

    // /**
    //  * icheck - Directive for custom checkbox icheck
    //  */
    // function icheck($timeout) {
    //     return {
    //         restrict: 'A',
    //         require: 'ngModel',
    //         link: function($scope, element, $attrs, ngModel) {
    //             return $timeout(function() {
    //                 var value;
    //                 value = $attrs['value'];

    //                 $scope.$watch($attrs['ngModel'], function(newValue) {
    //                     $(element).iCheck('update');
    //                 })

    //                 return $(element).iCheck({
    //                     checkboxClass: 'icheckbox_square-green',
    //                     radioClass: 'iradio_square-green'

    //                 }).on('ifChanged', function(event) {
    //                     if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
    //                         $scope.$apply(function() {
    //                             return ngModel.$setViewValue(event.target.checked);
    //                         });
    //                     }
    //                     if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
    //                         return $scope.$apply(function() {
    //                             return ngModel.$setViewValue(value);
    //                         });
    //                     }
    //                 });
    //             });
    //         }
    //     };
    // }

    // /**
    //  * ionRangeSlider - Directive for Ion Range Slider
    //  */
    // function ionRangeSlider() {
    //     return {
    //         restrict: 'A',
    //         scope: {
    //             rangeOptions: '='
    //         },
    //         link: function(scope, elem, attrs) {
    //             elem.ionRangeSlider(scope.rangeOptions);
    //         }
    //     }
    // }

    // /**
    //  * dropZone - Directive for Drag and drop zone file upload plugin
    //  */
    // function dropZone() {
    //     return {
    //         restrict: 'C',
    //         link: function(scope, element, attrs) {

    //             var config = {
    //                 url: 'http://localhost:8080/upload',
    //                 maxFilesize: 100,
    //                 paramName: "uploadfile",
    //                 maxThumbnailFilesize: 10,
    //                 parallelUploads: 1,
    //                 autoProcessQueue: false
    //             };

    //             var eventHandlers = {
    //                 'addedfile': function(file) {
    //                     scope.file = file;
    //                     if (this.files[1] != null) {
    //                         this.removeFile(this.files[0]);
    //                     }
    //                     scope.$apply(function() {
    //                         scope.fileAdded = true;
    //                     });
    //                 },

    //                 'success': function(file, response) {}

    //             };

    //             dropzone = new Dropzone(element[0], config);

    //             angular.forEach(eventHandlers, function(handler, event) {
    //                 dropzone.on(event, handler);
    //             });

    //             scope.processDropzone = function() {
    //                 dropzone.processQueue();
    //             };

    //             scope.resetDropzone = function() {
    //                 dropzone.removeAllFiles();
    //             }
    //         }
    //     }
    // }

    // /**
    //  * chatSlimScroll - Directive for slim scroll for small chat
    //  */
    // function chatSlimScroll($timeout) {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element) {
    //             $timeout(function() {
    //                 element.slimscroll({
    //                     height: '234px',
    //                     railOpacity: 0.4
    //                 });

    //             });
    //         }
    //     };
    // }

    // /**
    //  * customValid - Directive for custom validation example
    //  */
    // function customValid() {
    //     return {
    //         require: 'ngModel',
    //         link: function(scope, ele, attrs, c) {
    //             scope.$watch(attrs.ngModel, function() {

    //                 // You can call a $http method here
    //                 // Or create custom validation

    //                 var validText = "Vogt-Auction";

    //                 if (scope.extras == validText) {
    //                     c.$setValidity('cvalid', true);
    //                 }
    //                 else {
    //                     c.$setValidity('cvalid', false);
    //                 }

    //             });
    //         }
    //     }
    // }


    // /**
    //  * fullScroll - Directive for slimScroll with 100%
    //  */
    // /**
    // function fullScroll($timeout){
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element) {
    //             $timeout(function(){
    //                 element.slimscroll({
    //                     height: '100%',
    //                     railOpacity: 0.9
    //                 });

    //             });
    //         }
    //     };
    // }
    // **/
    // /**
    //  * slimScroll - Directive for slimScroll with custom height
    //  */
    // /**
    // function slimScroll($timeout){
    //     return {
    //         restrict: 'A',
    //         scope: {
    //             boxHeight: '@'
    //         },
    //         link: function(scope, element) {
    //             $timeout(function(){
    //                 element.slimscroll({
    //                     height: scope.boxHeight,
    //                     railOpacity: 0.9
    //                 });

    //             });
    //         }
    //     };
    // }
    // **/
    // /**
    //  * clockPicker - Directive for clock picker plugin
    //  */
    // function clockPicker() {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element) {
    //             element.clockpicker();
    //         }
    //     };
    // }


    // /**
    //  * landingScrollspy - Directive for scrollspy in landing page
    //  */
    // function landingScrollspy() {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element, attrs) {
    //             element.scrollspy({
    //                 target: '.navbar-fixed-top',
    //                 offset: 80
    //             });
    //         }
    //     }
    // }

    // /**
    //  * fitHeight - Directive for set height fit to window height
    //  */
    // function fitHeight() {
    //     return {
    //         restrict: 'A',
    //         link: function(scope, element) {
    //             element.css("height", $(window).height() + "px");
    //             element.css("min-height", $(window).height() + "px");
    //         }
    //     };
    // }

    // /**
    //  * truncate - Directive for truncate string
    //  */
    // function truncate($timeout) {
    //     return {
    //         restrict: 'A',
    //         scope: {
    //             truncateOptions: '='
    //         },
    //         link: function(scope, element) {
    //             $timeout(function() {
    //                 element.dotdotdot(scope.truncateOptions);

    //             });
    //         }
    //     };
    // }


    // /**
    //  * touchSpin - Directive for Bootstrap TouchSpin
    //  */
    // function touchSpin() {
    //     return {
    //         restrict: 'A',
    //         scope: {
    //             spinOptions: '='
    //         },
    //         link: function(scope, element, attrs) {
    //             scope.$watch(scope.spinOptions, function() {
    //                 render();
    //             });
    //             var render = function() {
    //                 $(element).TouchSpin(scope.spinOptions);
    //             };
    //         }
    //     }
    // }

    // /**
    //  * markdownEditor - Directive for Bootstrap Markdown
    //  */
    // function markdownEditor() {
    //     return {
    //         restrict: "A",
    //         require: 'ngModel',
    //         link: function(scope, element, attrs, ngModel) {
    //             $(element).markdown({
    //                 savable: false,
    //                 onChange: function(e) {
    //                     ngModel.$setViewValue(e.getContent());
    //                 }
    //             });
    //         }
    //     }
    // }

    // function categoryName(categoryService) {
    //     return {
    //         restrict: 'AE',
    //         replace: true,
    //         scope: {
    //             id: '@'
    //         },
    //         template: '<span>{{category.name}}</span>',
    //         link: function(scope, elem) {
    //             categoryService.getById(scope.id).then(function(response){
    //                 scope.category = response;
    //             });
    //         }
    //     }
    // }

    // function categorySelect(categoryService) {
    //     return {
    //         replace: true,
    //         restrict: 'E',
    //         scope: {
    //             selectedCategoryId: '='
    //         },
    //         template:
    //         '<select name="categoryId" id="categoryId" ng-model="selectedCategoryId" class="form-control input-lg" required>' +
    //         '<option value="">-- Select a Category --</option>' +
    //         '<option ng-repeat="category in categories track by $index" value="{{category._id}}">{{category.name}}</option>' +
    //         '</select>',
    //         link: function(scope, elem) {
    //             categoryService.getAll(1000, 1, '+name').then(function(response) {
    //                 if (response.data) {
    //                     scope.categories = response.data;
    //                 }
    //             });
    //         }
    //     }
    // }

    // function categoryToggle(categoryService) {
    //     return {
    //         replace: false,
    //         restrict: 'E',
    //         scope: {
    //             categories: '=',
    //             onChange: '='
    //         },
    //         template:
    //         '<span ng-click="onClick()" ng-repeat="category in categories track by $index">' +
    //         '<button type="button" class="btn btn-primary btn-upper m-t-xs m-r-xs" ng-model="category.selected" bs-checkbox>{{category.name}}</button>' +
    //         '</span>',
    //         controller: function($scope) {
    //             categoryService.getAll(1000, 1, '+name').then(function(response) {
    //                 if (response.data) {
    //                     $scope.categories = response.data;
    //                     // fire change handler once with all categories for default state
    //                     $scope.onChange($scope.categories);
    //                 }
    //             });
    //             $scope.onClick = function() {
    //                 $scope.onChange($scope.categories.filter(function(c) { return c.selected === true }));
    //             }
    //         }
    //     }
    // }


    // topNavCollapse - Directive to collapse and change look of header navbar on scroll
    function topNavCollapse($window) {
        return function(scope, element, attrs) {
            angular.element($window).bind('scroll', function() {
                if ($window.pageYOffset >= 75) {
                    scope.boolChangeClass = true;
                }
                else {
                    scope.boolChangeClass = false;
                }
                scope.$apply();
            });
        };
    }


    // autofocus - Directive
    function autofocus($timeout) {
        return {
            restrict: 'A',
            link: function($scope, $element) {
                $timeout(function() {
                    $element[0].focus();
                });
            },
        };
    }
})();

/**
 *
 * Main directives.js file
 * Define directives for used plugin
 *
 *
 * Functions (directives)
 *  - sideNavigation
 *  - iboxTools
 *  - minimalizaSidebar
 *  - vectorMap
 *  - sparkline
 *  - icheck
 *  - ionRangeSlider
 *  - dropZone
 *  - responsiveVideo
 *  - chatSlimScroll
 *  - customValid
 *  - fullScroll
 *  - closeOffCanvas
 *  - clockPicker
 *  - landingScrollspy
 *  - fitHeight
 *  - iboxToolsFullScreen
 *  - slimScroll
 *  - truncate
 *  - touchSpin
 *  - markdownEditor
 *  - resizeable
 *
 */

(function() {
    'use strict';

    angular.module('auth.signup', []);
})();


(function() {
    'use strict';

    angular
        .module('auth.signup')
        .config(signupRouteConfig);

    function signupRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('signup', {
            controller: 'SignupController',
            controllerAs: 'vm',
            parent: 'auth',
            templateUrl: 'app/auth/signup/signup.view.html',
            url: 'signup?token',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.signup)
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('auth.signup')
        .controller('SignupController', SignupController);

    function SignupController($log, $scope, $rootScope, $state, Session, authService, emailService, passService, formsService, flashService, usernameService, Notification, REDIRECT) {
        var vm = this;

        // ViewModel Properties
        vm.isModal = ($state.current.name === 'auction-item');
        vm.user = {};
        vm.secondStep = false;

        // ViewModel Methods
        vm.isEmail = emailService.isEmail;
        vm.isEmailUnique = emailService.isEmailUnique;
        vm.isPasswordConfirmed = passService.isPasswordConfirmed;
        vm.isUsernameValid = usernameService.isUsernameValid;
        vm.isUsernameUnique = usernameService.isUsernameUnique;
        vm.onSubmit = handleSubmit;
        vm.onNext = handleNext;
        vm.onBack = handleBack;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        (function init() {
            $scope.isDataLoading = false;

            // reset login status - ensure user is logged out on controller load
            // user should never get to /signup when authenticaed - this is precaution
            Session.destroy();
        })();


        // Private Methods
        // handleNext
        function handleNext() {
            vm.secondStep = true;
        }

        // handleBack
        function handleBack() {
            vm.secondStep = false;
        }

        // handleSubmit
        function handleSubmit() {
            $scope.isDataLoading = true;

            var user = angular.copy(vm.user);

            return authService.signup(user)
                .then(function(response) {
                    $scope.isDataLoading = false;
                    $rootScope.setCurrentUser(response);

                    if (!vm.isModal) {
                        $state.go(REDIRECT.BID);
                    }
                    else {
                        $rootScope.$broadcast('UserUpdate');
                    }

                    $log.debug('SignupController.handleSubmit-success:\n', response);
                    Notification.success('You\'ve Successfully Signed Up!');
                    flashService.clear();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('SignupController.handleSubmit-error:\n', error);
                    flashService.error(error.message);
                });
        }
    };
})();

(function() {
    'use strict';

    angular
        .module('auth.login')
        .config(loginRouteConfig);

    function loginRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('login', {
            controller: 'LoginController',
            controllerAs: 'vm',
            parent: 'auth',
            templateUrl: 'app/auth/login/login.view.html',
            url: 'login',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.login)
            }
        })

        .state('forgotpw', {
            url: 'login/forgot',
            templateUrl: 'app/auth/login/forgot/login-forgot.view.html',
            controller: 'LoginForgotController',
            controllerAs: 'vm',
            parent: 'auth',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.forgotpassword)
            }
        })

        .state('resetpw', {
            templateUrl: 'app/auth/login/reset/login-reset.view.html',
            controller: 'LoginResetController',
            controllerAs: 'vm',
            parent: 'auth',
            url: '/login/reset',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.resetpassword)
            }
        })
        .state('resetpwtoken', {
            controller: 'LoginResetController',
            controllerAs: 'vm',
            parent: 'auth',
            templateUrl: 'app/auth/login/reset/login-reset.view.html',
            url: 'login/reset/?token',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.resetpassword)
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('auth.login')
        .controller('LoginController', LoginController);

    function LoginController($scope, $rootScope, $state, $log, authService, Session, formsService, flashService, Notification, REDIRECT) {
        var vm = this;

        // ViewModel Properties
        vm.isModal = ($state.current.name === 'auction-item');
        vm.user = {};

        // ViewModel Methods
        vm.onSubmit = handleSubmit;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        (function init() {
            $scope.isDataLoading = false;

            // reset login status - ensure user is logged out on controller load
            // user should never get to /login when authenticaed - this is precaution
            Session.destroy();
        })();


        // Private Methods
        // handleSubmit
        function handleSubmit() {
            $scope.isDataLoading = true;

            return authService.login(vm.user)
                .then(function(response) {
                    $scope.isDataLoading = false;
                    $rootScope.setCurrentUser(response);

                    if (!vm.isModal) {
                        $state.go(REDIRECT.BID);
                    }
                    else {
                        $rootScope.$broadcast('UserUpdate');
                    }

                    $log.debug('LoginController.handleSubmit-success:\n', response);
                    Notification.success('Login Success!');
                    flashService.clear();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('LoginController.handleSubmit-error:\n', error);
                    flashService.error(error.message);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('account.settings', []);
})();

(function() {
    'use strict';

    angular
        .module('account.settings')
        .config(settingsRouteConfig);

    function settingsRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('settings', {
            controller: 'SettingsController',
            controllerAs: 'vm',
            parent: 'account',
            templateUrl: 'app/account/settings/settings.view.html',
            url: 'settings',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.settings)
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('account.settings')
        .controller('SettingsController', SettingsController);

    function SettingsController($q, $log, $scope, $rootScope, Session, formsService, passService, flashService, usernameService, Notification, accountRepository, userRepository) {
        var vm = this;

        // ViewModel Properties
        vm.account = {};
        vm.user = {};
        vm.confirmPassword = '';
        vm.password = '';
        vm.orginalUsername = null;

        // ViewModel Methods
        vm.isPasswordConfirmed = passService.isPasswordConfirmed;
        vm.onSubmit = handleSubmit;
        vm.isUsernameValid = usernameService.isUsernameValid;
        vm.isUsernameUnique = usernameService.isUsernameUnique;

        // error handling utility
        $scope.canSave = formsService.canSave;
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;


        (function init() {
            $scope.isDataLoading = false;

            getUser();
        })();


        // Private Methods
        // getUser
        function getUser() {
            $scope.isDataLoading = true;

            var promises = [
                accountRepository.getMy(),
                userRepository.getMy()
            ];

            return $q.all(promises)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    $log.debug('SettingsController.getUser-success:\n', response);

                    var tmpAccount = response[0];
                    vm.account = {
                        name: tmpAccount.name,
                        phone: tmpAccount.phone,
                        address1: tmpAccount.address1,
                        address2: tmpAccount.address2,
                        city: tmpAccount.city,
                        state: tmpAccount.state,
                        zipcode: tmpAccount.zipcode,
                    };

                    vm.orginalUsername = response[1].username;
                    vm.user = {
                        email: response[1].email,
                        username: response[1].username
                    };
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('SettingsController.getUser-error:\n', error);
                    Notification.error('There was an error loading the user.');
                });
        }

        // changePassword
        function changePassword() {
            $scope.isDataLoading = true;

            return userRepository.changeMyPassword(vm.password)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    $log.debug('SettingAdminProfileController.changePassword-success:\n', response);
                    Notification.success('Password Successfully Updated!');
                    flashService.clear();
                })
                .catch(function(error) {
                    $log.error('SettingAdminProfileController.changePassword-error:\n', error);
                    flashService.error('There was an error updating the password.');
                });
        }

        // handleSubmit
        function handleSubmit() {
            $scope.isDataLoading = true;

            var promises = [];
            promises.push(accountRepository.updateMy(vm.account));
            promises.push(userRepository.updateMy(vm.user));

            return $q.all(promises)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    $log.debug('SettingAdminProfileController.handleSubmit-success:\n', response);

                    if (vm.password) {
                        changePassword();
                    }

                    // update global currentUser object
                    vm.orginalUsername = response[1].username;
                    var user = {
                        email: response[1].email,
                        _id: response[1]._id,
                        name: response[0].name,
                        phone: response[0].phone,
                        username: response[1].username
                    };

                    Session.setUser(user);
                    $rootScope.setCurrentUser(user);

                    Notification.success('Profile Successfully Updated!');
                    flashService.clear();
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('SettingAdminProfileController.handleSubmit-error:\n', error);
                    flashService.error(error.message);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('account.bid')
        .config(bidRouteConfig);

    function bidRouteConfig($stateProvider, metaTagsDataProvider) {

        var metaTagsData = metaTagsDataProvider.getMetaTagsData();
        var defaultMeta = metaTagsData.defaultMeta;

        $stateProvider

        .state('bid', {
            controller: 'BidController',
            controllerAs: 'vm',
            parent: 'account',
            templateUrl: 'app/account/bid/bid.view.html',
            url: 'my-bids',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.mybids)
            }
        })

        .state('bid-photos', {
            onEnter: function($state, $stateParams, modalService) {
                if ($stateParams.bid && typeof $stateParams.bid._id === 'string') {
                    modalService.show(
                        'app/account/bid/bid-photos/bid-photos.modal.html',
                        'BidPhotosController'
                    );
                }
                else {
                    $state.go('bid');
                }
            },
            params: {
                bid: null,
            },
            parent: 'bid',
            url: '/photos',
            data: {
                meta: Object.assign({}, defaultMeta, metaTagsData.mybids)
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('account.bid')
        .controller('BidController', BidController);

    function BidController($log, $scope, $rootScope, $timeout, $state, modalService, bidRepository, Notification, itemRepository, auctionRepository) {
        var vm = this;

        // ViewModel Properties
        vm.bids = [];
        vm.activePanel = 0;


        // ViewModel Methods
        vm.onImageClick = handleImageClick;
        vm.onCancel = handleCancel;
        vm.onEdit = handleEdit;

        // Event listeners
        $scope.$on('BidListUpdate', getMyBids);


        (function init() {
            $scope.isDataLoading = false;
            getMyBids();
        })();


        // Private Methods
        // getMyBids
        function getMyBids() {
            $scope.isDataLoading = true;

            return bidRepository.listMyBids($rootScope.currentUser.email)
                .then(function(response) {
                    $scope.isDataLoading = false;
                    vm.bids = response;

                    getItem();

                    $log.debug('vm.bids:\n', vm.bids);

                    //$log.debug('BidController.getBids-success:\n', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('BidController.getBids-error:\n', error);
                    Notification.error('There was an error loading the bids.');
                });
        }

        // getItem
        function getItem() {
            //$scope.isDataLoading = true;

            _.forEach(vm.bids, function(bid, index) {

                return itemRepository.find(bid.item.id)
                    .then(function(response) {
                        $scope.isDataLoading = false;
                        var item = response;

                        vm.bids[index].items = item;

                        getAuction(item, index);

                        $log.debug('BidController.getItem-success:\n', response);
                    })
                    .catch(function(error) {
                        $scope.isDataLoading = false;
                        return;
                        // $log.error('BidController.getItem-error:\n', error);
                        // Notification.error('There was an error loading the item.');
                    });
            });
        }

        // getAuction
        function getAuction(item, index) {

            return auctionRepository.find(item.events[0].id)
                .then(function(response) {
                    $scope.isDataLoading = false;
                    var auction = response;

                    // check how much time before auction start
                    var timesBefore = auction.startDates.map(function(date) {
                        return moment(date).diff(moment(), 'minutes');
                    });

                    if (timesBefore.every(function(time) {
                        return time < -480;
                    })) {
                        auction.isPast = true;
                    }
                    else if (timesBefore.some(function(time) {
                        return time < 60;
                    })) {
                        auction.isLive = true;
                    }

                    vm.bids[index].auction = auction;


                    //$log.debug('BidController.getAuction-success:\n', response);
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;
                    return;
                    // $log.error('BidController.getAuction-error:\n', error);
                    // Notification.error('There was an error loading the auction.');
                });
        }

        // handleImageClick
        function handleImageClick(bid) {
            $.fancybox.open(bid.items.featuredImagesUrls.map(function(url, index) {
                return {
                    src: url.md,
                    type: 'image',
                    opts: {
                        caption: 'LOT #' + bid.items.lot + ': ' + bid.items.title + '<br>' + (index+1) + '/' + bid.items.featuredImagesUrls.length
                    }
                };
            }));
        }

        // handleCancel
        function handleCancel(bidId, itemId) {
            if (confirm('Are you sure you want to cancel your bid?')) {
                $scope.isDataLoading = true;

                return bidRepository.deleteOneBid(bidId, itemId)
                    .then(function(response) {
                        $scope.isDataLoading = false;

                        modalService.hide();

                        $rootScope.$broadcast('BidListUpdate');

                        $log.debug('BidPhotosController.handleCancel-success:', response);
                        Notification.success('Bid deleted.');
                    })
                    .catch(function(error) {
                        $scope.isDataLoading = false;

                        $log.error('BidPhotosController.handleCancel-error:', error);
                        Notification.error('There was an error deleting the bid.');
                    });
            }
        }

        // handleEdit
        function handleEdit(auctionSlug, itemSlug) {
            // $log.debug('auctionSlug:', auctionSlug);
            // $log.debug('itemSlug:', itemSlug);
            $scope.isDataLoading = false;

            modalService.hide(false);

            var params = {
                auctionSlug: auctionSlug,
                itemSlug: itemSlug
            };

            $timeout(function() {
                $state.go('auction-item', params);
            }, 500);
        }

    }
})();

(function() {
    'use strict';

    angular.module('public', [
        'public.about',
        'public.auction',
        'public.assets',
        'public.blog',
        'public.category',
        'public.home',
        'public.pages',
    ]);
})();

(function() {
    'use strict';

    angular
        .module('public')
        .controller('PublicController', PublicController);

    function PublicController($log, $scope, contactRepository, subscriptionRepository, modalService, formsService, flashService, Notification) {
        var vm = this;

        // ViewModel Properties
        vm.message = {};
        vm.subscriber = {};

        // ViewModel Methods
        vm.onContactClick = handleContactClick;
        vm.onSubscribeClick = handleSubscribeClick;
        vm.onContactSubmit = handleContactSubmit;
        vm.onSubscribeSubmit = handleSubscribeSubmit;
        vm.onHideClick = handleHideClick;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        (function init() {
            $scope.isDataLoading = false;
            flashService.clear();
        })();


        // Private Methods
        // handleContactClick
        function handleContactClick() {
            modalService.show(
                'app/public/public-contact.modal.html',
                PublicController,
                false
            );
        }

        // handleSubscribeClick
        function handleSubscribeClick() {
            modalService.show(
                'app/public/public-subscribe.modal.html',
                PublicController,
                false
            );
        }

        // handleContactSubmit
        function handleContactSubmit() {
            $scope.isDataLoading = true;

            $log.debug('handleContactSubmit');

            return contactRepository.create(vm.message)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    modalService.hide();

                    $log.debug('PublicController.handleContactSubmit-success:\n', response);
                    Notification.success('Message Successfully Sent!');
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('PublicController.handleContactSubmit-error:\n', error);
                    flashService.error('There was an error sending the message.');
                });
        }

        // handleSubscribeSubmit
        function handleSubscribeSubmit() {
            $scope.isDataLoading = true;

            return subscriptionRepository.create(vm.subscriber)
                .then(function(response) {
                    $scope.isDataLoading = false;

                    modalService.hide();

                    $log.debug('PublicController.handleSubscribeSubmit-success:\n', response);
                    Notification.success('Subscriber Successfully Added!');
                })
                .catch(function(error) {
                    $scope.isDataLoading = false;

                    $log.error('PublicController.handleSubscribeSubmit-error:\n', error);
                    flashService.error('There was an error creating the subscriber.');
                });
        }

        // handleHideClick
        function handleHideClick() {
            $scope.isDataLoading = true;

            $log.debug('handleHideClick');

            modalService.hide();
        }
    }
})();

(function() {
    'use strict';

    angular.module('main', []);
})();

(function() {
    'use strict';

    angular
        .module('main')
        .controller('MainController', MainController);

    function MainController($log, $scope, $rootScope, $aside, Session, authService, modalService, categoriesRepository, taxonomyService,
        Notification, REDIRECT, ENV_VARS, HIGHLIGHT_TYPE) {
        var vm = this;

        // ViewModel Properties
        vm.asideMobile = false;

        // ViewModel Methods
        vm.getNumber = getNumber;
        vm.isAuthenticated = authService.isAuthenticated;
        vm.isAuthorized = authService.isAuthorized;
        vm.onLogoutClick = handleLogoutClick;
        vm.onToggleClick = handleToggleClick;

        // GLOBAL ENV VARS
        $rootScope.appName = ENV_VARS.appName; // app name from gulp file json
        $rootScope.appDesc = ENV_VARS.appDesc; // app description from gulp file json
        $rootScope.categories = [];
        $rootScope.currentUser = {};
        $rootScope.setCurrentUser = handleCurrentUserSet;
        $rootScope.PATH = REDIRECT;
        $rootScope.HIGHLIGHT_TYPE = HIGHLIGHT_TYPE;

        // we set these for page refresh
        if (vm.isAuthenticated()) {
            if (Session.user) {
                $rootScope.currentUser = Session.user;
                $log.debug('MainController.$rootScope.currentUser:\n', $rootScope.currentUser);

            }
        }


        (function init() {
            getCategories();
        })();


        // Private Properties
        var aside = $aside({
            onHide: handleSidebarHide,
            onBeforeShow: handleSidebarShow,
            scope: $scope,
            show: false,
            templateUrl: 'app/public/public-sidebar.view.html',
        });

        // Private Methods
        // handleCurrentUserSet
        function handleCurrentUserSet(user) {
            $rootScope.currentUser = user;
        }

        // handleLogoutClick
        function handleLogoutClick() {
            authService.logout();
        }

        // handleSidebarHide
        function handleSidebarHide() {
            vm.asideMobile = false;
        }

        // handleSidebarShow
        function handleSidebarShow() {
            vm.asideMobile = true;
        }

        // handleToggleClick
        function handleToggleClick() {
            aside.$promise.then(function() {
                aside.show();
            });
        }


        // STATE CHANGE
        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            // hide left aside
            aside.$promise.then(function() {
                aside.hide();
            });

            // hide modal window
            modalService.hide(false);
        });

        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            // set unique id on body tag for any state we specify in routes files
            if (toState.data) {
                vm.bodyClass = toState.data.bodyClass ? toState.data.bodyClass : '';
                vm.wrapClass = toState.data.wrapClass ? toState.data.wrapClass : '';
            }

            // scroll to the top of page if there is no modal windows on enter
            if (!toState.onEnter && (!fromState.onEnter || fromState.parent !== toState.name)) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
        });


        // getCategories
        function getCategories() {
            return categoriesRepository.list()
                .then(function(response) {
                    $log.debug('MainController.getCategories-success:\n', response);

                    var catsWithLevel = taxonomyService.group(response.data);

                    // TODO: define parent category by something else
                    $rootScope.categories = catsWithLevel[0].children;
                })
                .catch(function(error) {
                    $log.error('MainController.getCategories-error:\n', error);
                    Notification.error('There was an error loading Categories.');
                });
        }

        // getNumber
        function getNumber(num) {
            return new Array(num);
        }
    }
})();

(function() {
    'use strict';

    angular.module('auth', [
        'auth.login',
        'auth.signup'
    ]);
})();

(function() {
    'use strict';

    angular.module('account', [
        'account.bid',
        'account.settings'
    ]);
})();

(function() {
    'use strict';

    angular.module('app', [
        '720kb.socialshare',
        'angular-carousel',
        'angular-google-analytics',
        'angular.filter',
        'infinite-scroll',
        'LocalStorageModule',
        'mgcrea.ngStrap',
        'ngAnimate',
        'ngMap',
        'ngMessages',
        'ngMeta',
        'ngSanitize',
        'ngTouch',
        'ui-notification',
        'ui.router',
        'ui.router.title',
        'ui.utils.masks',
        'ui.validate',
        'youtube-embed',
        'wipImageZoom',
        'ngMask',
        // setup
        'app.env',
        'app.directives',
        'app.filters',
        'app.services',
        'main',
        // pages
        'account',
        'auth',
        'public'
    ]);
})();

(function() {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    function runBlock(ngMeta, authService, accountRepository) {
        // seo - meta tags
        ngMeta.init();

        // GET EXISTING SESSION
        // persist user session data on page refresh
        authService.getSession();

        if (authService.isAuthenticated()) {
            //accountRepository.updateCache();
        }

    }
})();

(function () {
    "use strict";

    angular.module("app").config(routeConfig);

    function routeConfig(
        $stateProvider,
        $urlRouterProvider,
        $urlMatcherFactoryProvider
    ) {
        // redirects
        $urlMatcherFactoryProvider.strictMode(false);
        $urlMatcherFactoryProvider.caseInsensitive(true);

        $urlRouterProvider.when(
            "/SSAbenefit",
            "auctions/ssa-benefit-art-auction"
        );
        $urlRouterProvider.when(
            "/ssabenefit",
            "auctions/ssa-benefit-art-auction"
        );
        $urlRouterProvider.when("/texas", "category/texas-western-art");
        $urlRouterProvider.when(
            "/category/texas",
            "category/texas-western-art"
        );
        $urlRouterProvider.when(
            "/category/texas-art",
            "category/texas-western-art"
        );
        $urlRouterProvider.when("/western", "category/texas-western-art");
        $urlRouterProvider.when(
            "/category/western-arts",
            "category/texas-western-art"
        );
        $urlRouterProvider.when("/luxury", "category/luxury");
        $urlRouterProvider.when("/antiques", "category/antiques");
        $urlRouterProvider.when(
            "/agarita",
            "auctions/real-estate-auction-101-e-agarita-107-e-agarita-in-monte-vis"
        );
        $urlRouterProvider.when(
            "/gharvey",
            "auctions/western-arts-auction-featuring-the-estate-of-g-harvey"
        );
        // $urlRouterProvider.when('/blog', 'company/blog');
        // $urlRouterProvider.when('/blog/:slug', 'company/blog/:slug');
        // $urlRouterProvider.when('/latest-news', 'company/news');
        // $urlRouterProvider.when('/about', 'company/team');
        // $urlRouterProvider.when('/products/oligo-pools', 'products/pools');
        // $urlRouterProvider.when('/events', 'company/events');
        // $urlRouterProvider.when('/contact-us', 'contact');
        // $urlRouterProvider.when('/Oligo_Pools/CRISPR_Screens', 'products/pools');
        // $urlRouterProvider.when('/gene_fragments', 'products/genes#geneFragments');
        // $urlRouterProvider.when('/CRISPR_screening_oligo_pools', 'products/pools');

        // $urlRouterProvider.when('/press-releases', 'company/news');
        // $urlRouterProvider.when('/press', 'company/news');
        // $urlRouterProvider.when('/press-releases/:slug', 'company/press/:slug');
        // $urlRouterProvider.when('/press/:slug', 'company/press/:slug');

        $stateProvider

            // MAIN
            .state("main", {
                abstract: true,
                templateUrl: "app/main/main.view.html",
                url: "/",
            })

            // TEMPLATES
            .state("account", {
                abstract: true,
                data: {
                    wrapClass: "site-wrap-account",
                },
                parent: "main",
                resolve: {
                    account: function (authSecurityService) {
                        return authSecurityService.requireAccountUser();
                    },
                },
                views: {
                    content: {
                        templateUrl: "app/account/account.view.html",
                    },
                    footer: {
                        controller: "PublicController",
                        controllerAs: "vm",
                        templateUrl: "app/account/account-footer.view.html",
                    },
                    header: {
                        templateUrl: "app/account/account-header.view.html",
                    },
                    subheader: {
                        templateUrl: "app/account/account-subheader.view.html",
                    },
                },
            })

            .state("auth", {
                abstract: true,
                data: {
                    wrapClass: "site-wrap-auth",
                },
                parent: "main",
                resolve: {
                    unAuthenticatedUser: function (authSecurityService) {
                        return authSecurityService.requireUnauthenticatedUser();
                    },
                },
                views: {
                    content: {
                        templateUrl: "app/auth/auth.view.html",
                    },
                },
            })

            .state("public", {
                abstract: true,
                data: {
                    wrapClass: "site-wrap-public",
                },
                parent: "main",
                views: {
                    content: {
                        templateUrl: "app/public/public.view.html",
                    },
                    footer: {
                        controller: "PublicController",
                        controllerAs: "vm",
                        templateUrl: "app/public/public-footer.view.html",
                    },
                    header: {
                        templateUrl: "app/public/public-header.view.html",
                    },
                    subheader: {
                        templateUrl: "app/public/public-subheader.view.html",
                    },
                },
            })

            // SERVICE PAGES
            .state("404client", {
                data: {
                    wrapClass: "site-wrap-404",
                },
                parent: "main",
                resolve: {
                    $title: function () {
                        return "Page Not Found";
                    },
                },
                views: {
                    content: {
                        templateUrl: "app/main/main-404.view.html",
                    },
                },
                url: "*path",
            })

            .state("404server", {
                data: {
                    wrapClass: "site-wrap-404",
                },
                parent: "main",
                resolve: {
                    $title: function () {
                        return "Page Not Found";
                    },
                },
                views: {
                    content: {
                        templateUrl: "app/main/main-404.view.html",
                    },
                },
            });

        // function applyRedirects(prefix, urls) {
        //     (urls || []).forEach(function(url) {
        //         $urlRouterProvider.when(url, prefix + url);
        //     });
        // }
    }
})();

angular.module("app.env", [])
.constant("ENV_VARS", {
    "appName": "Vogt Auction (Staging)",
    "appDesc": "",
    "appDomain": "vogtauction.scaliolabs.com",
    "apiUrl": "https://vogtauction-api.scaliolabs.com/",
    "debug": "true",
    "version": "1.0.0",
    "s3BucketDomain": "vogtauction-stg-content.s3.amazonaws.com",
    "cdnDomain": "vogtauction-stg-content.s3.amazonaws.com"
});

(function() {
    'use strict';

    angular
        .module('app')
        .constant('REDIRECT', {
            BID: 'bid',
            HOME: 'home',
            LOGIN: 'login',
            SETTINGS: 'settings',
            SIGNUP: 'signup'
        })
        .constant('HIGHLIGHT_TYPE', {
            EVENT: 'Event',
            PAGE: 'Page',
            VIDEO: 'Video',
        })
        .factory('API', function(ENV_VARS) {
            return {
                BASE_URL: ENV_VARS.apiUrl, // controlled from /config/app.env-vars.json file
                ACCOUNTS: 'api/accounts',
                ASSETS: 'api/assets',
                BIDS: 'api/bids',
                BLOG: 'api/blog',
                CATEGORIES: 'api/categories',
                CONTACT: 'api/contact',
                EVENTS: 'api/events',
                HIGHLIGHTS: 'api/highlights',
                ITEMS: 'api/items',
                LOGIN: 'api/login',
                LOGIN_FORGOT: 'api/login/forgot',
                LOGIN_RESET: 'api/login/reset',
                LOGOUT: 'api/logout',
                PAGES: 'api/pages',
                SIGNUP: 'api/signup',
                SIGNUP_INVITATION: 'api/signup/invitation',
                SPECIALTIES: 'api/specialties',
                SUBSCRIPTION: 'api/newsletter',
                TEAM: 'api/team',
                USERS: 'api/users'
            };
        });
})();

(function () {
    "use strict";

    angular.module("app").config(config);

    function config(
        $logProvider,
        $locationProvider,
        $httpProvider,
        $asideProvider,
        $modalProvider,
        $tooltipProvider,
        $dropdownProvider,
        $titleProvider,
        NotificationProvider,
        AnalyticsProvider,
        ENV_VARS
    ) {
        // LOGGING (turn on/off globally)
        if (ENV_VARS.debug === "true") {
            $logProvider.debugEnabled(true);
        } else {
            $logProvider.debugEnabled(false);
        }

        // CLEAN URLS
        $locationProvider.hashPrefix("!");
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
        });

        // AUTH INTERCEPTOR SERVICE (SNIFF FOR 401s)
        $httpProvider.interceptors.push("authInterceptorService");
        // RESPONSE INTERCEPTOR SERVICE (SNIFF FOR 404s)
        $httpProvider.interceptors.push("responseInterceptorService");

        // UI-NOTIFICATION
        NotificationProvider.setOptions({
            replaceMessage: true,
            startTop: 15,
            startRight: 20,
        });

        // ANGULAR STRAP ASIDE DEFAULTS
        angular.extend($asideProvider.defaults, {
            animation: "am-fade-and-slide-top",
            container: "body",
            html: true,
        });

        // ANGULAR STRAP MODAL DEFAULTS
        angular.extend($modalProvider.defaults, {
            animation: "none",
            container: "body",
            html: true,
        });

        // ANGULAR STRAP TOOLTIP DEFAULTS
        angular.extend($tooltipProvider.defaults, {
            container: "body",
        });

        // ANGULAR STRAP DROPDOWN DEFAULTS
        angular.extend($dropdownProvider.defaults, {
            container: "self",
            delay: {
                show: 0,
                hide: 200,
            },
            placement: "bottom",
            trigger: "hover",
        });

        // PAGE TITLE
        $titleProvider.documentTitle(function ($rootScope) {
            var title = $rootScope.ngMeta.title;
            var appName = ENV_VARS.appName;
            return title
                ? title.search(appName) >= 0
                    ? title
                    : title + " | " + appName
                : appName;
        });

        // Google analytics
        // GoogleAnalyticsKey must be added to `config/app.env-vars.json`
        if (ENV_VARS.googleAnalyticsKey) {
            AnalyticsProvider.setAccount(ENV_VARS.googleAnalyticsKey);
        }
    }
})();

angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/account/account-footer.view.html','<footer class="footer"><div class="footer__top"><div class="container"><div class="row"><div class="col-md-10 col-md-push-1"><div class="row"><div class="col-xs-6 col-sm-3 footer-menu"><ul class="footer-menu__list"><li class="footer-menu__item"><a ui-sref="{{PATH.HOME}}">Home</a></li><li class="footer-menu__item"><a href="https://bid.vogtauction.com/">Auctions</a></li><li class="footer-menu__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Buying</a></li><li class="footer-menu__item"><a ui-sref="page-detail({pageSlug: \'selling\'})">Selling</a></li></ul></div><div class="col-xs-6 col-sm-3 footer-list"><h4>Ways to bid</h4><ul class="footer-list__list"><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Bid in person</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Leave a written bid</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Bid by telephone</a></li></ul></div><div class="footer-list__clearfix"></div><div class="col-xs-6 col-sm-3 footer-list"><h4>Services</h4><ul class="footer-list__list"><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'valuations\'})">Valuations</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'estate-sales\'})">Estate Sales</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'charity-auctions\'})">Charity Auctions</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'delivery\'})">Delivery</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'resources\'})">Resources</a></li></ul></div><div class="col-xs-6 col-sm-3 footer-list"><h4>Company</h4><ul class="footer-list__list"><li class="footer-list__item"><a ui-sref="about">About Us</a></li><li class="footer-list__item"><a ui-sref="directions">Directions</a></li><li class="footer-list__item"><a ng-click="vm.onContactClick()" role="button">Contact Us</a></li><li class="footer-list__item"><a ng-click="vm.onSubscribeClick()" role="button">Newsletter</a></li></ul></div></div></div></div></div></div><div class="footer__bottom"><div class="container"><div class="row footer__row"><div class="col-xs-12 col-md-6 footer-subscribe"><h2 class="footer-subscribe__title">Vogt Auction Newsletter</h2><p class="footer-subscribe__desc">Sign-up for updates and new auction announcements!</p><form class="form-inline footer-subscribe__form" name="subscribeForm" novalidate="" role="form"><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(subscribeForm.subscriberName)}"><input class="form-control footer-subscribe__input" id="subscriberName" name="subscriberName" ng-model="vm.subscriber.name" placeholder="First and Last Name" required="" tabindex="101" type="text"> <span class="help-block" ng-show="showError(subscribeForm.subscriberName, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(subscribeForm.subscriberEmail)}"><input class="form-control footer-subscribe__input" id="subscriberEmail" name="subscriberEmail" ng-model="vm.subscriber.email" placeholder="Email Address" required="" tabindex="102" type="email"> <span class="help-block" ng-show="showError(subscribeForm.subscriberEmail, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(subscribeForm.subscriberEmail, \'email\')">Please enter a valid email</span></div><div class="form-action"><button class="btn btn-black btn-lg btn-upper footer-subscribe__btn" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubscribeSubmit()" ng-disabled="!canSave(subscribeForm) || isDataLoading" type="submit">Submit</button></div></form></div><div class="col-xs-12 col-md-6 footer-info"><div class="footer-info__texas"><img class="img-responsive" ng-src="/assets/images/texas.svg"></div><div class="footer-info__clearfix"></div><div class="footer-info__location"><h6>Vogt Auction Galleries<br>The Great Texas Auction House</h6><div class="footer-info__address">Monday-Friday 10am-6pm<br>7233 Blanco Road<br>San Antonio, TX 78216<br><strong>(210) 822-6155</strong></div></div></div></div><hr class="footer__hr"><div class="row"><div class="col-sm-6 col-md-4 footer-social"><a class="footer-social__item" href="https://www.facebook.com/VogtAuction" target="_blank"><i class="fab fa-facebook fa-fw"></i></a> <a class="footer-social__item" href="https://twitter.com/VogtAuction" target="_blank"><i class="fab fa-twitter fa-fw"></i></a> <a class="footer-social__item" href="https://www.instagram.com/vogtauction" target="_blank"><i class="fab fa-instagram fa-fw"></i></a> <a class="footer-social__item" href="https://www.youtube.com/channel/UCAhNx9whIPGd57KCe4lcXVQ" target="_blank"><i class="fab fa-youtube fa-fw"></i></a> <a class="footer-social__item" href="https://www.pinterest.com/VogtAuction" target="_blank"><i class="fab fa-pinterest fa-fw"></i></a></div><div class="col-sm-6 col-md-8 footer__copy">\xA9 2026 Vogt Enterprises Inc. <span class="footer__ndash"></span> Texas Licenses #7825 #15958 #18265</div></div></div></div></footer>');
$templateCache.put('app/account/account-header.view.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button class="navbar-toggle" ng-class="{\'active\': vm.asideMobile}" ng-click="vm.onToggleClick()" type="button"><span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" ui-sref="{{PATH.HOME}}"><img class="img-responsive-height" ng-src="/assets/images/logo-tx.png"></a></div><div class="collapse navbar-collapse"><div class="nav-user navbar-right"><a class="btn btn-link btn-sm" ng-if="!vm.isAuthenticated()" href="https://bid.vogtauction.com/user/login"><span>Log In</span></a> <span class="nav-user__separ" ng-if="!vm.isAuthenticated()">or</span> <a class="btn btn-primary btn-sm" ng-if="!vm.isAuthenticated()" href="https://bid.vogtauction.com/user/register">Sign Up</a><div class="dropdown nav-user__dropdown" ng-if="vm.isAuthenticated()"><div aria-haspopup="true" aria-expanded="false" bs-dropdown="" data-placement="bottom-right" class="userarea"><a class="btn btn-link btn-sm" role="button"><span ng-bind="currentUser.name.first + \' \' + currentUser.name.last"></span> <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ui-sref-active="active"><a ui-sref="{{PATH.SETTINGS}}">Settings</a></li><li role="separator" class="divider"></li><li><a ng-click="vm.onLogoutClick()" role="button">Log Out</a></li></ul><div class="bidoption"><a ui-sref="{{PATH.BID}}">My Bids</a></div></div></div><ul class="nav navbar-nav navbar-right nav-menu"><li ui-sref-active="active"><a ui-sref="auction"><span>Auctions</span></a></li><li class="dropdown"><div aria-haspopup="true" aria-expanded="false" bs-dropdown=""><a role="button"><span>Services</span> <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'valuations\'})">Valuations</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'estate-sales\'})">Estate Sales</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'charity-auctions\'})">Charity Auctions</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'delivery\'})">Delivery</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'resources\'})">Resources</a></li></ul></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'buying\'})"><span>Buying</span></a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'selling\'})"><span>Selling</span></a></li></ul></div></div></nav>');
$templateCache.put('app/account/account-subheader.view.html','<nav class="navbar navbar-inverse navbar-subheader" role="navigation"><div class="container"><ul class="nav navbar-nav nav-submenu"><li class="dropdown" ng-repeat="category in categories track by $index" ui-sref-active="active"><div aria-haspopup="true" aria-expanded="false" bs-dropdown=""><a role="button" ui-sref="category-detail({categorySlug: category.meta.slug})"><span>{{category.name}}</span> <i class="fa fa-fw fa-angle-down" ng-show="category.children && category.children.length > 0"></i></a></div><ul class="dropdown-menu" ng-show="category.children && category.children.length > 0" role="menu"><li ng-repeat="subcategory in category.children track by $index" ui-sref-active="active"><a ui-sref="category-detail({categorySlug: subcategory.meta.slug})">{{subcategory.name}}</a></li></ul></li></ul></div></nav>');
$templateCache.put('app/account/account.view.html','<ui-view></ui-view>');
$templateCache.put('app/auth/auth.view.html','<div class="container"><div class="row"><div class="col-xs-12"><div class="panel auth-panel"><div class="panel-brand"><a ui-sref="{{PATH.HOME}}"><img class="img-responsive" ng-src="/assets/images/logo-tx.png"></a></div><div class="panel-body"><ui-view></ui-view></div></div></div></div></div>');
$templateCache.put('app/main/main-404.view.html','<div class="notfound"><div class="container"><div class="row"><div class="col-sm-10 col-sm-push-1 col-md-8 col-md-push-2 col-lg-6 col-lg-push-3"><h1>Page Not Found</h1><h3 class="notfound__subtitle">Vogt Auction recently updated their website and you may be using an old link. Click below to go to the new web experience.</h3><div class="notfound__helper"><a class="btn btn-link btn-lg notfound__btn" ui-sref="{{PATH.HOME}}">Go to new homepage</a></div><img class="img-responsive" style="width: 30%;" ng-src="/assets/images/logo.svg"></div></div></div></div>');
$templateCache.put('app/main/main.view.html','<ui-view name="header"></ui-view><ui-view name="subheader"></ui-view><ui-view class="site-content" name="content"></ui-view><ui-view name="footer"></ui-view>');
$templateCache.put('app/public/public-contact.modal.html','<div class="modal modal-form" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button class="close" ng-click="vm.onHideClick()" type="button"><i class="material-icons">clear</i></button><h2 class="modal-title">Send Us A Message</h2></div><form name="contactForm" novalidate="" role="form"><div class="modal-body"><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(contactForm.name)}"><input autofocus="" class="form-control input-material" id="name" name="name" ng-model="vm.message.name" placeholder="First and Last Name" required="" tabindex="1" type="text"> <span class="help-block" ng-show="showError(contactForm.name, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(contactForm.email)}"><input class="form-control input-material" id="email" name="email" ng-model="vm.message.email" placeholder="Email Address" required="" tabindex="2" type="email"> <span class="help-block" ng-show="showError(contactForm.email, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(contactForm.email, \'email\')">Please enter a valid email</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(contactForm.message)}"><textarea class="form-control input-material" id="message" name="message" ng-model="vm.message.message" placeholder="Message" required="" rows="5" tabindex="3"></textarea> <span class="help-block" ng-show="showError(contactForm.message, \'required\')">This field is required</span></div></div><div class="modal-footer"><button class="btn btn-primary btn-lg btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onContactSubmit()" ng-disabled="!canSave(contactForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Send</span></button></div></form></div></div></div>');
$templateCache.put('app/public/public-footer.view.html','<footer class="footer"><div class="footer__top"><div class="container"><div class="row"><div class="col-md-10 col-md-push-1"><div class="row"><div class="col-xs-6 col-sm-3 footer-menu"><ul class="footer-menu__list"><li class="footer-menu__item"><a ui-sref="{{PATH.HOME}}">Home</a></li><li class="footer-menu__item"><a href="https://bid.vogtauction.com/">Auctions</a></li><li class="footer-menu__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Buying</a></li><li class="footer-menu__item"><a ui-sref="page-detail({pageSlug: \'selling\'})">Selling</a></li></ul></div><div class="col-xs-6 col-sm-3 footer-list"><h4>Ways to bid</h4><ul class="footer-list__list"><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Bid in person</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Leave a written bid</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'buying\'})">Bid by telephone</a></li></ul></div><div class="footer-list__clearfix"></div><div class="col-xs-6 col-sm-3 footer-list"><h4>Services</h4><ul class="footer-list__list"><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'valuations\'})">Valuations</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'estate-sales\'})">Estate Sales</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'charity-auctions\'})">Charity Auctions</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'delivery\'})">Delivery</a></li><li class="footer-list__item"><a ui-sref="page-detail({pageSlug: \'resources\'})">Resources</a></li></ul></div><div class="col-xs-6 col-sm-3 footer-list"><h4>Company</h4><ul class="footer-list__list"><li class="footer-list__item"><a ui-sref="about">About Us</a></li><li class="footer-list__item"><a ui-sref="directions">Directions</a></li><li class="footer-list__item"><a ng-click="vm.onContactClick()" role="button">Contact Us</a></li><li class="footer-list__item"><a ng-click="vm.onSubscribeClick()" role="button">Newsletter</a></li></ul></div></div></div></div></div></div><div class="footer__bottom"><div class="container"><div class="row footer__row"><div class="col-xs-12 col-md-6 footer-subscribe"><h2 class="footer-subscribe__title">Vogt Auction Newsletter</h2><p class="footer-subscribe__desc">Sign-up for updates and new auction announcements!</p><form class="form-inline footer-subscribe__form" name="subscribeForm" novalidate="" role="form"><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(subscribeForm.subscriberName)}"><input class="form-control footer-subscribe__input" id="subscriberName" name="subscriberName" ng-model="vm.subscriber.name" placeholder="First and Last Name" required="" tabindex="101" type="text"> <span class="help-block" ng-show="showError(subscribeForm.subscriberName, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(subscribeForm.subscriberEmail)}"><input class="form-control footer-subscribe__input" id="subscriberEmail" name="subscriberEmail" ng-model="vm.subscriber.email" placeholder="Email Address" required="" tabindex="102" type="email"> <span class="help-block" ng-show="showError(subscribeForm.subscriberEmail, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(subscribeForm.subscriberEmail, \'email\')">Please enter a valid email</span></div><div class="form-action"><button class="btn btn-black btn-lg btn-upper footer-subscribe__btn" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubscribeSubmit()" ng-disabled="!canSave(subscribeForm) || isDataLoading" type="submit">Submit</button></div></form></div><div class="col-xs-12 col-md-6 footer-info"><div class="footer-info__texas"><img class="img-responsive" ng-src="/assets/images/texas.svg"></div><div class="footer-info__clearfix"></div><div class="footer-info__location"><h6>Vogt Auction Galleries<br>The Great Texas Auction House</h6><div class="footer-info__address">Monday-Friday 10am-6pm<br>7233 Blanco Road<br>San Antonio, TX 78216<br><strong>(210) 822-6155</strong></div></div></div></div><hr class="footer__hr"><div class="row"><div class="col-sm-6 col-md-4 footer-social"><a class="footer-social__item" href="https://www.facebook.com/VogtAuction" target="_blank"><i class="fab fa-facebook fa-fw"></i></a> <a class="footer-social__item" href="https://twitter.com/VogtAuction" target="_blank"><i class="fab fa-twitter fa-fw"></i></a> <a class="footer-social__item" href="https://www.instagram.com/vogtauction" target="_blank"><i class="fab fa-instagram fa-fw"></i></a> <a class="footer-social__item" href="https://www.youtube.com/channel/UCAhNx9whIPGd57KCe4lcXVQ" target="_blank"><i class="fab fa-youtube fa-fw"></i></a> <a class="footer-social__item" href="https://www.pinterest.com/VogtAuction" target="_blank"><i class="fab fa-pinterest fa-fw"></i></a></div><div class="col-sm-6 col-md-8 footer__copy">\xA9 2026 Vogt Enterprises Inc. <span class="footer__ndash"></span> Texas Licenses #7825 #15958 #18265</div></div></div></div></footer>');
$templateCache.put('app/public/public-header.view.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button class="navbar-toggle" ng-class="{\'active\': vm.asideMobile}" ng-click="vm.onToggleClick()" type="button"><span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" ui-sref="{{PATH.HOME}}"><img class="img-responsive-height" ng-src="/assets/images/logo-aniversary.png"></a></div><div class="collapse navbar-collapse"><div class="nav-user navbar-right"><a class="btn btn-link btn-sm" ng-if="!vm.isAuthenticated()" href="https://bid.vogtauction.com/user/login"><span>Log In</span></a> <span class="nav-user__separ" ng-if="!vm.isAuthenticated()">or</span> <a class="btn btn-primary btn-sm" ng-if="!vm.isAuthenticated()" href="https://bid.vogtauction.com/user/register">Sign Up</a><div class="dropdown nav-user__dropdown" ng-if="vm.isAuthenticated()"><div aria-haspopup="true" aria-expanded="false" bs-dropdown="" data-placement="bottom-right" class="userarea"><a class="btn btn-link btn-sm" role="button"><span ng-bind="currentUser.name.first + \' \' + currentUser.name.last"></span> <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ui-sref-active="active"><a ui-sref="{{PATH.SETTINGS}}">Settings</a></li><li role="separator" class="divider"></li><li><a ng-click="vm.onLogoutClick()" role="button">Log Out</a></li></ul><div class="bidoption"><a ui-sref="{{PATH.BID}}">My Bids</a></div></div></div><ul class="nav navbar-nav navbar-right nav-menu"><li><a href="https://bid.vogtauction.com/"><span>Auctions</span></a></li><li class="dropdown"><div aria-haspopup="true" aria-expanded="false" bs-dropdown=""><a role="button"><span>Services</span> <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'valuations\'})">Valuations</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'estate-sales\'})">Estate Sales</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'charity-auctions\'})">Charity Auctions</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'delivery\'})">Delivery</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'resources\'})">Resources</a></li></ul></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'buying\'})"><span>Buying</span></a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'selling\'})"><span>Selling</span></a></li></ul></div></div></nav>');
$templateCache.put('app/public/public-sidebar.view.html','<div class="aside admin view notabs" role="dialog"><div class="aside-dialog"><div class="aside-content"><button class="close" ng-click="$hide()" type="button"><i class="material-icons">clear</i></button><div class="aside-body"><div class="navbar-default"><div class="nav-user"><a class="btn btn-default btn-sm btn-block" ng-if="!vm.isAuthenticated()" href="https://bid.vogtauction.com/user/login"><span>Log In</span></a> <a class="btn btn-primary btn-sm btn-block" ng-if="!vm.isAuthenticated()" href="https://bid.vogtauction.com/user/register">Sign Up</a><div class="dropdown nav-user__dropdown" ng-if="vm.isAuthenticated()"><div aria-haspopup="true" aria-expanded="false" bs-dropdown="" data-placement="bottom-right"><a class="btn btn-link" role="button">{{currentUser.name.first}} {{currentUser.name.last}} <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ui-sref-active="active"><a ui-sref="{{PATH.BID}}">My Bids</a></li><li ui-sref-active="active"><a ui-sref="{{PATH.SETTINGS}}">Settings</a></li><li role="separator" class="divider"></li><li><a ng-click="vm.onLogoutClick()" role="button">Log Out</a></li></ul></div></div><hr><ul class="nav navbar-nav nav-menu"><li ui-sref-active="active"><a href="https://bid.vogtauction.com/">Auctions</a></li><li class="dropdown"><div aria-haspopup="true" aria-expanded="false" bs-dropdown=""><a role="button">Services <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'valuations\'})">Valuations</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'estate-sales\'})">Estate Sales</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'charity-auctions\'})">Charity Auctions</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'delivery\'})">Delivery</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'resources\'})">Resources</a></li></ul></li><li class="dropdown"><div aria-haspopup="true" aria-expanded="false" bs-dropdown=""><a role="button">What we sell <i class="fa fa-fw fa-angle-down"></i></a></div><ul class="dropdown-menu" role="menu"><li ng-repeat="category in categories track by $index" ui-sref-active="active"><a ui-sref="category-detail({categorySlug: category.meta.slug})">{{category.name}}</a></li></ul></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'buying\'})">Buying</a></li><li ui-sref-active="active"><a ui-sref="page-detail({pageSlug: \'selling\'})">Selling</a></li></ul><hr><ul class="nav navbar-nav nav-submenu"><li ui-sref-active="active"><a ui-sref="about">About Us</a></li><li ui-sref-active="active"><a ui-sref="directions">Directions</a></li><li><br></li><li class="social"><a href="https://www.facebook.com/VogtAuction" target="_blank"><i class="fab fa-facebook"></i></a></li><li class="social"><a href="https://www.instagram.com/vogtauction" target="_blank"><i class="fab fa-instagram"></i></a></li><li class="social"><a href="https://twitter.com/VogtAuction" target="_blank"><i class="fab fa-twitter"></i></a></li><li class="social"><a href="https://www.youtube.com/user/VogtAuction" target="_blank"><i class="fab fa-youtube"></i></a></li><li class="social"><a href="https://www.pinterest.com/VogtAuction" target="_blank"><i class="fab fa-pinterest"></i></a></li></ul></div></div><div class="aside-footer"><div class="ordernow"><i class="fa fa-phone fa-flip-horizontal fa-fw ordernow__icon"></i> (210) 822-6155</div></div></div></div></div>');
$templateCache.put('app/public/public-subheader.view.html','<nav class="navbar navbar-inverse navbar-subheader" role="navigation"><div class="container"><ul class="nav navbar-nav nav-submenu"><li class="dropdown" ng-repeat="category in categories track by $index" ui-sref-active="active"><div aria-haspopup="true" aria-expanded="false" bs-dropdown=""><a role="button" ui-sref="category-detail({categorySlug: category.meta.slug})"><span>{{category.name}}</span> <i class="fa fa-fw fa-angle-down" ng-show="category.children && category.children.length > 0"></i></a></div><ul class="dropdown-menu" ng-show="category.children && category.children.length > 0" role="menu"><li ng-repeat="subcategory in category.children track by $index" ui-sref-active="active"><a ui-sref="category-detail({categorySlug: subcategory.meta.slug})">{{subcategory.name}}</a></li></ul></li></ul></div></nav>');
$templateCache.put('app/public/public-subscribe.modal.html','<div class="modal modal-form" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button class="close" ng-click="vm.onHideClick()" type="button"><i class="material-icons">clear</i></button><h2 class="modal-title">Get Auction Updates</h2></div><form name="subscribeForm" novalidate="" role="form"><div class="modal-body"><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(subscribeForm.name)}"><input autofocus="" class="form-control input-material" id="name" name="name" ng-model="vm.subscriber.name" placeholder="First and Last Name" required="" tabindex="1" type="text"> <span class="help-block" ng-show="showError(subscribeForm.name, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(subscribeForm.email)}"><input class="form-control input-material" id="email" name="email" ng-model="vm.subscriber.email" placeholder="Email Address" required="" tabindex="2" type="email"> <span class="help-block" ng-show="showError(subscribeForm.email, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(subscribeForm.email, \'email\')">Please enter a valid email</span></div></div><div class="modal-footer"><button class="btn btn-primary btn-lg btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubscribeSubmit()" ng-disabled="!canSave(subscribeForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Subscribe</span></button></div></form></div></div></div>');
$templateCache.put('app/public/public.view.html','<ui-view></ui-view>');
$templateCache.put('app/account/bid/bid.view.html','<div class="page-header"><h2 class="page-header__title">My Bids</h2></div><div class="page-content"><div class="container"><div class="row item-list bids" ng-if="vm.bids.length > 0 && !isDataLoading"><div class="col-md-10 col-md-push-1"><div class="row"><div class="col-sm-6" ng-repeat="bid in vm.bids" ng-if="!bid.auction.isPast && bid.auction.state.indexOf(\'published\') > -1"><div class="item-list__item"><a class="item-list__img item-list__img-link" ng-click="vm.onImageClick(bid)"><img ng-src="{{bid.item.imageUrl | cdn}}"><div class="item-list__banner" ng-if="!bid.phoneBid">My bid: &nbsp;<b>${{bid.bidamount || 0}}</b></div><div class="item-list__banner" ng-if="bid.phoneBid">My bid: &nbsp;<b>PHONE BID</b></div></a><h5 class="item-list__name">LOT #{{bid.lot}}: {{bid.item.title}}</h5><div class="button-bar"><a class="btn btn-primary btn-w-sm btn-upper" ng-click="vm.onEdit(bid.auction.meta.slug, bid.items.meta.slug)">Edit Bid</a> <a class="btn btn-danger btn-w-sm btn-upper" ng-click="vm.onCancel(bid._id, bid.item.id)" ng-disabled="isDataLoading" type="button">Cancel Bid</a></div></div></div></div></div></div><div class="row item-list past" ng-if="vm.bids.length > 0 && !isDataLoading"><div class="col-md-10 col-md-push-1"><div aria-multiselectable="true" bs-collapse="" ng-model="vm.activePanel" role="tablist"><div class="auction-past__panel"><a bs-collapse-toggle="" class="btn btn-transparent btn-icon btn-sm auction-past__btn" role="button"><i class="fa" ng-class="{ \'fa-minus\': vm.activePanel === 0, \'fa-plus\': vm.activePanel !== 0 }"></i></a><h5 class="auction-past__title">Past Auction Bids</h5></div><div bs-collapse-target="" role="tabpanel"><div class="row"><div class="col-sm-6" ng-repeat="bid in vm.bids" ng-if="bid.auction.isPast && bid.auction.state.indexOf(\'published\') > -1"><div class="item-list__item"><a class="item-list__img item-list__img-link" ng-click="vm.onImageClick(bid)"><img ng-src="{{bid.item.imageUrl | cdn}}"><div class="item-list__banner">My Past Bid: &nbsp;<b>${{bid.bidamount || 0}}</b></div></a><h5 class="item-list__name">LOT #{{bid.lot}}: {{bid.item.title}}</h5><div class="photobid__note" ng-if="bid.auction.isPast">Auction Has Ended.<br>Call <strong>(210) 822-6155</strong> for sales results.</div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div><div class="row blank-list" ng-if="vm.bids.length < 1 && !isDataLoading"><div class="col-xs-12"><i class="fa fa-gavel blank-list__icon"></i><h4 class="blank-list__title">You didn\'t have any bids yet.</h4><button class="btn btn-primary" type="button" ui-sref="auction">Browse Auctions</button></div></div></div></div>');
$templateCache.put('app/account/settings/settings.view.html','<div class="page-header"><h2 class="page-header__title">Settings</h2><div class="row"><div class="col-md-4 col-md-offset-4"><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div></div></div></div><div class="page-content"><div class="container"><form name="settingsForm" novalidate="" role="form"><div class="row"><div class="col-md-4 col-md-offset-2"><div class="form-group form-group-lg"><input class="form-control" id="email" name="email" ng-model="vm.user.email" type="text" disabled=""></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.firstname)}"><input class="form-control" id="firstname" name="firstname" ng-model="vm.account.name.first" placeholder="First Name" required="" type="text"> <span class="help-block" ng-show="showError(settingsForm.firstname, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.lastname)}"><input class="form-control" id="lastname" name="lastname" ng-model="vm.account.name.last" placeholder="Last Name" required="" type="text"> <span class="help-block" ng-show="showError(settingsForm.lastname, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.username)}"><input class="form-control" id="username" name="username" ng-model="vm.user.username" placeholder="Username" required="" type="text" ng-pattern="/^[a-zA-Z0-9_]+$/" ui-validate="{notValid: \'vm.isUsernameValid($value) || !$value\'}" ui-validate-async="{notUnique: \'vm.isUsernameUnique($value, vm.orginalUsername)\'}"> <span class="help-block" ng-show="showError(settingsForm.username, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(settingsForm.username, \'pattern\')">Username must only contain alpha-numeric and underscore characters</span> <span class="help-block" ng-show="showError(settingsForm.username, \'notValid\')">Username should not contain a space.</span> <span class="help-block" ng-show="showError(settingsForm.username, \'notUnique\')">That username is already in use</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.password)}"><input autocomplete="new-password" class="form-control" id="password" name="password" ng-minlength="6" ng-model="vm.password" placeholder="New Password" type="password"> <span class="help-block" ng-show="showError(settingsForm.password, \'minlength\')">The password needs to be at least 6 characters</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.confirmPassword)}"><input class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.confirmPassword" placeholder="Confirm Password" type="password" ui-validate-async="{notMatch: \'vm.isPasswordConfirmed($value, vm.password)\'}"> <span class="help-block" ng-show="showError(settingsForm.confirmPassword, \'notMatch\')">Password and confirmation do not match</span></div></div><div class="col-md-4"><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.phone)}"><input class="form-control" id="phone" name="phone" ng-maxlength="17" ng-model="vm.account.phone" placeholder="Phone Number" required="" type="tel" ui-us-phone-number=""> <span class="help-block" ng-show="showError(settingsForm.phone, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.address1)}"><input class="form-control" id="address1" name="address1" ng-model="vm.account.address1" type="text" placeholder="Address 1" required=""> <span class="help-block" ng-show="showError(settingsForm.address1, \'required\')">This field is required</span></div><div class="form-group form-group-lg" ng-class="{\'has-error\': hasError(settingsForm.address2)}"><input class="form-control" id="address2" name="address2" ng-model="vm.account.address2" placeholder="Address 2" type="text"> <span class="help-block" ng-show="showError(settingsForm.address2, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(settingsForm.city), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="city" name="city" ng-model="vm.account.city" placeholder="City" type="text" required=""> <span class="help-block" ng-show="showError(settingsForm.city, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(settingsForm.state), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="state" name="state" ng-model="vm.account.state" placeholder="State" type="text" required=""> <span class="help-block" ng-show="showError(settingsForm.state, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(settingsForm.zipcode), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="zipcode" name="zipcode" ng-model="vm.account.zipcode" placeholder="Zip Code" type="text" required=""> <span class="help-block" ng-show="showError(settingsForm.zipcode, \'required\')">This field is required</span></div></div></div><div class="row"><div class="col-md-4 col-md-offset-4"><div class="form-action"><button class="btn btn-primary btn-lg btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubmit()" ng-disabled="!canSave(settingsForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Save</span></button></div><br></div></div></form></div></div>');
$templateCache.put('app/auth/login/login.view.html','<form name="loginForm" novalidate="" role="form"><h5 ng-class="{\'auth-panel__title\': !vm.isModal}">Log In</h5><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group" ng-class="{\'has-error\': hasError(loginForm.username), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="username" name="username" ng-model="vm.user.username" placeholder="Username or Email Address" required="" type="text"> <span class="help-block" ng-show="showError(loginForm.username, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(loginForm.password), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="password" name="password" ng-model="vm.user.password" placeholder="Password" required="" type="password"> <span class="help-block" ng-show="showError(loginForm.password, \'required\')">This field is required</span></div><div class="form-action"><button class="btn btn-primary btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading, \'btn-lg\': !vm.isModal}" ng-click="vm.onSubmit()" ng-disabled="!canSave(loginForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Log In</span></button> <a class="btn btn-link btn-sm btn-block" role="button" ui-sref="forgotpw">Forgot your password?</a><div ng-if="!vm.isModal"><div class="auth-panel__separator"><span>or</span></div><a class="btn btn-default btn-block" role="button" href="https://bid.vogtauction.com/user/register">Need an account?</a></div></div></form>');
$templateCache.put('app/auth/signup/signup.view.html','<form role="form" name="signupForm" novalidate=""><div ng-if="!vm.secondStep"><h5 ng-class="{\'auth-panel__title\': !vm.isModal}">Step 1: Create Account</h5><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.email), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="email" name="email" ng-model="vm.user.email" placeholder="Email Address" required="" type="email" ui-validate="{notEmail: \'vm.isEmail($value) || !$value\'}" ui-validate-async="{notUnique: \'vm.isEmailUnique($value)\'}"> <span class="help-block" ng-show="showError(signupForm.email, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(signupForm.email, \'notEmail\')">Please enter a valid email</span> <span class="help-block" ng-show="showError(signupForm.email, \'notUnique\')">That email is already in use</span></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.username), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="username" name="username" ng-model="vm.user.username" placeholder="Username" required="" type="text" ng-pattern="/^[a-zA-Z0-9_]+$/" ui-validate="{notValid: \'vm.isUsernameValid($value) || !$value\'}" ui-validate-async="{notUnique: \'vm.isUsernameUnique($value)\'}"> <span class="help-block" ng-show="showError(signupForm.username, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(signupForm.username, \'pattern\')">Username must only contain alpha-numeric and underscore characters</span> <span class="help-block" ng-show="showError(signupForm.username, \'notValid\')">Username should not contain a space.</span> <span class="help-block" ng-show="showError(signupForm.username, \'notUnique\')">That username is already in use</span></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.password), \'form-group-lg\': !vm.isModal}"><input autocomplete="new-password" class="form-control" id="password" name="password" ng-minlength="6" ng-model="vm.user.password" placeholder="Password" required="" type="password"> <span class="help-block" ng-show="showError(signupForm.password, \'required\')">Please input your password</span> <span class="help-block" ng-show="showError(signupForm.password, \'minlength\')">The password needs to be at least 6 characters</span></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.confirmPassword), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.user.confirmPassword" placeholder="Confirm Password" required="" type="password" ui-validate-async="{notMatch: \'vm.isPasswordConfirmed($value, vm.user.password)\'}"> <span class="help-block" ng-show="showError(signupForm.confirmPassword, \'required\')">Please confirm your password</span> <span class="help-block" ng-show="showError(signupForm.confirmPassword, \'notMatch\')">Password and confirmation do not match</span></div><div class="form-action"><button class="btn btn-primary btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading, \'btn-lg\': !vm.isModal}" ng-click="vm.onNext()" ng-disabled="!canSave(signupForm) || isDataLoading" type="submit"><span class="btn-loading__text" style="position: relative; top: -1px">Next</span> <i class="fa fa-angle-right"></i></button></div></div><div ng-if="vm.secondStep"><h5 ng-class="{\'auth-panel__title\': !vm.isModal}">Step 2: Complete Profile</h5><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.name), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="name" name="name" ng-model="vm.user.name" placeholder="First and Last Name" required="" type="text"> <span class="help-block" ng-show="showError(signupForm.name, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.phone), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="phone" name="phone" ng-maxlength="20" ng-model="vm.user.phone" placeholder="Phone Number" required="" type="text" ui-us-phone-number=""> <span class="help-block" ng-show="showError(signupForm.phone, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.address1), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="address1" name="address1" ng-model="vm.user.address1" placeholder="Address 1" required="" type="text"> <span class="help-block" ng-show="showError(signupForm.address1, \'required\')">This field is required</span></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.address2), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="address2" name="address2" ng-model="vm.user.address2" placeholder="Address 2 (Optional)" type="text"></div><div class="row"><div class="col-sm-6 form-group" ng-class="{\'has-error\': hasError(signupForm.city), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="city" name="city" ng-model="vm.user.city" placeholder="City" required="" type="text"> <span class="help-block" ng-show="showError(signupForm.city, \'required\')">This field is required</span></div><div class="col-sm-6 form-group" ng-class="{\'has-error\': hasError(signupForm.state), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="state" name="state" ng-model="vm.user.state" placeholder="State" required="" type="text"> <span class="help-block" ng-show="showError(signupForm.state, \'required\')">This field is required</span></div></div><div class="form-group" ng-class="{\'has-error\': hasError(signupForm.zipcode), \'form-group-lg\': !vm.isModal}"><input class="form-control" id="zipcode" name="zipcode" ng-model="vm.user.zipcode" placeholder="Zip Code" required="" type="text"><span class="help-block" ng-show="showError(signupForm.zipcode, \'required\')">This field is required</span></div><div class="row"><div class="col-sm-6"><div class="form-action"><button class="btn btn-upper btn-block btn-social" ng-class="{\'btn-lg\': !vm.isModal}" ng-click="vm.onBack()"><span class="btn-loading__text">Back</span></button></div></div><div class="col-sm-6"><div class="form-action"><button class="btn btn-primary btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading, \'btn-lg\': !vm.isModal}" ng-click="vm.onSubmit()" ng-disabled="!canSave(signupForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Sign Up</span></button></div></div></div></div><div ng-if="!vm.isModal"><div class="auth-panel__separator"><span>or</span></div><a class="btn btn-default btn-block" role="button" href="https://bid.vogtauction.com/user/login">Log In</a></div></form>');
$templateCache.put('app/public/about/about.view.html','<div class="page-header"><h2 class="page-header__title">About Us</h2></div><div class="page-content"><div class="container"><div class="row" ng-if="!isDataLoading"><div class="col-md-10 col-md-push-1 col-lg-8 col-lg-push-2"><div ng-bind-html="vm.page.body"></div></div></div><div class="row person-list" ng-if="!isDataLoading"><div class="col-md-10 col-md-push-1 col-lg-8 col-lg-push-2"><h2>The Team</h2><div class="row"><div class="col-sm-6" ng-repeat="person in vm.persons | orderBy:\'weight\'" ng-class="{clear: $even}"><a class="person-list__item" role="button" ui-sref="person({personSlug: person.slug, person: person})"><div class="person-list__img cssco cssco--x1"><img ng-src="{{person.imageUrl | cdn}}"></div><h5 class="person-list__name" ng-bind="person.name"></h5><div class="person-list__position" ng-bind="person.title"></div><div><span class="person-list__link">Read Bio</span></div></a></div></div></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/public/assets/assets.view.html','<div class="asset-hero" ng-show="vm.asset.headerUrl"><img class="asset-hero__img" ng-src="{{vm.asset.headerUrl}}"></div><div class="asset-content"><div class="container"><div class="row" ng-if="!isDataLoading"><div class="col-md-10 col-md-push-1 col-lg-8 col-lg-push-2"><div ng-if="vm.isDoc" ng-bind-html="vm.html" class="docx"></div><iframe ng-if="vm.isPdf" width="800" height="800" src="{{vm.asset.assetUrl | trustUrl}}"></iframe><video width="800" ng-if="!vm.isPdf && !vm.isDoc" src="{{vm.asset.assetUrl}}" controls=""></video></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/public/auction/auction.view.html','<div class="page-hero"><img class="page-hero__img page-hero__img-auction" ng-src="/assets/images/hero-paddle.jpg"></div><div class="page-header"><h2 class="page-header__title">Auctions</h2></div><div class="page-content"><div class="container"><div class="row auction-next detail" ng-if="vm.auctionNext.length > 0 && !isDataLoading"><div class="col-md-12"><h2 class="auction-next__title">Upcoming Auctions</h2><a class="auction-next__item" ng-repeat="auction in vm.auctionNext | orderBy:\'startDate\'" ng-if="auction.state.indexOf(\'published\') > -1" title="{{auction.title}}" ui-sref="auction-detail({auctionSlug: auction.meta.slug})"><img class="auction-next__img" ng-src="{{ auction.eventImageUrl | cdn}}"><h3 class="auction-next__name" ng-bind="auction.title"></h3><div class="auction-next__date" ng-repeat="date in auction.startDates" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div><div class="auction-next__date" ng-if="auction.startDates.length === 0">Auction date TBD</div><div class="auction-next__category">Category: <span class="category" ng-repeat="category in auction.categories track by $index">{{category.name}}<span ng-if="!$last">,</span>&nbsp;</span></div><span ui-sref="auction-detail({auctionSlug: auction.meta.slug, limit: 0})" style="display:none;"></span></a><h2 class="auction-next__title"><a ui-sref="page-detail({pageSlug: \'upcoming-auctions-in-san-antonio-vogt-auction\'})">View all upcoming auctions</a></h2></div></div><div class="row" ng-if="vm.auctionNext.length === 0 && !isDataLoading"><div class="col-md-12"><h2 class="auction-next__title">Next Auction Coming Soon!</h2></div></div><div class="auction-past" ng-if="vm.auctionPast.length > 0 && !isDataLoading"><div class="col-md-12"><div aria-multiselectable="true" bs-collapse="" ng-model="vm.activePanel" role="tablist"><div class="auction-past__panel"><a bs-collapse-toggle="" class="btn btn-transparent btn-icon btn-sm auction-past__btn" role="button"><i class="fa" ng-class="{ \'fa-minus\': vm.activePanel === 0, \'fa-plus\': vm.activePanel !== 0 }"></i></a><h5 class="auction-past__title">Past Auctions</h5></div><div bs-collapse-target="" role="tabpanel"><div class="table-responsive"><table class="table table-hover table-auction"><tbody><tr ng-repeat="auction in vm.auctionPast | orderBy:\'-startDate\'" ng-if="auction.state.indexOf(\'published\') > -1" title="{{auction.title}}" ui-sref="auction-detail({auctionSlug: auction.meta.slug})"><td><div class="auction-past__img"><img ng-src="{{auction.eventImageUrl | cdn}}"></div></td><td><a ui-sref="auction-detail({auctionSlug: auction.meta.slug, limit: 0})" style="display:none;"></a><h3 class="auction-past__name" ng-bind="auction.title"></h3><div class="auction-past__date" ng-repeat="date in auction.startDates" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div><div class="auction-past__category">Category: <span class="category" ng-repeat="category in auction.categories track by $index">{{category.name}}<span ng-if="!$last">,</span>&nbsp;</span></div></td></tr></tbody></table></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/public/blog/blog.view.html','<div class="page-hero"><img class="page-hero__img" ng-src="{{vm.posts[0].image | cdn}}"><div class="opacity-layer"></div><div class="container"><div class="page-header"><h1 class="page-header__title">{{vm.posts[0].title}}</h1><div class="btn-row"><button type="button" class="btn btn-blog small" ui-sref="blog.detail({id: vm.posts[0].id})">READ NOW</button></div></div></div></div><div class="blogposts section"><div class="container"><div class="row"><div ui-sref="blog.detail({id: post.id})" ng-repeat="post in vm.posts"><div class="col-sm-6 col-md-4"><div class="post"><div class="image"><img ng-src="{{post.image | cdn}}"></div><div class="post-inner"><div class="categories"><span class="category" ng-repeat="cat in post.categories track by $index">{{cat.name}}<span ng-if="!$last">,</span>&nbsp;</span></div><div class="title">{{post.title}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/public/category/category.view.html','<div class="page-header"><h2 class="page-header__title" ng-bind="vm.specialty.title"></h2></div><div class="page-content"><div class="container"><div class="row specialties" ng-if="!isDataLoading"><div class="col-md-10 col-md-push-1"><div class="col-sm-12 custom-block" ng-if="vm.specialty.custom.image"><div style="display: flex; flex-direction: {{vm.specialty.custom.arrangement ? \'row\' : \'column\'}}"><div class="custom-image" ng-class="{\'col-sm-6\': vm.specialty.custom.arrangement}"><img ng-src="{{vm.specialty.custom.image}}"></div><div class="custom-text" ng-class="{\'col-sm-6\': vm.specialty.custom.arrangement, \'custom-text--justify\': vm.specialty.custom.arrangement == \'left\'}" style="order: {{vm.specialty.custom.arrangement == \'left\' ? \'-1\' : \'0\'}}">{{vm.specialty.custom.text}}</div></div></div><div class="specialties__auctions"><a target="{{event.mainImageLink ? \'_blank\' : \'\'}}" ng-href="{{event.event.eventImageLink || \'/auctions/\' + event.event.meta.slug}}" class="specialties__img auction-next__item" ng-repeat="event in vm.specialty.events" style="flex-basis: {{$first && vm.specialty.events.length % 2 == 1 ? \'100\' : \'49\'}}%;"><img ng-src="{{event.event.eventImageUrl}}" class="auction-next__img"><h3 class="auction-next__name" ng-bind="event.event.title"></h3><div ng-if="event.event.startDates" class="auction-next__date"><div ng-repeat="date in event.event.startDates">{{date | date:\'EEE, MMM d, y @ h:mma\'}}</div></div><div class="auction-next__category">Category: <span class="category" ng-repeat="category in event.event.categories track by $index">{{category.name}}<span ng-if="!$last">,</span>&nbsp;</span></div><h3 class="auction-next__textsub" ng-if="event.eventText" ng-bind="event.eventText"></h3></a></div><div class="col-md-12 specialties__personblock" ng-repeat="block in vm.specialty.personBlocks"><div class="col-xs-3 specialties__person-info"><img class="img-responsive" ng-src="{{ block.person.profileImage }}"><div class="specialties__person"><h5 class="specialties__name">{{ block.person.name }}</h5><div class="specialties__title">{{ block.person.title }}</div><div class="specialties__email"><a href="mailto:{{ block.person.email }}">{{ block.person.email }}</a></div><div ng-bind="block.person.phone | phonenumberFilter"></div></div></div><div class="col-xs-9 specialties__person-info"><div ng-bind-html="block.text2"></div></div><div class="clearfix"></div></div><div class="col-md-10 col-md-push-1 specialties__textblock"><div ng-bind-html="vm.specialty.text1"></div></div><div class="col-md-10 col-md-push-1 specialties__featured row"><div class="col-sm-6" ng-repeat="item in vm.specialty.featuredItems | orderBy:\'weight\'" title="{{item.title}}" ng-class="{clear: $even}"><div class="item-list__item"><a class="item-list__img"><img ng-src="{{ item.url }}"></a><h5 class="item-list__name">{{ item.title }}</h5><div class="item-list__note text-primary">{{ item.description }}</div></div></div></div><div class="col-md-10 col-md-push-1 auction-next past specialty" ng-if="vm.auctionPast.length > 0 && !isDataLoading"><h2 class="auction-next__title">Past {{ vm.category.name }} Auctions</h2><div class="specialties__past-auctions"><a class="auction-next__item specialties__past-auctions-item" ng-repeat="auction in vm.auctionPast | orderBy:\'-startDate\'" ng-if="auction.state.indexOf(\'published\') > -1" title="{{auction.title}}" ui-sref="auction-detail({auctionSlug: auction.meta.slug})"><div class="img-box"><img class="auction-next__img" ng-src="{{ auction.eventImageUrl | cdn}}"></div><h4 class="auction-next__name" ng-bind="auction.title"></h4><div class="auction-next__date" ng-repeat="date in auction.startDates" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div></a></div></div></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/public/home/home.view.html','<div class="page-content"><div class="container"><div class="row auction-next" ng-if="!isDataLoading"><div class="col-md-12"><div class="news"><span class="col-xs-2 tag">News</span> <span class="col-xs-9 message">We have a new website! You can now PRE-BID on everything right here on the site.<p>Questions? Call or text us anytime at 210-865-8648, or email <a href="mailto:rob@vogtauction.com">rob@vogtauction.com</a>.</p></span><div class="clearfix"></div></div><div class="row"><div ng-class="{ \'col-sm-12\': $first, \'col-sm-6\': !$first }" ng-repeat="highlight in vm.highlights | orderBy: \'index\'"><a ng-href="{{highlight.url}}?limit=0" style="display:none;"></a> <a class="auction-next__item" ng-href="{{highlight.imageLink || highlight.url}}" title="{{highlight.title}}"><img ng-if="highlight.type !== HIGHLIGHT_TYPE.VIDEO" class="auction-next__img" ng-src="{{ highlight.imageUrl | cdn }}"><div class="auction-next__vid" ng-if="highlight.type === HIGHLIGHT_TYPE.VIDEO"><youtube-video video-url="highlight.video"></youtube-video></div><h3 class="auction-next__name" ng-bind="highlight.title"></h3><div class="auction-next__date" ng-repeat="date in highlight.dates" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div><div class="auction-next__date" ng-if="highlight.type === \'Auction\' && highlight.dates && highlight.dates.length === 0">Auction date TBD</div><div class="auction-next__category" ng-if="highlight.type != HIGHLIGHT_TYPE.VIDEO && highlight.categories.length > 0">Category: <span class="category" ng-repeat="category in highlight.categories track by $index">{{category.name}}<span ng-if="!$last">,</span>&nbsp;</span></div><div class="auction-next__category" ng-if="highlight.type === HIGHLIGHT_TYPE.VIDEO"><br></div><div ng-if="!highlight.date" class="auction-next__date"></div></a></div></div></div></div><div class="auction-past" ng-if="vm.auctionPast.length > 0 && !isDataLoading"><div class="col-md-12"><div aria-multiselectable="true" bs-collapse="" ng-model="vm.activePanel" role="tablist"><div class="auction-past__panel"><a bs-collapse-toggle="" class="btn btn-transparent btn-icon btn-sm auction-past__btn" role="button"><i class="fa" ng-class="{ \'fa-minus\': vm.activePanel === 0, \'fa-plus\': vm.activePanel !== 0 }"></i></a><h5 class="auction-past__title">Past Auctions</h5></div><div bs-collapse-target="" role="tabpanel"><div class="table-responsive"><table class="table table-hover table-auction"><tbody><tr ng-repeat="auction in vm.auctionPast | orderBy:\'-startDate\' | limitTo:5" title="{{auction.title}}" ui-sref="auction-detail({auctionSlug: auction.meta.slug})"><td><div class="auction-past__img"><img ng-src="{{auction.eventImageUrl | cdn}}"></div></td><td><a ui-sref="auction-detail({auctionSlug: auction.meta.slug, limit: 0})" style="display:none;"></a><h3 class="auction-past__name" ng-bind="auction.title"></h3><div class="auction-past__date" ng-repeat="date in auction.startDates" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div><div class="auction-past__category">Category: <span class="category" ng-repeat="category in auction.categories track by $index">{{category.name}}<span ng-if="!$last">,</span>&nbsp;</span></div></td></tr></tbody></table></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/public/pages/pages.view.html','<div class="page-hero" ng-show="vm.page.headerUrl"><img class="page-hero__img" ng-src="{{ vm.page.headerUrl}}"></div><div class="page-header"><h2 class="page-header__title" ng-bind="vm.page.title"></h2></div><div class="page-content"><div class="container"><div class="row" ng-if="!isDataLoading"><div class="col-md-10 col-md-push-1 col-lg-8 col-lg-push-2"><div ng-bind-html="vm.page.body"></div></div></div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/account/bid/bid-photos/bid-photos.modal.html','<div class="modal modal-photo" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button class="close" ng-click="$hide()" type="button"><i class="material-icons">clear</i></button><h5 class="modal-title">LOT #{{vm.bid.lot}}: {{vm.bid.item.title}}</h5></div><div class="modal-body photo" ng-show="!isDataLoading"><div class="photo__wrap"><ul class="photo-list" rn-carousel="" rn-carousel-buffered="" rn-carousel-controls="" rn-carousel-index="vm.photoIndex" rn-carousel-duration="600"><li class="photo-list__item" ng-if="photo" ng-repeat="photo in vm.bid.item.featuredImagesUrls track by $index"><img class="photo-list__img" ng-src="{{photo}}"></li><span class="photo-list__imgs" ng-if="vm.bid.item.featuredImagesUrls.length === 0"><i class="fa fa-images photo-list__icon"></i></span></ul><div class="photo-indicators" ng-if="vm.bid.item.featuredImagesUrls.length > 0" rn-carousel-indicators="" rn-carousel-index="vm.photoIndex"></div></div></div><div class="modal-body photo" ng-show="isDataLoading"><div class="spinner spinner-content"></div></div></div></div></div>');
$templateCache.put('app/auth/login/forgot/login-forgot.view.html','<form name="loginForgotForm" novalidate="" role="form"><h5 ng-class="{\'auth-panel__title\': !vm.isModal}">Forgot Your Password?</h5><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group form-group-lg" ng-if="!vm.success" ng-class="{\'has-error\': hasError(loginForgotForm.email)}"><input class="form-control" id="email" name="email" ng-model="vm.email" placeholder="Enter Your Email" required="" type="email" ui-validate="{notEmail: \'vm.isEmail($value) || !$value\'}"> <span class="help-block" ng-show="showError(loginForgotForm.email, \'required\')">This field is required</span> <span class="help-block" ng-show="showError(loginForgotForm.email, \'notEmail\')">Please enter a valid email</span></div><div class="form-action" ng-if="!vm.success"><button class="btn btn-primary btn-lg btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubmit()" ng-disabled="!canSave(loginForgotForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Reset Password</span></button></div><a class="btn btn-link btn-sm btn-block" role="button" href="https://bid.vogtauction.com/user/login">Go to Log In</a></form>');
$templateCache.put('app/auth/login/reset/login-reset.view.html','<form name="resetForm" novalidate="" role="form"><h5 ng-class="{\'auth-panel__title\': !vm.isModal}">Create Password</h5><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><div class="form-group form-group-lg" ng-if="!vm.success && vm.valid" ng-class="{\'has-error\': hasError(resetForm.password)}"><input autocomplete="new-password" class="form-control" id="password" name="password" ng-minlength="6" ng-model="vm.password" placeholder="New Password" required="" type="password"> <span class="help-block" ng-show="showError(resetForm.password, \'required\')">Please input your password</span> <span class="help-block" ng-show="showError(resetForm.password, \'minlength\')">The password needs to be at least 6 characters</span></div><div class="form-group form-group-lg" ng-if="!vm.success && vm.valid" ng-class="{\'has-error\': hasError(resetForm.confirmPassword)}"><input class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.confirmPassword" placeholder="Confirm New Password" type="password" required="" ui-validate-async="{notMatch: \'vm.isPasswordConfirmed($value, vm.password)\'}"> <span class="help-block" ng-show="showError(resetForm.confirmPassword, \'required\')">Please confirm your password</span> <span class="help-block" ng-show="showError(resetForm.confirmPassword, \'notMatch\')">Password and confirmation do not match</span></div><div class="form-action" ng-if="!vm.success && vm.valid"><button class="btn btn-primary btn-lg btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubmit()" ng-disabled="!canSave(resetForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Set Password</span></button> <a class="btn btn-link btn-sm btn-block" role="button" href="https://bid.vogtauction.com/user/login">Back to Login</a></div><div class="form-action" ng-if="vm.success && vm.valid"><a class="btn btn-primary btn-lg btn-upper btn-block" href="https://bid.vogtauction.com/user/login">Go to Log In</a></div></form>');
$templateCache.put('app/public/about/team/team.modal.html','<div class="modal modal-team" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button class="close" ng-click="$hide()" type="button"><i class="material-icons">clear</i></button></div><div class="modal-body person"><div class="row"><div class="col-sm-6"><div class="person__img"><img ng-src="{{vm.person.imageUrl | cdn}}"></div></div><div class="col-sm-6"><h1 class="person__name" ng-bind="vm.person.name"></h1><div class="person__position" ng-bind="vm.person.title"></div><div class="person__email"><a href="mailto:{{vm.person.email}}">{{vm.person.email}}</a></div><div class="person__phone" ng-bind="vm.person.phone"></div><div class="person__bio" ng-bind-html="vm.person.bio"></div></div></div><div class="row"><div class="col-xs-12"><div ng-if="vm.person.publications"><h3>Publications</h3><div class="person__publications" ng-bind-html="vm.person.publications"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/public/auction/auction-detail/auction-detail.view.html','<div class="page-content"><div class="container"><div class="auction" ng-if="vm.auction"><div class="col-md-12"><h2 class="auction__title"><span class="text-danger" ng-if="vm.auction.isPast">Past Auction:</span> {{vm.auction.title}}</h2><div class="col-md-12 auction__dates"><div class="col-sm-5 row"><div class="auction__previewtext">Auction</div><div class="auction__date" ng-repeat="date in vm.auction.startDates" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div><div class="auction__date" ng-if="vm.auction.startDates.length === 0">Auction date TBD</div></div><div class="col-sm-5 row" ng-if="vm.auction.previewDates.length"><div class="auction__previewtext">Gallery Previews</div><div ng-repeat="range in vm.auction.previewDates"><div class="auction__date">{{range.start | date:\'EEE, MMM d, h:mma\'}} \u2014 {{range.stop | date:\'h:mma\'}}</div></div></div><div class="clearfix"></div></div><div class="auction__img"><a target="_blank" ng-href="{{vm.auction.eventImageLink}}"><img ng-src="{{vm.auction.eventImageUrl | cdn}}"></a></div><div class="auction__body" ng-bind-html="vm.auction.body"></div><div class="gallery"><div ng-class="{\'col-md-12\': vm.auction.featuredImagesUrls.length === 1, \'col-md-4\': vm.auction.featuredImagesUrls.length === 3, \'col-lg-3 col-md-4 col-xs-6 item-grid\': vm.auction.featuredImagesUrls.length > 3}" ng-repeat="image in vm.auction.featuredImagesUrls"><a class="gallery-list__item" href="{{image}}" data-fancybox="gallery" data-caption="{{$index+1}}/{{vm.auction.featuredImagesUrls.length}}"><img ng-src="{{image | cdn}}" class="center-block" ng-class="{\'gallery-image--height\': vm.auction.featuredImagesUrls.length > 1}"></a></div></div></div><div class="clearfix"></div></div><div class="search-block" ng-if="(vm.items.length > 0 || vm.searching)"><input ng-model="vm.search" placeholder="Search for Items" class="input-sm form-control align-middle" type="search" ng-model-options="{updateOn: \'default blur\', debounce: {\'default\': 700, \'blur\': 0}}"><div class="backtoauction" ng-click="vm.clearSearch()" ng-if="(vm.search && vm.searching && !isDataLoading)"><span class="text">Back to Auction</span></div></div><div class="item-list" ng-if="vm.items.length > 0"><div class="col-md-12" infinite-scroll="vm.getAuctionItems()" infinite-scroll-disabled="isDataLoading" infinite-scroll-distance="0"><div class="row"><div class="col-lg-3 col-md-4 col-xs-6 item-grid" ng-repeat="item in vm.items"><a class="item-list__item" ng-disabled="!item.meta.slug" ui-sref="auction-item({itemSlug: item.meta.slug})"><div class="item-list__img"><img ng-src="{{item.itemImageUrl | cdn}}"></div><h5 class="item-list__name">LOT #{{item.lot}}: {{item.title}}</h5><div class="item-list__note" ng-if="!vm.auction.isPast && !vm.auction.isLive"><span ng-if="((item.lowEstimate || item.highEstimate) && !item.isSold)">Estimate:</span> <span ng-if="(item.lowEstimate && !item.isSold)">{{item.lowEstimate | currency:"$":0}}</span> <span ng-if="((item.lowEstimate && item.highEstimate) && !item.isSold)">&ndash;</span> <span ng-if="(item.highEstimate && !item.isSold)">{{item.highEstimate | currency:"$":0}}</span> <span ng-if="((!item.lowEstimate && !item.highEstimate) && !item.isSold)">&nbsp;</span> <span ng-if="item.isSold" class="item-sold">SOLD</span></div><div class="live" ng-if="vm.auction.isLive"><div class="item-closed" bs-tooltip="" data-title="Online Bidding closes 1 hour before auction start" role="button">Please click here to bid live online at LiveAuctioneers.com.</div></div><div class="item-list__note" ng-if="vm.auction.isPast && !item.soldPrice">Auction Has Ended.<br>Call <strong>(210) 822-6155</strong> for sales results.</div><div class="item-list__note" ng-if="vm.auction.isPast && item.soldPrice">Sold price: <b><span ng-if="item.soldPrice!=0">{{item.soldPrice | currency:"$":0}}</span> <span ng-if="item.soldPrice==0">Lot passed</span></b><br ng-if="item.soldPrice!=0">(incl. buyer\u2019s premium)</div></a></div></div></div></div><div class="item-list noresult" ng-if="(vm.items.length == 0 && vm.searching && !isDataLoading)">No Items Found.</div><div class="row"><div class="col-xs-12"><div class="spinner spinner-content" ng-show="isDataLoading"></div></div></div></div></div>');
$templateCache.put('app/public/home/directions/directions.view.html','<div class="page-hero"><img class="page-hero__img" ng-src="/assets/images/hero-directions.jpg"></div><div class="page-header"><h2 class="page-header__title">Directions to Vogt auction</h2></div><div class="directions page-content"><div class="container"><div class="row"><div class="col-md-10 col-md-push-1 col-lg-8 col-lg-push-2"><h1>We\'ll show you the way!</h1><div class="block"><p><strong>Vogt Auction Galleries is located at:</strong><br>7233 Blanco Road in San Antonio, Texas</p><p>Hours: Monday-Friday 10am-6pm<br>Phone: (210) 822-6155<br>Fax: (210) 821-5821<br></p></div><br><div class="block"><ng-map center="[29.524490, -98.505584]" zoom="13"><custom-marker id="foo" position="[29.524490, -98.505584]"><img class="custom-marker" ng-src="/assets/images/icon-marker.png"><div class="place">Vogt Auction</div></custom-marker></ng-map><a style="margin-top: 5px;display:block;" href="https://www.google.com/maps/place/Vogt+Auction+Galleries/@29.52449,-98.5061312,19z/data=!4m13!1m7!3m6!1s0x0:0x0!2zMjnCsDMxJzI4LjIiTiA5OMKwMzAnMjAuMSJX!3b1!8m2!3d29.52449!4d-98.505584!3m4!1s0x0:0x766c91f4fd747580!8m2!3d29.5244235!4d-98.5055865?hl=en-US" target="_blank">Click here to get directions from Google Maps</a></div><br><br><div class="block directions"><h2>WRITTEN DIRECTIONS</h2><p><strong>Coming from the north (Austin, New Braunfels, Dallas)</strong> Take I-35 south towards San Antonio. Exit onto Loop I-410 West (Exit #166). Continue for 7 miles, then exit at Blanco (Exit #20A). Turn right onto Blanco, drive 0.3 miles up Blanco heading north - we\'re on the left at 7233 Blanco Rd.</p><p><strong>Coming from the Hill Country on I- 10 (Fredericksburg, Kerrville, Comfort, Boerne)</strong> Take I - 10 east towards San Antonio. Exit onto Loop 410 East (Exit #564). Continue for 4 miles, then exit at Blanco (Exit #20A). Turn left onto Blanco, drive 0.3 miles up Blanco heading north - we\'re on the left at 7233 Blanco Rd.</p><p><strong>Coming from the Hill Country on 281 (Marble Falls, Johnson City, Blanco)</strong> Take US-281 south towards San Antonio. Exit onto Loop 410 West (near San Antonio Intl. Airport). Continue down Loop 410 1.5 miles, then exit at Blanco (Exit #20A). Turn left and drive 0.3 miles up Blanco heading north - we\'re on the left at 7233 Blanco Rd.</p><p><strong>Coming from the east (Houston)</strong> Take I-10 west towards San Antonio. Exit onto Loop I-410 North (Exit #581). Continue on 410 for 13 miles, then exit at Blanco (Exit #20A). Turn left onto Blanco, drive 0.3 miles up Blanco heading north \xE2\u20AC\u201C we\'re on the left at 7233 Blanco Rd.</p><p><strong>Coming from the south (Corpus Christi, Rio Grande Valley, Laredo)</strong> From Corpus Christi or the Valley, take I-37 north towards San Antonio. From Laredo, take I-35 north towards San Antonio. Laredo drivers exit onto I-37/281 North at exit #158 (near downtown San Antonio). Continue north on I-37/281 for 5 miles, exiting onto Loop I-410 West (near San Antonio Intl. Airport). Continue down Loop 410 1.5 miles, then exit at Blanco (Exit #20A). Turn left and drive 0.3 miles up Blanco heading north - we\'re on the left at 7233 Blanco Rd.</p></div></div></div></div></div>');
$templateCache.put('app/public/auction/auction-detail/item/bid-authenticated.view.html','<form name="vm.bidForm" novalidate="" role="form"><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><span class="bidOnline" ng-if="!vm.bid.phoneBid"><div class="form-group" ng-class="{\'has-error\': hasError(vm.bidForm.bidamount)}"><label for="bidamount">Your maximum bid:</label> <input class="form-control" id="bidamount" ng-maxlength="20" name="bidamount" ng-model="vm.bid.bidamount" placeholder="$ Bid" required="" type="text" ui-money-mask="0" min="vm.item.startPrice || 1"><div ng-if="vm.item.startPrice" class="bid__startprice"><span class="bid__text">Starting Bid:</span> <span class="bid__price">{{vm.item.startPrice | currency:"$":0}}</span></div><span class="help-block" ng-show="showError(vm.bidForm.bidamount, \'required\')">This field is required</span></div><span ng-if="!vm.isEdit"><button class="btn btn-primary btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubmitBid()" ng-disabled="!canSave(vm.bidForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Place Bid</span></button></span> <span ng-if="vm.isEdit"><button class="btn btn-primary btn-upper btn-block" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onEdit()" ng-disabled="!canSave(vm.bidForm) || isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Update</span></button> <button class="btn btn-link btn-sm btn-upper btn-block" ng-click="vm.onCancel()" ng-disabled="isDataLoading" type="button">Cancel Online Bid</button></span><div class="bid__descr">We will email you after the auction with your results. Questions? Call us at 210-822-6155.</div></span> <span class="bidByPhone" ng-if="vm.bid.phoneBid"><div class="form-group" ng-class="{\'has-error\': hasError(vm.bidFormByPhone.byphone)}"><label for="byphone">You\'ve chosen to bid by phone...</label> <span ng-if="vm.isEditByPhone" class="bid__descr"><p>If you\'d like to place a maximum bid online, you must first cancel your phone request using the link below.</p><button class="btn btn-link btn-sm btn-upper btn-block" ng-click="vm.onCancelByPhone()" ng-disabled="isDataLoading" type="button">Cancel Phone Request</button></span></div></span><div aria-multiselectable="true" bs-collapse="" class="notice" ng-model="vm.activePanel" role="tablist"><a bs-collapse-toggle="" class="notice__link" role="button">More info. <i class="fa fa-angle-right"></i></a><div bs-collapse-target="" class="list-style1 notice__list" role="tabpanel" ng-bind-html="vm.auction.details"></div></div></form>');
$templateCache.put('app/public/auction/auction-detail/item/bid-unauthenticated.view.html','<div class="form-group"><label for="forshow">Your maximum bid:</label> <input disabled="" class="form-control" id="forshow" ng-maxlength="20" name="forshow" placeholder="$ Bid" required="" type="text"><div ng-if="vm.item.startPrice" class="bid__startprice"><span class="bid__text">Starting Bid:</span> <span class="bid__price">{{vm.item.startPrice | currency:"$":0}}</span></div></div><button class="btn btn-primary btn-upper btn-block" ng-click="vm.onSignupClick()" type="button">Sign Up to bid</button> <button class="btn btn-link btn-sm btn-block" ng-click="vm.onLoginClick()" type="button">Log In</button><div class="bid__descr">Click the button above to sign up or log in and pre-bid online!</div>');
$templateCache.put('app/public/auction/auction-detail/item/call-authenticated.view.html','<form name="vm.bidFormByPhone" novalidate="" role="form"><div class="flash-message" ng-if="flash"><div class="alert alert-{{flash.type}}" ng-bind="flash.message"></div></div><span class="bidByPhone" ng-if="!vm.bid.bidamount"><div class="form-group" ng-class="{\'has-error\': hasError(vm.bidFormByPhone.byphone)}"><label for="byphone">Bid live by phone:</label> <span ng-if="!vm.isEditByPhone"><button class="btn btn-primary btn-upper btn-block call-btn" ng-class="{\'btn-loading\': isDataLoading}" ng-click="vm.onSubmitBidByPhone()" ng-disabled="isDataLoading" type="submit"><span class="spinner btn-loading__icon"></span> <span class="btn-loading__text">Call me on this lot</span></button><div class="bid__descr"><span ng-if="vm.item.startPrice">(Minimum $100 bid please.)</span> (Minimum $100 bid please.) We will call you during the auction when this lot comes up for bid.<br><br>Your phone number is <strong>{{ currentUser.phone | phonenumberFilter }}</strong>.<br><a ui-sref="settings">Change my phone number.</a></div></span> <span ng-if="vm.isEditByPhone" class="bid__descr"><p>You\'ve requested for us to call you by phone on this lot during the auction. We\'ll call you at the following number: <strong>{{vm.bid.phone}}</strong></p><button class="btn btn-link btn-sm btn-upper btn-block" ng-click="vm.onCancelByPhone()" ng-disabled="isDataLoading" type="button">Cancel Phone Request</button></span></div></span> <span class="bidOnline" ng-if="vm.bid.bidamount"><div class="form-group" ng-class="{\'has-error\': hasError(vm.bidFormByPhone.byphone)}"><label for="byphone">You\'ve chosen to bid online...</label> <span ng-if="vm.isEditByPhone" class="bid__descr"><p>If you\'d rather have us call you during the auction, you must first cancel your online bid using the link below.</p><button class="btn btn-link btn-sm btn-upper btn-block" ng-click="vm.onCancel()" ng-disabled="isDataLoading" type="button">Cancel Online Bid</button></span></div></span><div aria-multiselectable="true" bs-collapse="" class="notice" ng-model="vm.activePanel" role="tablist"><a bs-collapse-toggle="" class="notice__link" role="button">More info. <i class="fa fa-angle-right"></i></a><div bs-collapse-target="" class="list-style1 notice__list" role="tabpanel" ng-bind-html="vm.auction.details"></div></div></form>');
$templateCache.put('app/public/auction/auction-detail/item/call-unauthenticated.view.html','<div class="form-group"><label for="forshow">Want to bid live by phone?</label></div><button class="btn btn-primary btn-upper btn-block" ng-click="vm.onSignupClick()" type="button">Sign Up to Bid</button> <button class="btn btn-link btn-sm btn-block" ng-click="vm.onLoginClick()" type="button">Log In</button><div class="bid__descr">Click the button above to sign up or log in to receive a phone call on this lot!</div>');
$templateCache.put('app/public/auction/auction-detail/item/item.modal.html','<div class="modal modal-photo" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button class="close" ng-click="$hide()" type="button"><i class="material-icons">clear</i></button><h5 class="modal-title" ng-if="vm.item.title">LOT #{{vm.item.lot}}: {{vm.item.title}}</h5></div><div class="modal-body photo"><div class="photo__note" ng-if="!vm.item.isPast && !vm.auction.isLive"><span ng-if="vm.item.lowEstimate || vm.item.highEstimate">Estimate:</span> <span ng-if="vm.item.lowEstimate">{{vm.item.lowEstimate | currency:"$":0}}</span> <span ng-if="vm.item.lowEstimate && vm.item.highEstimate">&ndash;</span> <span ng-if="vm.item.highEstimate">{{vm.item.highEstimate | currency:"$":0}}</span></div><div class="photo__note" ng-if="vm.item.isPast && !vm.item.soldPrice">Auction Has Ended.<br>Call <strong>(210) 822-6155</strong> for sales results.</div><div class="row"><div class="col-md-7 photo"><div class="photo__wrap"><div class="photo-thumbs"><div class="photo-thumbs__item" ng-repeat="photo in vm.item.featuredImagesUrls track by $index" ng-click="$parent.slideIndex=$index" ng-class="{\'is-active\': ($parent.slideIndex==$index)}"><img class="photo-thumbs__img" ng-src="{{photo.xs}}"></div></div><ul class="photo-list" rn-carousel="" rn-carousel-buffered="" rn-carousel-index="slideIndex" rn-carousel-duration="100"><li class="photo-list__item" ng-if="photo" ng-repeat="photo in vm.item.featuredImagesUrls"><img class="photo-list__img" ng-src="{{photo.md}}"></li></ul></div><div class="photo__descr" ng-bind="vm.item.description"></div></div><div class="spinner spinner-content" ng-show="vm.item.isBiddable === \'\'"></div><div class="col-md-5 bid" ng-if="vm.item.isSold && vm.auction.isPast == false && vm.auction.isLive == false"><div class="bid-sold">This item has been sold.</div></div><div class="col-md-5 bid" ng-if="[null, false].includes(vm.item.isBiddable) && !vm.item.isSold && vm.auction.isPast == false"><div class="bid-notbiddable">This item is not up for bid.</div></div><div class="col-md-5 bid" ng-if="vm.auction.isPast && vm.auction.isLive == false && !vm.item.soldPrice"><div class="bid-past">Auction Has Ended.<br>Call <strong>(210) 822-6155</strong> for sales results.</div></div><div class="col-md-5 bid" ng-if="vm.auction.isPast && vm.auction.isLive == false && vm.item.soldPrice"><div class="bid-sold">Sold price: <span ng-if="vm.item.soldPrice!=0">{{vm.item.soldPrice | currency:"$":0}}</span> <span ng-if="vm.item.soldPrice==0">Lot passed</span><br ng-if="vm.item.soldPrice!=0">(incl. buyer\u2019s premium)</div></div><div class="col-md-5 bid" ng-if="vm.item.isBiddable && !vm.item.isSold && vm.auction.isPast == false && vm.auction.isLive == false"><bs-tabs><bs-pane data-title="Bid online"><div class="bid__form"><span ng-if="!vm.isAuthenticated() && (vm.isLogin || vm.isSignup)"><button class="close close-sm" ng-click="vm.onBackClick()" type="button"><i class="material-icons">clear</i></button></span><ng-include src="\'app/public/auction/auction-detail/item/bid-authenticated.view.html\'" ng-if="vm.isAuthenticated()"></ng-include><ng-include src="\'app/public/auction/auction-detail/item/bid-unauthenticated.view.html\'" ng-if="!vm.isAuthenticated() && !vm.isSignup && !vm.isLogin"></ng-include><ng-include src="\'app/auth/signup/signup.view.html\'" ng-controller="SignupController as vm" ng-if="!vm.isAuthenticated() && vm.isSignup"></ng-include><ng-include src="\'app/auth/login/login.view.html\'" ng-controller="LoginController as vm" ng-if="!vm.isAuthenticated() && vm.isLogin"></ng-include></div></bs-pane><bs-pane data-title="By phone"><div class="bid__form byphone"><span ng-if="!vm.isAuthenticated() && (vm.isLogin || vm.isSignup)"><button class="close close-sm" ng-click="vm.onBackClick()" type="button"><i class="material-icons">clear</i></button></span><ng-include src="\'app/public/auction/auction-detail/item/call-authenticated.view.html\'" ng-if="vm.isAuthenticated()"></ng-include><ng-include src="\'app/public/auction/auction-detail/item/call-unauthenticated.view.html\'" ng-if="!vm.isAuthenticated() && !vm.isSignup && !vm.isLogin"></ng-include><ng-include src="\'app/auth/signup/signup.view.html\'" ng-controller="SignupController as vm" ng-if="!vm.isAuthenticated() && vm.isSignup"></ng-include><ng-include src="\'app/auth/login/login.view.html\'" ng-controller="LoginController as vm" ng-if="!vm.isAuthenticated() && vm.isLogin"></ng-include></div></bs-pane><bs-pane data-title="In person"><div class="bid__inperson"><div>Come bid in person \u2013 it\u2019s fun!<br><div class="auction__date__modal" ng-repeat="date in vm.auction.startDate" ng-bind="date | date:\'EEE, MMM d, y @ h:mma\'"></div><br>We\u2019re at 7233 Blanco Road in San Antonio:</div><div class="bid__map"><ng-map center="[29.524490, -98.505584]" zoom="13"><custom-marker id="foo" position="[29.524490, -98.505584]"><img class="custom-marker" ng-src="/assets/images/icon-marker.png"><div class="place">Vogt Auction</div></custom-marker></ng-map></div><a href="https://www.google.com/maps/place/Vogt+Auction+Galleries/@29.52449,-98.5061312,19z/data=!4m13!1m7!3m6!1s0x0:0x0!2zMjnCsDMxJzI4LjIiTiA5OMKwMzAnMjAuMSJX!3b1!8m2!3d29.52449!4d-98.505584!3m4!1s0x0:0x766c91f4fd747580!8m2!3d29.5244235!4d-98.5055865?hl=en-US" target="_blank">Click here for Google Maps</a></div></bs-pane><bs-pane data-title="Live online"><div class="bid-type_live" ng-if="vm.auction.live.liveauctioneersUrl || vm.auction.live.invaluableUrl"><div class="block"><strong>Check us out Live:</strong><div><a href="{{vm.auction.live.liveauctioneersUrl}}" ng-if="vm.auction.live.liveauctioneersUrl" target="_blank"><img class="" ng-src="/assets/images/logo-liveauctioneers.png"></a> <a href="{{vm.auction.live.invaluableUrl}}" ng-if="vm.auction.live.invaluableUrl" target="_blank"><img class="" ng-src="/assets/images/logo-invaluable.png"></a></div><br>(A 5% surcharge applies)</div></div><div class="bid__nolive" ng-if="!vm.auction.live.liveauctioneersUrl && !vm.auction.live.invalableUrl"><strong>No Live Events for this Auction.</strong></div></bs-pane></bs-tabs></div><div class="col-md-5 bid" ng-if="vm.auction.isLive"><div class="bid-sold bid-sold-live" ng-if="vm.auction.live.liveauctioneersUrl || vm.auction.live.invaluableUrl">Bid live online at <span ng-if="vm.auction.live.liveauctioneersUrl">LiveAuctioneers (<a href="{{vm.auction.live.liveauctioneersUrl}} target=" _blank"="">click here</a>)</span> <span ng-if="vm.auction.live.liveauctioneersUrl && vm.auction.live.invaluableUrl">and</span> <span ng-if="vm.auction.live.invaluableUrl">Invaluable (<a href="{{vm.auction.live.invaluableUrl}}">linked</a>)</span></div><div class="bid-sold" ng-if="!vm.auction.live.liveauctioneersUrl && !vm.auction.live.invaluableUrl">Pre-bidding here has closed.<br>To place a bid please call us at<br>210-822-6155.</div></div></div><div class="nextprevblock"><div class="col-md-6 pull-left"><a class="btn-prev-next" ng-if="vm.prevItem" ng-click="vm.onGoto(vm.prevItem)"><i class="fa fa-angle-left"></i> <span class="btn-prev-next__text">previous lot</span></a></div><div class="col-md-6 pull-right text-right"><a class="btn-prev-next" ng-if="vm.nextItem" ng-click="vm.onGoto(vm.nextItem)"><span class="btn-prev-next__text" "="">next lot</span><i class="fa fa-fw fa-angle-right"></i></a></div></div></div></div></div></div>');}]);